import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigNumber: { input: number; output: number; }
  DateTimeUtc: { input: string; output: string; }
  JSON: { input: any; output: any; }
  SimLosses: { input: any; output: any; }
  UnifiedKey: { input: string; output: string; }
  UxId: { input: string; output: string; }
};

/** Risk Assessments */
export type Assessment = {
  __typename?: 'Assessment';
  /** Base Risk modelled by the Scenarios */
  AssessmentBaseRisk: AssessmentRisk;
  /** Current Risk allowing for live controls */
  AssessmentLiveRisk: AssessmentRisk;
  /** Projected Risk after all controls applied */
  AssessmentProjectedRisk: AssessmentRisk;
  /** Actions for this assessment */
  actions: Array<Event>;
  /** Text describing the Assessment */
  description?: Maybe<Scalars['String']['output']>;
  /** Edited at date */
  editedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** A management summary for the assessment report */
  executiveSummary?: Maybe<Scalars['String']['output']>;
  /** Expected Loss for the Assessment */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
  /** Expected Loss for the Assessment */
  expectedLossLive?: Maybe<Scalars['Float']['output']>;
  /** Expected Loss for the Assessment */
  expectedLossProjected?: Maybe<Scalars['Float']['output']>;
  /** Assessment identifier */
  id: Scalars['UxId']['output'];
  /** Meta data for Assessment */
  meta?: Maybe<Meta>;
  /** A name identifying the Assessment */
  name: Scalars['String']['output'];
  /** When the Assessment is/was due for review */
  reviewDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Risk tolerance weightings */
  riskTolerance?: Maybe<Scalars['String']['output']>;
  /** The Scenarios for this Assessment */
  scenarios: Array<Scenario>;
  /** When the Assessment was started */
  startedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Reason assessment was transfered to new owner/workspace */
  transferJustification?: Maybe<Scalars['String']['output']>;
  /** Variables available for use in Scenario formulas */
  variables: Array<Variable>;
  /** Versions of this Assessment */
  versions: Array<Version>;
  /** Workspace where this assessment is accessible */
  workspace?: Maybe<Workspace>;
};


/** Risk Assessments */
export type AssessmentActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['UxId']['input']>;
  completionStatus?: InputMaybe<EventCompletionStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Risk Assessments */
export type AssessmentScenariosArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};

/** Base Risk modelled by the Scenarios */
export type AssessmentBaseRisk = {
  __typename?: 'AssessmentBaseRisk';
  /**
   * Calculated expected loss for all scenarios
   * @deprecated Use AssessmentRisk. AssessmentBaseRisk is deprecated and will be removed in a future release.
   */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
};

/** Risk Assessment input */
export type AssessmentInput = {
  /** Text describing the Assessment */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A management summary for the assessment report */
  executiveSummary?: InputMaybe<Scalars['String']['input']>;
  /** Assessment identifier */
  id?: InputMaybe<Scalars['UxId']['input']>;
  /** A name identifying the Assessment */
  name?: InputMaybe<Scalars['String']['input']>;
  /** When the Assessment is/was due for review */
  reviewDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  /** Risk tolerance weightings */
  riskTolerance?: InputMaybe<Scalars['String']['input']>;
  /** When the Assessment was started */
  startedDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
};

/** Current Risk allowing for live controls */
export type AssessmentLiveRisk = {
  __typename?: 'AssessmentLiveRisk';
  /**
   * Expected loss after live controls applied
   * @deprecated Use AssessmentRisk. AssessmentLiveRisk is deprecated and will be removed in a future release.
   */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
};

/** Projected Risk after all controls applied */
export type AssessmentProjectedRisk = {
  __typename?: 'AssessmentProjectedRisk';
  /**
   * Projected expected loss for all scenarios after all their controls are applied
   * @deprecated Use AssessmentRisk. AssessmentProjectedRisk is deprecated and will be removed in a future release.
   */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
};

/** A Risk modelled by the Assessment's Scenarios */
export type AssessmentRisk = {
  __typename?: 'AssessmentRisk';
  chart: Array<ChartCoordinate>;
  /** Calculated expected loss for all scenarios */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
};

/** Base Risk modelled by the Scenario */
export type BaseRisk = {
  __typename?: 'BaseRisk';
  /**
   * Calculated expected loss based on upper and lower estimates and frequency
   * @deprecated Use ScenarioRisk. BaseRisk is deprecated and will be removed in a future release.
   */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
  /** Number of times the risk is expected to occur */
  frequencyTimes?: Maybe<Scalars['Int']['output']>;
  /** Period of time for the frequency times */
  frequencyYears?: Maybe<Scalars['Int']['output']>;
  /** Lower estimate of the monetary cost of the event */
  lower?: Maybe<Scalars['BigNumber']['output']>;
  /** low values can affect the graph */
  lowerThanMinimum?: Maybe<Scalars['String']['output']>;
  /** loss simulation for graph */
  simLosses?: Maybe<Scalars['SimLosses']['output']>;
  /** Upper estimate of the monetary cost of the event */
  upper?: Maybe<Scalars['BigNumber']['output']>;
};

export enum BillingType {
  Channel = 'CHANNEL',
  Direct = 'DIRECT',
  NoBilling = 'NO_BILLING'
}

export enum BusinessType {
  Company = 'COMPANY',
  ConsultingPartner = 'CONSULTING_PARTNER',
  InsuranceBroker = 'INSURANCE_BROKER',
  InsuranceUnderwriter = 'INSURANCE_UNDERWRITER',
  Internal = 'INTERNAL',
  MspMssp = 'MSP_MSSP',
  PortfolioCompany = 'PORTFOLIO_COMPANY',
  PrivateEquity = 'PRIVATE_EQUITY'
}

/** A chart is a collection of x/y values to be plotted on a graph, such as a risk assessment curve */
export type ChartCoordinate = {
  __typename?: 'ChartCoordinate';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** Compatible Controls are controls from a different Framework which are considered equivalent. When a RMP control is associated (linked) to a Framework Control, it establishes a mechanism to assess compliance with the framework. By additionally linking compatible controls from other frameworks, it enables monitoring and reporting compliance across multiple frameworks through a single control association. */
export type CompatibleControl = {
  __typename?: 'CompatibleControl';
  /** Compatible Control */
  compatibleControl: FrameworkControl;
  /** Is this control already linked to a RMP Control - only populated when Framework control is accessed from an RMP control context. */
  isLinked: Scalars['Boolean']['output'];
};

export enum CompletionState {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  IncompleteEmptyVar = 'INCOMPLETE_EMPTY_VAR',
  PartiallyComplete = 'PARTIALLY_COMPLETE'
}

export type ComplianceControl = {
  __typename?: 'ComplianceControl';
  complianceStatus?: Maybe<ComplianceStatus>;
  compliantRmpControls: Array<Control>;
  frameworkControl: FrameworkControl;
};

export type ComplianceFramework = {
  __typename?: 'ComplianceFramework';
  complianceControls: Array<ComplianceControl>;
  controlFramework: ControlFramework;
  controlsCount: Scalars['Int']['output'];
  controlsImplementedCount: Scalars['Int']['output'];
  controlsPlannedCount: Scalars['Int']['output'];
  workspace: Workspace;
};

export type ContentImportSummary = {
  __typename?: 'ContentImportSummary';
  createdCount: Scalars['Int']['output'];
  frameworkId?: Maybe<Scalars['UxId']['output']>;
  groupId?: Maybe<Scalars['UxId']['output']>;
  metadataUpdated: Scalars['Boolean']['output'];
  unchangedCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

/** Controls for managing risk. */
export type Control = {
  __typename?: 'Control';
  /** Actions for this control */
  actions: Array<Event>;
  actualActiveDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  annualCost?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Maturity level of the control */
  existingMaturity?: Maybe<MaturityLevel>;
  expectedActiveDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /**
   * Control Framework is a library of published controls for managing risk
   * @deprecated Moving to [FrameworkControl!]! to support multiple framework controls
   */
  frameworkControl?: Maybe<FrameworkControl>;
  frameworkControls: Array<FrameworkControl>;
  id: Scalars['UxId']['output'];
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** Metadata for Control */
  meta?: Maybe<Meta>;
  modifiersCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Owner>;
  /** Control owner email */
  ownerEmail?: Maybe<Scalars['String']['output']>;
  /** Owner of the Control */
  ownerName?: Maybe<Scalars['String']['output']>;
  reviewDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Risk management plans link controls to risk scenarios with the option to add additional modifiers */
  riskManagementPlans: Array<RiskManagementPlan>;
  riskManagementPlansCount?: Maybe<Scalars['Int']['output']>;
  scenarios: Array<Scenario>;
  shortname?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  /** Maturity level of the control */
  targetMaturity?: Maybe<MaturityLevel>;
  updatedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
};


/** Controls for managing risk. */
export type ControlActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['UxId']['input']>;
  completionStatus?: InputMaybe<EventCompletionStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Input shape for applying filters to a controls query (when you wire the list).
 * Only UX IDs for related entities.
 */
export type ControlFilterInput = {
  frameworkUxIds?: InputMaybe<Array<Scalars['UxId']['input']>>;
  ownerUxIds?: InputMaybe<Array<Scalars['UxId']['input']>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  strategy?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Control-specific available filters. */
export type ControlFilterSet = {
  __typename?: 'ControlFilterSet';
  assessments: Array<UxFilterOption>;
  existingMaturity: Array<StringFilterOption>;
  frameworks: Array<UxFilterOption>;
  owners: Array<OwnerFilterOption>;
  status: Array<StringFilterOption>;
  strategy: Array<StringFilterOption>;
  targetMaturity: Array<StringFilterOption>;
};

/** Selection payload for Controls filters */
export type ControlFiltersSelectionInput = {
  frameworks?: InputMaybe<Array<FilterFlagInput>>;
  owners?: InputMaybe<Array<FilterFlagInput>>;
  status?: InputMaybe<Array<FilterFlagInput>>;
  strategy?: InputMaybe<Array<FilterFlagInput>>;
};

/** Control Framework - A standardised collection of controls for managing risk - Control Framework is the Framework (collection) */
export type ControlFramework = {
  __typename?: 'ControlFramework';
  author?: Maybe<Scalars['String']['output']>;
  /** Number of Controls in this Control Framework */
  controlCount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * External ID of the control framework
   * @deprecated duplicate of the now prefered name framework_identifier
   */
  externalId?: Maybe<Scalars['String']['output']>;
  featureKey?: Maybe<Scalars['String']['output']>;
  /** Framework Controls */
  frameworkControls: Array<FrameworkControl>;
  /**
   * Currently a duplicate of externalId
   * @deprecated now called framework_identifier
   */
  frameworkLibraryId?: Maybe<Scalars['String']['output']>;
  framework_identifier?: Maybe<Scalars['String']['output']>;
  /** Internal ID of the control framework */
  id: Scalars['UxId']['output'];
  /** Whether this version is the current visible version of the framework */
  isCurrentVersion?: Maybe<Scalars['Boolean']['output']>;
  /** Metadata for Control Framework */
  meta?: Maybe<Meta>;
  /** Name of the control framework */
  name: Scalars['String']['output'];
  publishDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  shortname?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  /** User who created this version */
  versionCreatedBy?: Maybe<Scalars['String']['output']>;
  /** Control framework version number */
  versionNumber?: Maybe<Scalars['Int']['output']>;
  /** All non-deleted versions for this control framework */
  versions: Array<ControlFramework>;
};

export type ControlFromLibraryInput = {
  id: Scalars['UxId']['input'];
  scenarioId?: InputMaybe<Scalars['UxId']['input']>;
};

export type ControlInput = {
  actualActiveDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  annualCost?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  existingMaturity?: InputMaybe<MaturityLevel>;
  expectedActiveDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  /** An array of the Framework Control IDs this RMP Control implements or satisfies - null or not supplied = no update, [] = clear all, [UxId!] = set to these IDs */
  frameworkControlIds?: InputMaybe<Array<InputMaybe<Scalars['UxId']['input']>>>;
  id?: InputMaybe<Scalars['UxId']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OwnerInput>;
  reviewDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  shortname?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  targetMaturity?: InputMaybe<MaturityLevel>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

/** Controls list filters */
export type ControlSelectionInput = {
  assessments?: InputMaybe<Array<SelectionOptionInput>>;
  existingMaturity?: InputMaybe<Array<SelectionOptionInput>>;
  frameworks?: InputMaybe<Array<SelectionOptionInput>>;
  owners?: InputMaybe<Array<SelectionOptionInput>>;
  status?: InputMaybe<Array<SelectionOptionInput>>;
  strategy?: InputMaybe<Array<SelectionOptionInput>>;
  targetMaturity?: InputMaybe<Array<SelectionOptionInput>>;
};

/** Workspace dashboard giving summary of the workspace, including charts and statistics. */
export type Dashboard = {
  __typename?: 'Dashboard';
  /** The assessment this dashboard presents */
  assessment?: Maybe<Assessment>;
  averageIncidentFrequency?: Maybe<WidgetAverageIncidentFrequency>;
  controlImplementation?: Maybe<WidgetControlImplementation>;
  expectedLoss?: Maybe<WidgetExpectedLoss>;
  futureSecurityProgram?: Maybe<WidgetFutureSecurityProgram>;
  missingData?: Maybe<WidgetMissingData>;
  overdueReviews?: Maybe<WidgetOverdueReviews>;
  returnOnInvestment?: Maybe<WidgetReturnOnInvestment>;
  riskAvoidance?: Maybe<WidgetRiskAvoidance>;
  riskyScenarios?: Maybe<WidgetRiskyScenarios>;
  securityProgram?: Maybe<WidgetSecurityProgram>;
};

/** A date range input for filtering timeline events. */
export type DateRangeInput = {
  /** Optional end date for the filter (ISO 8601 format). */
  end_date?: InputMaybe<Scalars['String']['input']>;
  /** Start date for the filter (ISO 8601 format). */
  start_date: Scalars['String']['input'];
};

export enum EnvironmentType {
  Demo = 'DEMO',
  Internal = 'INTERNAL',
  Paid = 'PAID',
  Trial = 'TRIAL'
}

/** Event */
export type Event = {
  __typename?: 'Event';
  /** Person event is assigned to */
  assignedTo?: Maybe<Owner>;
  /** Date event completed */
  completedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Person who completed the event */
  completedBy?: Maybe<Owner>;
  /** completion status of the event */
  completionStatus?: Maybe<EventCompletionStatus>;
  /** Date event action is due */
  dueDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Type of event - e.g. 'comment', 'action', 'review' */
  eventType?: Maybe<EventKind>;
  /** Event identifier */
  id: Scalars['UxId']['output'];
  /** Event is overdue */
  isOverdue: Scalars['Boolean']['output'];
  /** Meta data for Event */
  meta?: Maybe<Meta>;
  /** Notes relating to the Event */
  notes?: Maybe<Scalars['String']['output']>;
  /** UxId of the associated object */
  objectId?: Maybe<Scalars['UxId']['output']>;
  /** object type the event relates to - e.g. 'Assessment', 'Scenario', 'Control' */
  objectType?: Maybe<ObjectKind>;
};

/** Enum of completion statuses stored in completion_status */
export enum EventCompletionStatus {
  Cancelled = 'Cancelled',
  Done = 'Done',
  Open = 'Open'
}

/** Event input */
export type EventInput = {
  /** Person event is assigned to */
  assignedTo?: InputMaybe<OwnerInput>;
  /** Date event completed */
  completedAt?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  /** Person who completed the event */
  completedBy?: InputMaybe<OwnerInput>;
  /** completion status of the event */
  completionStatus?: InputMaybe<EventCompletionStatus>;
  /** Date event action is due */
  dueDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  /** Type of event */
  eventType?: InputMaybe<EventKind>;
  id?: InputMaybe<Scalars['UxId']['input']>;
  /** Notes relating to the Event */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** UxId of the associated object */
  objectId?: InputMaybe<Scalars['UxId']['input']>;
  /** object type the event relates to - e.g. 'Assessment', 'Scenario', 'Control' */
  objectType?: InputMaybe<ObjectKind>;
};

/** Enum of event kinds stored in event_type */
export enum EventKind {
  Action = 'Action',
  Comment = 'Comment',
  Review = 'Review'
}

/** Event Type */
export type EventType = {
  __typename?: 'EventType';
  /** Available completion status options for the event type */
  completionStatusOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Type of event - e.g. 'comment', 'action', 'review' */
  eventType?: Maybe<Scalars['String']['output']>;
  /** Can be assigend to Person / have due date */
  isAssignable?: Maybe<Scalars['Boolean']['output']>;
};

export enum ExportAccess {
  User = 'USER',
  Workspace = 'WORKSPACE'
}

/** An ExportJob represents a request to export data, such as an assessment report, which may take some time to generate. The job tracks the status and progress of the export, and once completed, provides a link to the exported file. */
export type ExportJob = {
  __typename?: 'ExportJob';
  /** Visibility access level for this export job */
  access: ExportAccess;
  /** When the export was canceled */
  canceledAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** When the export completed successfully */
  completedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Created timestamp */
  createdAt: Scalars['DateTimeUtc']['output'];
  /** ECS task ARN if running in ECS */
  ecsTaskArn?: Maybe<Scalars['String']['output']>;
  /** Error message if job failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Full execution parameters including document config as stringified JSON */
  executionParams?: Maybe<Scalars['String']['output']>;
  /** When this job expires and can be cleaned up */
  expiresAt: Scalars['DateTimeUtc']['output'];
  /** When the export failed */
  failedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** User-friendly identifier */
  id: Scalars['UxId']['output'];
  /** Last time job status was checked */
  lastCheckedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Progress percentage (0-100) */
  progress: Scalars['Int']['output'];
  /** Report entity keys and options as JSON string */
  reportParams?: Maybe<Scalars['String']['output']>;
  /** Type of report being exported */
  reportType: ExportReportType;
  /** User who requested the export */
  requestedBy: User;
  /** S3 key where the exported file is stored */
  s3Key?: Maybe<Scalars['String']['output']>;
  /** When the export started */
  startedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Current status of the export job (pending, processing, completed, failed, canceled, upload pending) */
  status: ExportStatus;
  /** Updated timestamp */
  updatedAt: Scalars['DateTimeUtc']['output'];
};

export enum ExportReportType {
  Assessment = 'ASSESSMENT',
  Insights = 'INSIGHTS',
  Rmp = 'RMP',
  Scenario = 'SCENARIO'
}

export enum ExportStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  UploadPending = 'UPLOAD_PENDING'
}

/** Features are discrete elements of functionality that can be enabled or disabled. */
export type Feature = {
  __typename?: 'Feature';
  general: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisations: Array<Scalars['UxId']['output']>;
  workspaces: Array<Scalars['UxId']['output']>;
};

/** Feature flag status for active workspace */
export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  feature: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};

/** Generic on/off filter flag (use either value OR uxId) */
export type FilterFlagInput = {
  enabled?: Scalars['Boolean']['input'];
  uxId?: InputMaybe<Scalars['UxId']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Top-level object types we can filter. Keep this list stable for the UI.
 * We expose the flow: overview -> pick object -> get that object's filters.
 */
export enum FilterObjectKey {
  Controls = 'CONTROLS'
}

/** Shown in the overview so the frontend knows what's available. */
export type FilterObjectSummary = {
  __typename?: 'FilterObjectSummary';
  count: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  key: FilterObjectKey;
  label: Scalars['String']['output'];
};

/** An Organisation */
export type FlatOrganisation = {
  __typename?: 'FlatOrganisation';
  /** Actions available to current user on this org unit (eg: workspace, organisation, etc) */
  actionsOnThisOrgUnit?: Maybe<OrgUnitActions>;
  /** Time the organisation was archived. */
  archivedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Who archived the organisation. */
  archivedBy?: Maybe<User>;
  /** Billing Type */
  billingType?: Maybe<BillingType>;
  /** Business Type */
  businessType?: Maybe<BusinessType>;
  /** Child IDs */
  childIds: Array<Scalars['UxId']['output']>;
  /** Domain for the Organisation */
  domain: Scalars['String']['output'];
  /** Environment Type */
  environmentType?: Maybe<EnvironmentType>;
  /** Main Organisation Identifier */
  id: Scalars['UxId']['output'];
  /** Whether this organisation is archived (soft-deleted). */
  isArchived: Scalars['Boolean']['output'];
  /** Restricted flag - orgs always restricted - unrestricted workspaces are open to all organisation domain users */
  isRestricted: Scalars['Boolean']['output'];
  /** Request membership data for a user - defaults to current authenticated user if not provided */
  member?: Maybe<Member>;
  /** Organisation Name */
  name: Scalars['String']['output'];
  /** Organisation Type */
  organisationType?: Maybe<OrganisationType>;
  /** Parent Organisation */
  parentId?: Maybe<Scalars['UxId']['output']>;
  /** Workspace Plan Type */
  plan?: Maybe<Scalars['String']['output']>;
  /** Plan Type */
  planType?: Maybe<PlanType>;
  /** Primary Contact for the Organisation */
  primaryContact: Scalars['String']['output'];
  /** Record Type: O -> Organisation , W -> Secondary Workspace, (later P -> Partner) */
  recordType: Scalars['String']['output'];
  /** Service Model */
  serviceModel?: Maybe<ServiceModel>;
  /** Users in the Organisation */
  users: Array<User>;
  /** Count of Users with access to this organisations workspaces */
  usersCount: Scalars['Int']['output'];
};


/** An Organisation */
export type FlatOrganisationUsersArgs = {
  memberId?: InputMaybe<Scalars['UxId']['input']>;
};

/** Framework Control is a specific control within the Control Framework - The term Framework Control is used to distinguish them from the controls the user implements as part of their RMP. A control in the user's RMP may reference one or more Framework Controls */
export type FrameworkControl = {
  __typename?: 'FrameworkControl';
  compatibleControls: Array<FrameworkControl>;
  controlFramework?: Maybe<ControlFramework>;
  /**
   * Control ID within Framework
   * @deprecated now called control_identifier
   */
  controlLibraryId?: Maybe<Scalars['String']['output']>;
  control_identifier?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Internal ID of the framework control */
  id: Scalars['UxId']['output'];
  /** Metadata for the Framework Control */
  meta?: Maybe<Meta>;
  /** Name of the framework control */
  name: Scalars['String']['output'];
  shortname?: Maybe<Scalars['String']['output']>;
  /** Treat, Transfer, Tolerate, Terminate */
  strategy?: Maybe<Scalars['String']['output']>;
};

export type FrameworkControlImportInput = {
  controlIdentifier?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UxId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortname?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<Scalars['String']['input']>;
};

export type FrameworkControlScenarioInput = {
  /** ID of the framework control (or user control based on framework control) to link to the scenario */
  frameworkControlId: Scalars['UxId']['input'];
  /** ID of the scenario to link to the framework control */
  scenarioId: Scalars['UxId']['input'];
};

export type FrameworkImportInput = {
  controls: Array<FrameworkControlImportInput>;
  framework: FrameworkImportMetadataInput;
};

export type FrameworkImportMetadataInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  frameworkIdentifier?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UxId']['input']>;
  name: Scalars['String']['input'];
  publishDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  shortname?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Details of incidents which may help identify/quantify risk scenarios and their outcomes */
export type Incident = {
  __typename?: 'Incident';
  /** Actions for this incident */
  actions: Array<Event>;
  dateOfIncident?: Maybe<Scalars['DateTimeUtc']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  financialImpactLower?: Maybe<Scalars['BigNumber']['output']>;
  financialImpactUpper?: Maybe<Scalars['BigNumber']['output']>;
  id: Scalars['UxId']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  incidentType?: Maybe<Scalars['String']['output']>;
  /** Metadata for Incident */
  meta?: Maybe<Meta>;
  name: Scalars['String']['output'];
  owner?: Maybe<Owner>;
  /** Incident owner email */
  ownerEmail?: Maybe<Scalars['String']['output']>;
  /** Owner of the Incident */
  ownerName?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  scenarios: Array<Scenario>;
  severity?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  workspace?: Maybe<Workspace>;
};


/** Details of incidents which may help identify/quantify risk scenarios and their outcomes */
export type IncidentActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['UxId']['input']>;
  completionStatus?: InputMaybe<EventCompletionStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Details of incidents which may help identify/quantify risk scenarios and their outcomes */
export type IncidentScenariosArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};

export type IncidentInput = {
  dateOfIncident?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  financialImpactLower?: InputMaybe<Scalars['BigNumber']['input']>;
  financialImpactUpper?: InputMaybe<Scalars['BigNumber']['input']>;
  id?: InputMaybe<Scalars['UxId']['input']>;
  impact?: InputMaybe<Scalars['String']['input']>;
  incidentType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OwnerInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Specifics about the invite */
export type Invite = {
  __typename?: 'Invite';
  /** The date the user accepted the invite - should be null for active invites - may be used in future for views of historical invites */
  acceptedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** The name used to identify the user before they exist in the workspace - subsequently an alternate name for the user in this workspace */
  aka?: Maybe<Scalars['String']['output']>;
  /** Record creation timestamp */
  createdAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** The unique identifier for the invite */
  id?: Maybe<Scalars['UxId']['output']>;
  /** The date the user was invited */
  invitedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** The role the user was pre-assigned when invited */
  invitedRole?: Maybe<Role>;
  /** The identifier of the invited org unit (workspace or organisation) */
  orgUnitId?: Maybe<Scalars['UxId']['output']>;
  /** The name of the invited org unit (workspace or organisation) */
  orgUnitName?: Maybe<Scalars['String']['output']>;
  /** The Type of the invited org unit (workspace or organisation) */
  orgUnitType?: Maybe<Scalars['String']['output']>;
  /** The organisation identifier of the invited workspace */
  organisationId?: Maybe<Scalars['UxId']['output']>;
  /** The organisation name of the invited workspace */
  organisationName?: Maybe<Scalars['UxId']['output']>;
  /** Record creation timestamp */
  updatedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** The invited user's email */
  userEmail?: Maybe<Scalars['UxId']['output']>;
  /** The invited user's ID */
  userId?: Maybe<Scalars['Int']['output']>;
  /** The invited user's name */
  userName?: Maybe<Scalars['UxId']['output']>;
  /** The identifier of the invited workspace */
  workspaceId?: Maybe<Scalars['UxId']['output']>;
  /** The name of the invited workspace */
  workspaceName?: Maybe<Scalars['UxId']['output']>;
};

/** Invite input data */
export type InviteInput = {
  /** The invited user's email */
  email: Scalars['String']['input'];
  /** The name used to identify this user - possible before they exist in a workspace */
  name: Scalars['String']['input'];
  /** The ID of the Owner (if inviting a person) */
  ownerId?: InputMaybe<Scalars['String']['input']>;
  /** The role to assign to the invited user - defaults to collaborator if not specified */
  role?: InputMaybe<Role>;
};

/** Some type of user (existing or prospective) that has been invited to a workspace */
export type InvitedUser = {
  __typename?: 'InvitedUser';
  /** The email address of the user */
  email?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the user - ids above 1000000 indicate a user that is not yet registered */
  id?: Maybe<Scalars['Int']['output']>;
  /** Specifics about the invite */
  invite?: Maybe<Invite>;
  /** The main name of the user */
  name?: Maybe<Scalars['String']['output']>;
  /** Path to Profile Image. */
  profilePhotoPath?: Maybe<Scalars['String']['output']>;
  /** The workspace name the user is invited to - maybe only needed for BE (notifications) */
  workspaceName?: Maybe<Scalars['String']['output']>;
  /** The name of the user in this workspace - legacy - orgUnitIdentity is the new approach but may not make sense at the invite stage */
  workspaceUserName?: Maybe<Scalars['String']['output']>;
};

/** Roles available for inviting a user */
export type InvitedUserRoles = {
  __typename?: 'InvitedUserRoles';
  /** Is the email that of an existing partner admin user */
  isPartnerAdmin: Scalars['Boolean']['output'];
  /** Is the email considered trusted for enabling admin roles */
  isTrustedEmail: Scalars['Boolean']['output'];
  /** Available roles for the invited user */
  roles: Array<Role>;
};

export type LinkOptionInput = {
  include: Scalars['Boolean']['input'];
  makeNewLink: Scalars['Boolean']['input'];
};

/** Current Risk allowing for live controls */
export type LiveRisk = {
  __typename?: 'LiveRisk';
  /**
   * Expected loss after live controls applied
   * @deprecated Use ScenarioRisk. LiveRisk is deprecated and will be removed in a future release.
   */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
  /** Number of times the risk is expected to occur */
  frequencyTimes?: Maybe<Scalars['Int']['output']>;
  /** Period of time for the frequency times */
  frequencyYears?: Maybe<Scalars['Int']['output']>;
  /** Lower estimate of the monetary cost of the event */
  lower?: Maybe<Scalars['BigNumber']['output']>;
  /** low values can affect the graph */
  lowerThanMinimum?: Maybe<Scalars['String']['output']>;
  /** loss simulation for graph */
  simLosses?: Maybe<Scalars['SimLosses']['output']>;
  /** Upper estimate of the monetary cost of the event */
  upper?: Maybe<Scalars['BigNumber']['output']>;
};

export type LogoUpload = {
  __typename?: 'LogoUpload';
  key: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** Maturity level of the control. */
export enum MaturityLevel {
  Level_0 = 'LEVEL_0',
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  Level_4 = 'LEVEL_4',
  Level_5 = 'LEVEL_5'
}

/** A member of an Org Unit is a user who has or may be given access to that Org Unit */
export type Member = {
  __typename?: 'Member';
  /** User access status within the Org Unit */
  access: MemberAccess;
  /** Associated member: */
  association?: Maybe<MemberAssociation>;
  /** Effective role of the member within the Org Unit - taking into account any inherited roles from parent Org Units */
  effectiveRole?: Maybe<Role>;
  /** Member actions the current authenticated user can perform on this member within the context of the Org Unit */
  memberActions: MemberActions;
  /** User associated with this member record */
  user: User;
};

export enum MemberAccess {
  Admin = 'ADMIN',
  AdminOnly = 'ADMIN_ONLY',
  Blocked = 'BLOCKED',
  Invited = 'INVITED',
  No = 'NO',
  Requested = 'REQUESTED',
  Yes = 'YES'
}

/** Member actions are the actions the current authenticated user can perform on a specified member in context of an Org Unit - member can be self or another user */
export type MemberActions = {
  __typename?: 'MemberActions';
  /** Can accept an invite sent for the Org Unit in context - when self */
  canAcceptInvite: Scalars['Boolean']['output'];
  /** Can accept a user's request to join the Org Unit in context - when user admin */
  canAcceptRequest: Scalars['Boolean']['output'];
  /** Can cancel user's invite for the Org Unit in context - when user admin */
  canCancelInvite: Scalars['Boolean']['output'];
  /** Can cancel a request sent to the Org Unit in context - when self */
  canCancelRequest: Scalars['Boolean']['output'];
  /** Can edit the profile of a user */
  canEditProfile: Scalars['Boolean']['output'];
  /** Can grant access to the Org Unit in context */
  canGrantAccess: Scalars['Boolean']['output'];
  /** Can invite user to the Org Unit in context - when user admin */
  canInviteUser: Scalars['Boolean']['output'];
  /** Can make user an admin of the Org Unit in context (organisation admin for orgs, workspace admin for workspaces) */
  canMakeAdmin: Scalars['Boolean']['output'];
  /** Can make user a customer manager of the Org Unit in context */
  canMakeCustomerManager: Scalars['Boolean']['output'];
  /** Can make user an partner admin of the Org Unit in context */
  canMakePartnerAdmin: Scalars['Boolean']['output'];
  /** Can reject a users's request to join the Org Unit in context - when user admin */
  canRejectRequest: Scalars['Boolean']['output'];
  /** Can remove (remove - guest domain, block - org domain) user from the Org Unit in context - when user admin */
  canRemoveUser: Scalars['Boolean']['output'];
  /** Can request access to the Org Unit in context - when self */
  canRequestAccess: Scalars['Boolean']['output'];
  /** Can revoke user from access to the Org Unit in context */
  canRevokeAccess: Scalars['Boolean']['output'];
  /** Can revoke user as admin of the Org Unit in context (revoke any admin status) */
  canRevokeAdmin: Scalars['Boolean']['output'];
};

/** A member association describes a direct (as opposed to implied) membership of an Org Unit. A member of an Org Unit is a user who has or may be given access to that Org Unit */
export type MemberAssociation = {
  __typename?: 'MemberAssociation';
  /** The date the user's request or invite was accepted - should be null for active requests - may be used in future for views of historical requests */
  acceptedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Member Identifier */
  id?: Maybe<Scalars['UxId']['output']>;
  /** The date the user was invited to join the organisation unit */
  invitedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Notification preferences for this member within the Org Unit */
  notifications: Scalars['Boolean']['output'];
  /** The date the user requested to join the workspace */
  requestedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** The member's role within the Org Unit */
  role?: Maybe<Role>;
  /** The requesting user's email */
  userEmail: Scalars['String']['output'];
  /** User's name in this Org Unit - may be different to their main user name */
  userName: Scalars['String']['output'];
};

/** Record Meta data */
export type Meta = {
  __typename?: 'Meta';
  /** When the record was created. */
  createdAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** User who created this record */
  createdBy?: Maybe<Scalars['String']['output']>;
  createdById?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use createdById. createdBy_id is deprecated and will be removed in a future release. */
  createdBy_id?: Maybe<Scalars['ID']['output']>;
  /** When the Assessment was updated. */
  updatedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** User who last updated this record */
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedById?: Maybe<Scalars['ID']['output']>;
};

/** Risk Managed by the application of controls */
export type Modifier = {
  __typename?: 'Modifier';
  /** consequence lower bound adjustment */
  consequenceLower?: Maybe<Scalars['Int']['output']>;
  /** consequence upper bound adjustment */
  consequenceUpper?: Maybe<Scalars['Int']['output']>;
  /** excess */
  excess?: Maybe<Scalars['Int']['output']>;
  /** Frequency reduction */
  frequencyReduction?: Maybe<Scalars['Int']['output']>;
  /** Modifiers identifier */
  id: Scalars['UxId']['output'];
  /** Percentage or value indicator */
  isPercentage?: Maybe<Scalars['Boolean']['output']>;
  /** Meta data */
  meta?: Maybe<Meta>;
  /** A descriptive note covering the modifier set */
  note?: Maybe<Scalars['String']['output']>;
  /** total policy cover */
  totalPolicyCover?: Maybe<Scalars['Float']['output']>;
  /** The Scenario the RMP is associated with */
  transactionId?: Maybe<Scalars['String']['output']>;
  /** Modifier type - determines which of the following fields are used */
  type?: Maybe<Scalars['String']['output']>;
};

export type ModifierDataInput = {
  /** excess */
  excess?: InputMaybe<Scalars['Int']['input']>;
  /** Percentage or value indicator */
  isPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lower bound adjustment */
  lower?: InputMaybe<Scalars['Int']['input']>;
  /** A descriptive note */
  note?: InputMaybe<Scalars['String']['input']>;
  /** total policy cover */
  tpc?: InputMaybe<Scalars['Int']['input']>;
  /** Upper bound adjustment */
  upper?: InputMaybe<Scalars['Int']['input']>;
  /** Value for frequency reduction or other adjustments */
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ModifierInput = {
  /** Notes */
  notes?: InputMaybe<Array<InputMaybe<ModifierNotesInput>>>;
  /** Transfer modifiers */
  transfer?: InputMaybe<Array<InputMaybe<ModifierItemInput>>>;
  /** Treat modifiers */
  treat?: InputMaybe<Array<InputMaybe<ModifierItemInput>>>;
};

export type ModifierItemInput = {
  /** Modifier data */
  data?: InputMaybe<ModifierDataInput>;
  /** A descriptive note covering the modifier */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Modifier type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ModifierNotesInput = {
  /** Note data */
  data?: InputMaybe<ModifierDataInput>;
  /** Note type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Allows a user to accept an invite to join a workspace. */
  acceptInvite?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a workspace Admin to accept a user request for access to an OrgUnit */
  acceptRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user directly associated with an organisation (via domain) to accept the Orgs T&Cs */
  acceptTerms?: Maybe<Scalars['Boolean']['output']>;
  /** Batch create or update a control */
  addControlsFromLibrary: Array<Control>;
  /** Add a scenario (by ux_id) into a scenario group (by ux_id). */
  addScenarioToGroup?: Maybe<ScenarioGroup>;
  /** Marks an organisation and all its workspaces as deleted, removing it from the list of orgs and workspaces a user can see */
  archiveOrganisation: Scalars['Boolean']['output'];
  /** Marks a workspace as deleted and removes it from the list of workspaces a user can see */
  archiveWorkspace: Scalars['Boolean']['output'];
  /** Allows a workspace Admin to cancel a users invite to a workspace that hasn't been accepted yet. */
  cancelInvite?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to cancel their request for access to an organisation (organisationId required) or to a workspace (requestId required) */
  cancelRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to duplicate an assessment */
  cloneAssessment?: Maybe<Assessment>;
  completeEvent?: Maybe<Event>;
  /** Create an export job for the authenticated user and launch the report task. */
  createExportJob: ExportJob;
  /** Create a new control framework and import framework control rows */
  createFrameworkFromImport: ContentImportSummary;
  /** Create a new scenario pack and import scenario template rows */
  createScenarioGroupFromImport: ContentImportSummary;
  /** Allows a user directly associated with an organisation (via domain) to defer the Orgs T&Cs */
  deferTerms?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to delete an assessment */
  deleteAssessment?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a control framework */
  deleteControlFramework: ContentImportSummary;
  /** Delete selected framework controls by creating a new control framework version without them */
  deleteControlFrameworkControls: ContentImportSummary;
  /** Delete one control framework version */
  deleteControlFrameworkVersion: ContentImportSummary;
  /** Allows a user to delete a control */
  deleteControls?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to delete an event */
  deleteEvent?: Maybe<Scalars['Boolean']['output']>;
  /** Allows an Admin to delete a feature flag */
  deleteFeature?: Maybe<Feature>;
  /** Allows a user to delete an Incident */
  deleteIncident?: Maybe<Scalars['Boolean']['output']>;
  /** Marks an organisation and all its workspaces as deleted */
  deleteOrganisation: Scalars['Boolean']['output'];
  /** Allows a user to delete a scenario */
  deleteScenario?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a scenario pack and all of its versions */
  deleteScenarioGroupPack: ContentImportSummary;
  /** Delete selected scenario templates by creating a new scenario pack version without them */
  deleteScenarioGroupRisks: ContentImportSummary;
  /** Delete one scenario pack version */
  deleteScenarioGroupVersion: ContentImportSummary;
  deleteScenarioTemplate?: Maybe<ScenarioTemplate>;
  /** Soft deletes a user (marks them as ignored). Only platform or organisation admins can perform this. */
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an export job. */
  deleteUserExportJobs: Scalars['Boolean']['output'];
  /** Permanently deletes a previously archived workspace */
  deleteWorkspace: Scalars['Boolean']['output'];
  /** Allows an admin to give a user access to a workspace (workspaceId required) or to an organisation (organisationId required) */
  grantAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Allows an admin to give a user admin rights to a workspace (workspaceId required) or to an organisation (organisationId required) */
  grantAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Grant workspace access to an export job. */
  grantWorkspaceAccessToExportJobs: Scalars['Boolean']['output'];
  /** Import framework metadata and framework control rows for an existing framework */
  importFramework: ContentImportSummary;
  /** Import scenario pack metadata and scenario template rows for an existing scenario group */
  importScenarioGroup: ContentImportSummary;
  /** Allows a workspace Admin to invite users to join a workspace */
  inviteUsers?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to link multiple scenarios to an control */
  linkControlToScenarios?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to link multiple framework controls to scenarios */
  linkFrameworkControlsToScenarios?: Maybe<Array<Maybe<Control>>>;
  /** Allows a user to link multiple scenarios to an incident */
  linkIncidentToScenarios?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to link multiple controls to a scenario */
  linkScenarioToControls?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to link multiple incidents to a scenario */
  linkScenarioToIncidents?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to reject an invite to join a workspace. */
  rejectInvite?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a workspace Admin to reject a user request for access to an OrgUnit */
  rejectRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Removes a person (organisation user) based on compound ID */
  removePeople?: Maybe<Scalars['Boolean']['output']>;
  /** Allows an admin to remove a user from a workspace (workspaceId required) or from an organisation (organisationId required) */
  removeUser?: Maybe<Scalars['Boolean']['output']>;
  /** Request a short-lived download URL for a completed export job. Writes an audit record. */
  reportDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Allows a user to request access to workspace (workspaceId required) or to an organisation (organisationId required) */
  requestAccess?: Maybe<Scalars['Boolean']['output']>;
  requestLogoUpload: LogoUpload;
  /** Allows a user to update their own details, or an admin to update managed user details */
  requestSupport?: Maybe<Scalars['Boolean']['output']>;
  /** Allows an admin to revoke a user's admin rights to a workspace (workspaceId required) or to an organisation (organisationId required) */
  revokeAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** Revoke workspace access from an export job. */
  revokeWorkspaceAccessFromExportJobs: Scalars['Boolean']['output'];
  /** Allows a user to work in a different workspace to the one they are currently in */
  setActiveWorkspace?: Maybe<Profile>;
  /** Restores a previously deleted (soft-deleted) organisation */
  unarchiveOrganisation: Scalars['Boolean']['output'];
  /** Restores a previously deleted (soft-deleted) organisation */
  unarchiveWorkspace: Scalars['Boolean']['output'];
  /** Allows a user to unlink multiple scenarios from an control */
  unlinkControlFromScenarios?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to unlink multiple scenarios from an incident */
  unlinkIncidentFromScenarios?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to unlink multiple controls from a scenario */
  unlinkScenarioFromControls?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to unlink multiple incidents from a scenario */
  unlinkScenarioFromIncidents?: Maybe<Scalars['Boolean']['output']>;
  /** Update an export job status and/or progress using X-Export-Auth header token. */
  updateExportJob: ExportJob;
  /** Update control framework metadata without importing control rows */
  updateFrameworkMetadata: ContentImportSummary;
  /** Update scenario pack metadata without importing scenario rows */
  updateScenarioGroupMetadata: ContentImportSummary;
  /** Allows a user to update their own details, or an admin to update managed user details */
  updateUser?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to create or update an assessment */
  upsertAssessment?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to create or update assessment variables */
  upsertAssessmentVariables?: Maybe<Assessment>;
  /** Allows a user to create or update a control */
  upsertControl?: Maybe<Control>;
  /** Batch create or update a control */
  upsertControls: Array<Control>;
  /** Allows a user to create or update an event */
  upsertEvent: Array<Event>;
  /** Allows an Admin to create or update a feature flag */
  upsertFeature: Feature;
  /** Allows a user to create or update an Incident */
  upsertIncident?: Maybe<Incident>;
  /** Batch create or update multiple Incidents */
  upsertIncidents?: Maybe<Array<Maybe<Incident>>>;
  /** Allows a user to unlink multiple scenarios from an control */
  upsertModifiers?: Maybe<Scalars['Boolean']['output']>;
  /** Allows a user to create or update a workspace */
  upsertOrganisation?: Maybe<Organisation>;
  /** Allows a user to create or update scenario details */
  upsertScenario?: Maybe<Scenario>;
  /** Create or update a scenario template */
  upsertScenarioTemplate: ScenarioTemplate;
  /** Allows a user to create or update multiple scenario details */
  upsertScenarios?: Maybe<Array<Maybe<Scenario>>>;
  /** Create or update a variable setting */
  upsertVariableSetting?: Maybe<VariableSetting>;
  /** Allows a user to create or update a workspace */
  upsertWorkspace?: Maybe<Workspace>;
  /** store responses to questions in the workspace wizzard */
  upsertWorkspaceQuestions?: Maybe<Workspace>;
  /** Update the value of workspace variables */
  upsertWorkspaceVariables?: Maybe<Workspace>;
  /** Allows a user to create or update assessment variables */
  wizardAddScenariosToAssessment?: Maybe<Assessment>;
  /** Allows a user to create or update an assessment */
  wizardCreateAssessment?: Maybe<Assessment>;
};


export type MutationAcceptInviteArgs = {
  inviteId: Scalars['UxId']['input'];
};


export type MutationAcceptRequestArgs = {
  requestId: Scalars['UxId']['input'];
};


export type MutationAcceptTermsArgs = {
  acceptedMethod: Scalars['String']['input'];
  termsId: Scalars['UxId']['input'];
};


export type MutationAddControlsFromLibraryArgs = {
  addRecommendedModifiers?: InputMaybe<Scalars['Boolean']['input']>;
  controlIds: Array<ControlFromLibraryInput>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationAddScenarioToGroupArgs = {
  groupId?: InputMaybe<Scalars['UxId']['input']>;
  scenarioId: Scalars['UxId']['input'];
};


export type MutationArchiveOrganisationArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationArchiveWorkspaceArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationCancelInviteArgs = {
  inviteId: Scalars['UxId']['input'];
};


export type MutationCancelRequestArgs = {
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  requestId?: InputMaybe<Scalars['UxId']['input']>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationCloneAssessmentArgs = {
  id: Scalars['UxId']['input'];
  incidents?: InputMaybe<LinkOptionInput>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  riskManagementPlan?: InputMaybe<LinkOptionInput>;
  toUserId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationCompleteEventArgs = {
  completedAt?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  completedBy?: InputMaybe<OwnerInput>;
  completionStatus?: InputMaybe<EventCompletionStatus>;
  id: Scalars['UxId']['input'];
};


export type MutationCreateExportJobArgs = {
  access: ExportAccess;
  reportParams?: InputMaybe<Scalars['String']['input']>;
  reportType: ExportReportType;
};


export type MutationCreateFrameworkFromImportArgs = {
  input: FrameworkImportInput;
};


export type MutationCreateScenarioGroupFromImportArgs = {
  input: ScenarioGroupImportInput;
};


export type MutationDeferTermsArgs = {
  termsId: Scalars['UxId']['input'];
};


export type MutationDeleteAssessmentArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationDeleteControlFrameworkArgs = {
  frameworkId: Scalars['UxId']['input'];
};


export type MutationDeleteControlFrameworkControlsArgs = {
  controlIds: Array<Scalars['UxId']['input']>;
  frameworkId: Scalars['UxId']['input'];
};


export type MutationDeleteControlFrameworkVersionArgs = {
  frameworkId: Scalars['UxId']['input'];
};


export type MutationDeleteControlsArgs = {
  ids: Array<Scalars['UxId']['input']>;
};


export type MutationDeleteEventArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationDeleteFeatureArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteIncidentArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationDeleteOrganisationArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationDeleteScenarioArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationDeleteScenarioGroupPackArgs = {
  scenarioGroupId: Scalars['UxId']['input'];
};


export type MutationDeleteScenarioGroupRisksArgs = {
  scenarioGroupId: Scalars['UxId']['input'];
  scenarioIds: Array<Scalars['UxId']['input']>;
};


export type MutationDeleteScenarioGroupVersionArgs = {
  scenarioGroupId: Scalars['UxId']['input'];
};


export type MutationDeleteScenarioTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserExportJobsArgs = {
  jobIds: Array<Scalars['UxId']['input']>;
};


export type MutationDeleteWorkspaceArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationGrantAccessArgs = {
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  userId: Scalars['Int']['input'];
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationGrantAdminArgs = {
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  userId: Scalars['Int']['input'];
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationGrantWorkspaceAccessToExportJobsArgs = {
  jobIds: Array<Scalars['UxId']['input']>;
};


export type MutationImportFrameworkArgs = {
  frameworkId: Scalars['UxId']['input'];
  input: FrameworkImportInput;
};


export type MutationImportScenarioGroupArgs = {
  input: ScenarioGroupImportInput;
  scenarioGroupId: Scalars['UxId']['input'];
};


export type MutationInviteUsersArgs = {
  invitesData: Array<InviteInput>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationLinkControlToScenariosArgs = {
  addRecommendedModifiers?: InputMaybe<Scalars['Boolean']['input']>;
  controlId: Scalars['UxId']['input'];
  scenarioIds: Array<Scalars['UxId']['input']>;
};


export type MutationLinkFrameworkControlsToScenariosArgs = {
  addRecommendedModifiers?: InputMaybe<Scalars['Boolean']['input']>;
  frameworkControlScenarioLinks: Array<FrameworkControlScenarioInput>;
};


export type MutationLinkIncidentToScenariosArgs = {
  incidentId: Scalars['UxId']['input'];
  scenarioIds: Array<Scalars['UxId']['input']>;
};


export type MutationLinkScenarioToControlsArgs = {
  addRecommendedModifiers?: InputMaybe<Scalars['Boolean']['input']>;
  controlIds: Array<Scalars['UxId']['input']>;
  scenarioId: Scalars['UxId']['input'];
};


export type MutationLinkScenarioToIncidentsArgs = {
  incidentIds: Array<Scalars['UxId']['input']>;
  scenarioId: Scalars['UxId']['input'];
};


export type MutationRejectInviteArgs = {
  inviteId: Scalars['UxId']['input'];
};


export type MutationRejectRequestArgs = {
  requestId: Scalars['UxId']['input'];
};


export type MutationRemovePeopleArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveUserArgs = {
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  userId: Scalars['Int']['input'];
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationReportDownloadUrlArgs = {
  jobId: Scalars['UxId']['input'];
};


export type MutationRequestAccessArgs = {
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationRequestLogoUploadArgs = {
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
};


export type MutationRequestSupportArgs = {
  assessmentId?: InputMaybe<Scalars['UxId']['input']>;
  scenarioId?: InputMaybe<Scalars['UxId']['input']>;
  text: Scalars['String']['input'];
};


export type MutationRevokeAdminArgs = {
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  userId: Scalars['Int']['input'];
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationRevokeWorkspaceAccessFromExportJobsArgs = {
  jobIds: Array<Scalars['UxId']['input']>;
};


export type MutationSetActiveWorkspaceArgs = {
  workspaceId: Scalars['UxId']['input'];
};


export type MutationUnarchiveOrganisationArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationUnarchiveWorkspaceArgs = {
  id: Scalars['UxId']['input'];
};


export type MutationUnlinkControlFromScenariosArgs = {
  controlId: Scalars['UxId']['input'];
  scenarioIds: Array<Scalars['UxId']['input']>;
};


export type MutationUnlinkIncidentFromScenariosArgs = {
  incidentId: Scalars['UxId']['input'];
  scenarioIds: Array<Scalars['UxId']['input']>;
};


export type MutationUnlinkScenarioFromControlsArgs = {
  controlIds: Array<Scalars['UxId']['input']>;
  scenarioId: Scalars['UxId']['input'];
};


export type MutationUnlinkScenarioFromIncidentsArgs = {
  incidentIds: Array<Scalars['UxId']['input']>;
  scenarioId: Scalars['UxId']['input'];
};


export type MutationUpdateExportJobArgs = {
  progress?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ExportStatus>;
};


export type MutationUpdateFrameworkMetadataArgs = {
  framework: FrameworkImportMetadataInput;
  frameworkId: Scalars['UxId']['input'];
};


export type MutationUpdateScenarioGroupMetadataArgs = {
  group: ScenarioPackGroupImportInput;
  scenarioGroupId: Scalars['UxId']['input'];
};


export type MutationUpdateUserArgs = {
  name: Scalars['String']['input'];
  orgUnitId?: InputMaybe<Scalars['UxId']['input']>;
  receiveNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
  userId: Scalars['Int']['input'];
};


export type MutationUpsertAssessmentArgs = {
  assessmentData: AssessmentInput;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertAssessmentVariablesArgs = {
  assessmentId: Scalars['UxId']['input'];
  variables: Array<InputMaybe<VariableInput>>;
};


export type MutationUpsertControlArgs = {
  controlData: ControlInput;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertControlsArgs = {
  controlsData: Array<ControlInput>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertEventArgs = {
  eventData: Array<EventInput>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertFeatureArgs = {
  general: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  organisations: Array<Scalars['UxId']['input']>;
  workspaces: Array<Scalars['UxId']['input']>;
};


export type MutationUpsertIncidentArgs = {
  incidentData: IncidentInput;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertIncidentsArgs = {
  incidentsData: Array<IncidentInput>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertModifiersArgs = {
  control_id?: InputMaybe<Scalars['UxId']['input']>;
  modifiers?: InputMaybe<ModifierInput>;
  scenario_id?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertOrganisationArgs = {
  billingContact?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<BusinessType>;
  createWorkspace?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  organisationType?: InputMaybe<OrganisationType>;
  parentId?: InputMaybe<Scalars['UxId']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryContact?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  workspace?: InputMaybe<WorkspaceCreateInput>;
};


export type MutationUpsertScenarioArgs = {
  assessmentId?: InputMaybe<Scalars['UxId']['input']>;
  scenarioData: ScenarioInput;
};


export type MutationUpsertScenarioTemplateArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  consequence?: InputMaybe<Scalars['Int']['input']>;
  consequenceNote?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['Int']['input']>;
  expectedLoss?: InputMaybe<Scalars['Float']['input']>;
  frequencyNote?: InputMaybe<Scalars['String']['input']>;
  frequencyTimes?: InputMaybe<Scalars['Int']['input']>;
  frequencyYears?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lower?: InputMaybe<Scalars['Int']['input']>;
  lowerFormula?: InputMaybe<Scalars['String']['input']>;
  managementNote?: InputMaybe<Scalars['String']['input']>;
  managementStrategy?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  riskNarrative?: InputMaybe<Scalars['String']['input']>;
  riskOwner?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['Int']['input']>;
  upper?: InputMaybe<Scalars['Int']['input']>;
  upperFormula?: InputMaybe<Scalars['String']['input']>;
  uxId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertScenariosArgs = {
  assessmentId?: InputMaybe<Scalars['UxId']['input']>;
  scenariosData: Array<ScenarioInput>;
};


export type MutationUpsertVariableSettingArgs = {
  setting: VariableSettingInput;
};


export type MutationUpsertWorkspaceArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  isRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationScheduleTime?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<PlanType>;
  primaryContact?: InputMaybe<Scalars['String']['input']>;
  reviewCadence?: InputMaybe<ReviewCadence>;
  reviewCadenceDays?: InputMaybe<Scalars['Int']['input']>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


export type MutationUpsertWorkspaceQuestionsArgs = {
  questions: QuestionsInput;
  workspaceId: Scalars['UxId']['input'];
};


export type MutationUpsertWorkspaceVariablesArgs = {
  variables: Array<VariableInput>;
  workspaceId: Scalars['UxId']['input'];
};


export type MutationWizardAddScenariosToAssessmentArgs = {
  assessmentId: Scalars['UxId']['input'];
  scenarios: QuestionScenariosInput;
};


export type MutationWizardCreateAssessmentArgs = {
  assessment: QuestionAssessmentInput;
  scenarios: QuestionScenariosInput;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};

/**
 * Future-proof container for per-object filter sets.
 * For now only 'controls' will be populated.
 */
export type ObjectFilterSets = {
  __typename?: 'ObjectFilterSets';
  controls?: Maybe<ControlFilterSet>;
};

/** Enum of object types stored in object_type */
export enum ObjectKind {
  Assessment = 'ASSESSMENT',
  Control = 'CONTROL',
  Incident = 'INCIDENT',
  Scenario = 'SCENARIO'
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type OrgSettingsOptions = {
  __typename?: 'OrgSettingsOptions';
  businessType?: Maybe<Array<BusinessType>>;
  organisationType?: Maybe<OrganisationType>;
};

/** Organisation Unit actions are the actions the current authenticated user can perform on the organisation unit (workspace, organisation, etc) */
export type OrgUnitActions = {
  __typename?: 'OrgUnitActions';
  /** Can access the Organisation Unit */
  canAccess: Scalars['Boolean']['output'];
  /** Can archive the organisation unit */
  canArchive: Scalars['Boolean']['output'];
  /** Can cancel thier request to access the Organisation Unit */
  canCancelRequest: Scalars['Boolean']['output'];
  /** Can delete the Organisation Unit */
  canDelete: Scalars['Boolean']['output'];
  /** Can edit organisation type */
  canEditOrganisationType: Scalars['Boolean']['output'];
  /** Can edit the parent of this Organisation Unit */
  canEditParent: Scalars['Boolean']['output'];
  /** Can edit the Organisation Unit settings */
  canEditSettings: Scalars['Boolean']['output'];
  /** Can Invite users to join this Organisation Unit */
  canInviteUsers: Scalars['Boolean']['output'];
  /** Can manage the workspace level variables (workspace only) */
  canManageVariables: Scalars['Boolean']['output'];
  /** Can request access the Organisation Unit */
  canRequest: Scalars['Boolean']['output'];
  /** Can run the workspace wizzard (workspace only) */
  canRunWizzard: Scalars['Boolean']['output'];
  /** Can see audit logs for this Organisation Unit */
  canSeeAuditLogs: Scalars['Boolean']['output'];
  /** Can see users who are invited to this Organisation Unit */
  canSeeInvites: Scalars['Boolean']['output'];
  /** Can see the Organisation Unit members */
  canSeeMembers: Scalars['Boolean']['output'];
  /** Can see the parent of this Organisation Unit */
  canSeeParent: Scalars['Boolean']['output'];
  /** Can see users who have requested access to this Organisation Unit */
  canSeeRequests: Scalars['Boolean']['output'];
  /** Can see the Organisation Unit settings */
  canSeeSettings: Scalars['Boolean']['output'];
  /** Can unarchive the Organisation Unit */
  canUnarchive: Scalars['Boolean']['output'];
  /**
   * Extended setting options - If more than one option per setting, that can be changed to one of these options
   * @deprecated Use Profile.wsSettingsOptions / Profile.orgSettingsOptions query instead
   */
  settingsOptions: Array<SettingsOptions>;
};

export type OrgUnitFields = {
  /** Unique identifier for Org Unit */
  id: Scalars['UxId']['output'];
  /** Name of Org Unit */
  name: Scalars['String']['output'];
  /** Type of Org Unit - O = Organisation, W = Workspace */
  recordType: Scalars['String']['output'];
};

/** Organisation Unit Identity provides user identity data for data that can vary between the users different organisations and workspaces (OrgUnits) */
export type OrgUnitIdentity = {
  __typename?: 'OrgUnitIdentity';
  /** Date and time when the user was accepted into this org unit */
  acceptedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Role assigned to the user in this organisation unit by way of cascading acc- can be null if no specific association has been made yet */
  assumedRole?: Maybe<Role>;
  /** Role specifically assigned to the user in this organisation unit - can be null if no specific association has been made yet */
  baseRole?: Maybe<Role>;
  /** user name in this organisation unit */
  name: Scalars['String']['output'];
  /** recive notifications */
  receiveNotifications: Scalars['Boolean']['output'];
};

/** An Organisation */
export type Organisation = OrgUnitFields & {
  __typename?: 'Organisation';
  /** Actions available to current user on this Organisation */
  actionsOnThisOrganisation?: Maybe<OrgUnitActions>;
  /** Time the organisation was archived. */
  archivedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Who archived the organisation. */
  archivedBy?: Maybe<User>;
  /** Billing Contact for the Organisation */
  billingContact?: Maybe<Scalars['String']['output']>;
  /**
   * Billing Type
   * @deprecated Service Model is deprecated and will be removed in future versions
   */
  billingType?: Maybe<BillingType>;
  /** Business Type */
  businessType?: Maybe<BusinessType>;
  /** Child Organisations */
  children: Array<Organisation>;
  /** Count of Child Organisations in this Organisation */
  childrenCount: Scalars['Int']['output'];
  /** Domain for the Organisation */
  domain?: Maybe<Scalars['String']['output']>;
  /**
   * Environment Type
   * @deprecated Service Model is deprecated and will be removed in future versions
   */
  environmentType?: Maybe<EnvironmentType>;
  /** Main Organisation Identifier */
  id: Scalars['UxId']['output'];
  /** Invites in this Organisation */
  invites: Array<InvitedUser>;
  /** Whether this organisation is archived (soft-deleted). */
  isArchived: Scalars['Boolean']['output'];
  /** Logo data URL for PDF rendering */
  logoDataUrl?: Maybe<Scalars['String']['output']>;
  /** Logo URL */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** current authenticated users membership */
  member?: Maybe<Member>;
  /** Meta data for Organisation */
  meta?: Maybe<Meta>;
  /** Organisation Name */
  name: Scalars['String']['output'];
  /** Organisation Type */
  organisationType?: Maybe<OrganisationType>;
  /** Parent Organisation */
  parentId?: Maybe<Scalars['UxId']['output']>;
  /**
   * Plan Type
   * @deprecated Service Model is deprecated and will be removed in future versions
   */
  planType?: Maybe<PlanType>;
  /** Primary brand color */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Primary Contact for the Organisation */
  primaryContact: Scalars['String']['output'];
  /** Record Type: O Organisation */
  recordType: Scalars['String']['output'];
  /** Requests in this Organisation */
  requests: Array<RequestUser>;
  /** Secondary brand color */
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /**
   * Service Model
   * @deprecated Service Model is deprecated and will be removed in future versions
   */
  serviceModel?: Maybe<ServiceModel>;
  /** Users with access to this organisations workspaces */
  users: Array<User>;
  /** Count of Users with access to this organisations workspaces */
  usersCount: Scalars['Int']['output'];
  /** Workspaces in this Organisation */
  workspaces: Array<Workspace>;
  /** Count of Workspaces in this Organisation */
  workspacesCount: Scalars['Int']['output'];
};


/** An Organisation */
export type OrganisationChildrenArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An Organisation */
export type OrganisationInvitesArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An Organisation */
export type OrganisationRequestsArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An Organisation */
export type OrganisationUsersArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  member_id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An Organisation */
export type OrganisationWorkspacesArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};

export enum OrganisationType {
  CydeaConsulting = 'CYDEA_CONSULTING',
  CydeaPlatform = 'CYDEA_PLATFORM',
  DirectCustomer = 'DIRECT_CUSTOMER',
  Partner = 'PARTNER',
  PartnerCustomer = 'PARTNER_CUSTOMER'
}

/** Organisation User actions are the actions the current authenticated user can perform on a user of the organisation */
export type OrganisationUserActions = {
  __typename?: 'OrganisationUserActions';
  /** Authenticated User can edit the profile of listed user for this organisation */
  canEditProfile: Scalars['Boolean']['output'];
  /** Authenticated User can grant access to listed user for this organisation */
  canGrantAccess: Scalars['Boolean']['output'];
  /** Authenticated User can grant admin privilege to listed user for this organisation */
  canGrantAdmin: Scalars['Boolean']['output'];
  /** Authenticated User can remove listed user from this organisation */
  canRemoveUser: Scalars['Boolean']['output'];
  /** Authenticated User can revoke access to listed user for this organisation */
  canRevokeAccess: Scalars['Boolean']['output'];
  /** Authenticated User can revoke admin privilege to listed user for this organisation */
  canRevokeAdmin: Scalars['Boolean']['output'];
};

/** Person responsible for some asset within the workspace */
export type Owner = {
  __typename?: 'Owner';
  /** Email address for the owner - in cases where the owner is a registered user or is subsequently invited to be a user */
  email?: Maybe<Scalars['String']['output']>;
  /** Identifying string for the owner - has the format workspaceId:text:email based on information available when created */
  id?: Maybe<Scalars['String']['output']>;
  /** ID of the invite record - if the owner is not a registered user */
  inviteId?: Maybe<Scalars['UxId']['output']>;
  /** ID of the member record - if the owner is a registered user */
  memberId?: Maybe<Scalars['UxId']['output']>;
  /** Path to Profile Image. */
  profilePhotoPath?: Maybe<Scalars['String']['output']>;
  /** Identifying text for the owner - usually the name - but could be a role or other identifier */
  text?: Maybe<Scalars['String']['output']>;
};

/** Owner option backed by OrganisationUser (UX ID only). */
export type OwnerFilterOption = {
  __typename?: 'OwnerFilterOption';
  count?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  unifiedKey: Scalars['UnifiedKey']['output'];
};

/** Person responsible for some asset within the workspace */
export type OwnerInput = {
  /** Email address for the owner - in cases where the owner is a registered user or is subsequently invited to be a user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Identifying string for the owner - has the format workspaceId:text:email based on information available when created */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ID of the invite record - if the owner is not a registered user */
  inviteId?: InputMaybe<Scalars['UxId']['input']>;
  /** ID of the member record - if the owner is a registered user */
  memberId?: InputMaybe<Scalars['UxId']['input']>;
  /** Path to Profile Image. */
  profilePhotoPath?: InputMaybe<Scalars['String']['input']>;
  /** Identifying text for the owner - usually the name - but could be a role or other identifier */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Permissions of a person who utilizes this application (array format). */
export type Permission = {
  __typename?: 'Permission';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Permissions of a person who utilizes this application (object format) */
export type Permissions = {
  __typename?: 'Permissions';
  canCreateChild: Scalars['Boolean']['output'];
  canCreateOrganisation: Scalars['Boolean']['output'];
  canCreateWorkspace: Scalars['Boolean']['output'];
  canEditUsers: Scalars['Boolean']['output'];
  canExportCsv: Scalars['Boolean']['output'];
  canExportPdf: Scalars['Boolean']['output'];
  canManageUsers: Scalars['Boolean']['output'];
  isPartnerAdmin: Scalars['Boolean']['output'];
  isPlatformAdmin: Scalars['Boolean']['output'];
};

export enum PlanType {
  EnterprisePlan = 'ENTERPRISE_PLAN',
  ProfessionalPlan = 'PROFESSIONAL_PLAN',
  RmpOnly = 'RMP_ONLY',
  StarterPlan = 'STARTER_PLAN'
}

/** Authenticated User and their environment */
export type Profile = {
  __typename?: 'Profile';
  /** The Organisation to which the active Workspace belongs, or users main organisation if active workspace is null */
  activeOrganisation?: Maybe<Organisation>;
  /** The Active Workspace for this user */
  activeWorkspace?: Maybe<Workspace>;
  /** Feature flag Status for the active workspace */
  features: Array<FeatureFlag>;
  /** Organisation Settings Options - check OrgUnitActions.canEditOrganisationType for edit permission */
  orgSettingsOptions: Array<OrgSettingsOptions>;
  /** Permissions of the user in active workspace */
  permissions: Permissions;
  /** Terms & Conditions for the active workspace */
  terms: Terms;
  /** The active authenticated user */
  user: User;
  /** Signature for user flow integration */
  userFlowSignature: Scalars['String']['output'];
  /** Workspace Settings Options */
  wsSettingsOptions: WsSettingsOptions;
};

/** Projected Risk after all controls applied */
export type ProjectedRisk = {
  __typename?: 'ProjectedRisk';
  /**
   * Projected expected loss after all controls applied
   * @deprecated Use ScenarioRisk. ProjectedRisk is deprecated and will be removed in a future release.
   */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
  /** Number of times the risk is expected to occur */
  frequencyTimes?: Maybe<Scalars['Int']['output']>;
  /** Period of time for the frequency times */
  frequencyYears?: Maybe<Scalars['Int']['output']>;
  /** Lower estimate of the monetary cost of the event */
  lower?: Maybe<Scalars['BigNumber']['output']>;
  /** low values can affect the graph */
  lowerThanMinimum?: Maybe<Scalars['String']['output']>;
  /** loss simulation for graph */
  simLosses?: Maybe<Scalars['SimLosses']['output']>;
  /** Upper estimate of the monetary cost of the event */
  upper?: Maybe<Scalars['BigNumber']['output']>;
};

/** Indicates what fields are available at the top level of a query operation. */
export type Query = {
  __typename?: 'Query';
  /** Returns Action events for a specific object (e.g., ASSESSMENT, SCENARIO, CONTROL, INCIDENT). */
  actionsForObject: Array<Event>;
  /** Find a single assessment by an identifying attribute. */
  assessment?: Maybe<Assessment>;
  /** List multiple assessments */
  assessments: Array<Assessment>;
  /** Get Control Frameworks with compliance data for workspace */
  complianceFrameworks: Array<ComplianceFramework>;
  /** Single Control */
  control?: Maybe<Control>;
  /** Get Control Frameworks */
  controlFrameworks: Array<ControlFramework>;
  /** List Controls for Workspace */
  controls: Array<Control>;
  controlsByFilters: Array<Control>;
  /** Dashboard for a Workspace */
  dashboard: Dashboard;
  /** Single Event by ID */
  event?: Maybe<Event>;
  /** List of Event Types and their options */
  eventTypes: Array<EventType>;
  /** List Events for Workspace */
  events: Array<Event>;
  /** List of Events for object */
  eventsForObject: Array<Event>;
  /** Retrieve an export job by X-Export-Auth token header */
  exportJob: ExportJob;
  /** Feature Flags */
  features: Array<Feature>;
  /**
   * Step 2: get the filter options for a specific object.
   * For now, only CONTROLS is implemented (others return null in ObjectFilterSets).
   */
  filtersFor: ObjectFilterSets;
  /**
   * Step 1: discover which filterable objects exist for this workspace.
   * This enables the flow: query filters -> see available objects -> pick one.
   */
  filtersOverview: Array<FilterObjectSummary>;
  /** Flat list of Organisations and workspaces with child IDs */
  flatOrganisations: Array<FlatOrganisation>;
  /** Get Framework Control */
  frameworkControl?: Maybe<FrameworkControl>;
  /** Single Incident */
  incident?: Maybe<Incident>;
  /** List Incidents for Workspace */
  incidents: Array<Incident>;
  /** Check available Roles settings for inviting users to an org unit */
  inviteRoles: InvitedUserRoles;
  /** Single Member */
  member?: Maybe<Member>;
  /** List export jobs for the authenticated user, plus shared jobs in their active workspace */
  myExportJobs: Array<ExportJob>;
  /** Single Organisation */
  organisation?: Maybe<Organisation>;
  /** Choose a branch from the hierarchy */
  organisationHierarchy?: Maybe<Organisation>;
  /** Fetch a single organisation by ID, including archived (soft-deleted) organisations. Only accessible to platform admins. */
  organisationWithArchived?: Maybe<Organisation>;
  /** List multiple Organisations starting from topmost available parents */
  organisationsHierarchy: Array<Organisation>;
  /** Fetch all organisations, including archived (soft-deleted) ones. Only accessible to platform admins. */
  organisationsWithArchived: Array<Organisation>;
  /** Get the authenticated user and environment */
  profile: Profile;
  /** Find a single scenario by ID, optionally from a version snapshot */
  scenario?: Maybe<Scenario>;
  /**
   * Scenario packs available in the current workspace:
   * - Global packs (like Common)
   * - Workspace-specific packs (if any)
   */
  scenarioGroups: Array<ScenarioGroup>;
  /** Find a single Scenario Template by id */
  scenarioTemplate?: Maybe<ScenarioTemplate>;
  /** List multiple Scenario Templates */
  scenarioTemplates: Array<ScenarioTemplate>;
  /** List multiple Scenario Templates */
  scenarioTemplatesEloquent: Array<ScenarioTemplate>;
  /** List multiple scenarios for assessment */
  scenarios: Array<Scenario>;
  /** Retrieves the timeline for the active workspace based on filters like events, owners, and object names. */
  timeline: TimelineResponse;
  /** Retrieves upcoming actions from the timeline (next 90 days), including future events like control go-live and review dates. */
  upcomingActions: TimelineResponse;
  /** Find a single user by an identifying attribute. */
  user?: Maybe<User>;
  /** List multiple users - with pagination. */
  users: Array<User>;
  /** List all Variable Settings (Platform Admin only) */
  variableSettings: Array<VariableSetting>;
  /** Get a point-in-time snapshot of a Risk Assessment */
  version: Version;
  /** Single Workspace */
  workspace?: Maybe<Workspace>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryActionsForObjectArgs = {
  objectId: Scalars['UxId']['input'];
  objectType: ObjectKind;
  onlyOpen?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAssessmentArgs = {
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAssessmentsArgs = {
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryComplianceFrameworksArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryControlArgs = {
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryControlFrameworksArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryControlsArgs = {
  controlIds?: InputMaybe<Array<Scalars['UxId']['input']>>;
  selection?: InputMaybe<ControlSelectionInput>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryControlsByFiltersArgs = {
  selection: ControlFiltersSelectionInput;
  workspaceId: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryDashboardArgs = {
  assessmentId: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryEventArgs = {
  id: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryEventsArgs = {
  completionStatus?: InputMaybe<EventCompletionStatus>;
  eventType?: InputMaybe<EventKind>;
  objectId?: InputMaybe<Scalars['UxId']['input']>;
  objectType?: InputMaybe<ObjectKind>;
  onlyOpen?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryEventsForObjectArgs = {
  objectId: Scalars['UxId']['input'];
  objectType: ObjectKind;
  onlyOpen?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFiltersForArgs = {
  includeCounts?: InputMaybe<Scalars['Boolean']['input']>;
  object: FilterObjectKey;
  workspaceId: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFiltersOverviewArgs = {
  workspaceId: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFlatOrganisationsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  memberEmail?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryFrameworkControlArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryIncidentArgs = {
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryIncidentsArgs = {
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryInviteRolesArgs = {
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  userEmail: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryMemberArgs = {
  memberEmail?: InputMaybe<Scalars['UxId']['input']>;
  orgUnitId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryOrganisationArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryOrganisationHierarchyArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryOrganisationWithArchivedArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryScenarioArgs = {
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryScenarioGroupsArgs = {
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryScenarioTemplateArgs = {
  id: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryScenarioTemplatesArgs = {
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryScenariosArgs = {
  assessmentId: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTimelineArgs = {
  filters?: InputMaybe<TimelineFilterInput>;
  workspaceId: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUpcomingActionsArgs = {
  filters?: InputMaybe<TimelineFilterInput>;
  workspaceId: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUsersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryVersionArgs = {
  id: Scalars['UxId']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryWorkspaceArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};

/** Assessment question responses */
export type QuestionAssessment = {
  __typename?: 'QuestionAssessment';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  review_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  started_date?: Maybe<Scalars['DateTimeUtc']['output']>;
};

/** Input type for QuestionAssessment. */
export type QuestionAssessmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  review_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  started_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
};

/** Cyber Insurance question responses */
export type QuestionCyberInsurance = {
  __typename?: 'QuestionCyberInsurance';
  cyberInsurance: Scalars['Boolean']['output'];
};

export type QuestionCyberInsuranceInput = {
  cyberInsurance: Scalars['Boolean']['input'];
};

/** Organisation question responses */
export type QuestionOrganisation = {
  __typename?: 'QuestionOrganisation';
  sector?: Maybe<Scalars['String']['output']>;
  usesManagedServiceProvider: Scalars['Boolean']['output'];
};

/** Input type for QuestionOrganisation. */
export type QuestionOrganisationInput = {
  sector?: InputMaybe<Scalars['String']['input']>;
  usesManagedServiceProvider: Scalars['Boolean']['input'];
};

/** Regulations question responses */
export type QuestionRegulations = {
  __typename?: 'QuestionRegulations';
  controlFrameworks: Array<Scalars['String']['output']>;
  controlFrameworksOther: Array<Scalars['String']['output']>;
  legislation: Array<Scalars['String']['output']>;
  pinnedControlFrameworks: Array<Scalars['String']['output']>;
  primaryControlFramework?: Maybe<Scalars['String']['output']>;
  primaryFrameworkControls: Array<Scalars['String']['output']>;
};

/** Input type for QuestionRegulations. */
export type QuestionRegulationsInput = {
  controlFrameworks: Array<Scalars['String']['input']>;
  controlFrameworksOther: Array<Scalars['String']['input']>;
  legislation: Array<Scalars['String']['input']>;
  pinnedControlFrameworks: Array<Scalars['String']['input']>;
  primaryControlFramework?: InputMaybe<Scalars['String']['input']>;
  primaryFrameworkControls: Array<Scalars['String']['input']>;
};

/** Wizard Scenarios question responses */
export type QuestionScenarios = {
  __typename?: 'QuestionScenarios';
  B2B: Scalars['Boolean']['output'];
  B2C: Scalars['Boolean']['output'];
  aiCustomerFacingApp: Scalars['Boolean']['output'];
  aiThirdPartyReliant: Scalars['Boolean']['output'];
  cniOrDefenseInvolvement: Scalars['Boolean']['output'];
  operationalTechnology: Scalars['Boolean']['output'];
  paymentVolumeOrValue: Scalars['Boolean']['output'];
  publiclyAccessibleInternetBusiness: Scalars['Boolean']['output'];
  regulated: Scalars['Boolean']['output'];
  significantDataInCloud: Scalars['Boolean']['output'];
  significantITContributionToRevenue: Scalars['Boolean']['output'];
  significantRandD: Scalars['Boolean']['output'];
  softwareBusiness: Scalars['Boolean']['output'];
  supplyChainReliant: Scalars['Boolean']['output'];
};

/** Input type for Wizard Scenario Questions. */
export type QuestionScenariosInput = {
  B2B: Scalars['Boolean']['input'];
  B2C: Scalars['Boolean']['input'];
  aiCustomerFacingApp: Scalars['Boolean']['input'];
  aiThirdPartyReliant: Scalars['Boolean']['input'];
  cniOrDefenseInvolvement: Scalars['Boolean']['input'];
  operationalTechnology: Scalars['Boolean']['input'];
  paymentVolumeOrValue: Scalars['Boolean']['input'];
  publiclyAccessibleInternetBusiness: Scalars['Boolean']['input'];
  regulated: Scalars['Boolean']['input'];
  significantDataInCloud: Scalars['Boolean']['input'];
  significantITContributionToRevenue: Scalars['Boolean']['input'];
  significantRandD: Scalars['Boolean']['input'];
  softwareBusiness: Scalars['Boolean']['input'];
  supplyChainReliant: Scalars['Boolean']['input'];
};

/** Software Development question responses */
export type QuestionSoftwareDev = {
  __typename?: 'QuestionSoftwareDev';
  developsSoftware: Scalars['Boolean']['output'];
};

/** Input type for QuestionSoftwareDev. */
export type QuestionSoftwareDevInput = {
  developsSoftware: Scalars['Boolean']['input'];
};

/** Responses to questions about the organisation's cyber security practices. */
export type Questions = {
  __typename?: 'Questions';
  assessment?: Maybe<QuestionAssessment>;
  cyberInsurance?: Maybe<QuestionCyberInsurance>;
  organisation?: Maybe<QuestionOrganisation>;
  regulations?: Maybe<QuestionRegulations>;
  scenarios?: Maybe<QuestionScenarios>;
  softwareDev?: Maybe<QuestionSoftwareDev>;
};

/** Input type for Questions. */
export type QuestionsInput = {
  assessment?: InputMaybe<QuestionAssessmentInput>;
  cyberInsurance?: InputMaybe<QuestionCyberInsuranceInput>;
  organisation?: InputMaybe<QuestionOrganisationInput>;
  regulations?: InputMaybe<QuestionRegulationsInput>;
  scenarios?: InputMaybe<QuestionScenariosInput>;
  softwareDev?: InputMaybe<QuestionSoftwareDevInput>;
};

export type RecommendedModifier = {
  __typename?: 'RecommendedModifier';
  /** Modifier data */
  data?: Maybe<RecommendedModifierData>;
  /** Modifier type */
  type?: Maybe<Scalars['String']['output']>;
};

export type RecommendedModifierData = {
  __typename?: 'RecommendedModifierData';
  /** Percentage or value indicator */
  isPercentage?: Maybe<Scalars['Boolean']['output']>;
  /** Lower bound adjustment */
  lower?: Maybe<Scalars['Int']['output']>;
  /** Upper bound adjustment */
  upper?: Maybe<Scalars['Int']['output']>;
  /** Value for frequency reduction or other adjustments */
  value?: Maybe<Scalars['Int']['output']>;
};

/** Specifics about the request to join the workspace */
export type Request = {
  __typename?: 'Request';
  /** The date the user's request was accepted - should be null for active requests - may be used in future for views of historical requests */
  acceptedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** The name used to identify the user before they exist in the workspace - subsequently an alternate name for the user in this workspace */
  aka?: Maybe<Scalars['String']['output']>;
  /** Record creation timestamp */
  createdAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** The unique identifier for the request */
  id?: Maybe<Scalars['UxId']['output']>;
  /** The identifier of the requested org unit (workspace or organisation) */
  orgUnitId?: Maybe<Scalars['UxId']['output']>;
  /** The name of the requested org unit (workspace or organisation) */
  orgUnitName?: Maybe<Scalars['String']['output']>;
  /** The Type of the requested org unit (workspace or organisation) */
  orgUnitType?: Maybe<Scalars['String']['output']>;
  /** The organisation identifier of the requested workspace */
  organisationId?: Maybe<Scalars['UxId']['output']>;
  /** The organisation name of the requested workspace */
  organisationName?: Maybe<Scalars['UxId']['output']>;
  /** The date the user requested to join the workspace */
  requestedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Record creation timestamp */
  updatedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** The requesting user's email */
  userEmail?: Maybe<Scalars['UxId']['output']>;
  /** The requesting user's ID */
  userId?: Maybe<Scalars['Int']['output']>;
  /** The requesting user's name */
  userName?: Maybe<Scalars['UxId']['output']>;
  /** The identifier of requested workspace */
  workspaceId?: Maybe<Scalars['UxId']['output']>;
  /** The name of the requested workspace */
  workspaceName?: Maybe<Scalars['UxId']['output']>;
};

/** Some type of user (existing or prospective) that has been requestd to a workspace */
export type RequestUser = {
  __typename?: 'RequestUser';
  /** The email address of the user */
  email?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the user - ids above 1000000 indicate a user that is not yet registered */
  id?: Maybe<Scalars['Int']['output']>;
  /** The main name of the user */
  name?: Maybe<Scalars['String']['output']>;
  /** Path to Profile Image. */
  profilePhotoPath?: Maybe<Scalars['String']['output']>;
  /** Specifics about the request */
  request?: Maybe<Request>;
  /** The workspace name the user is requestd to - maybe only needed for BE (notifications) */
  workspaceName?: Maybe<Scalars['String']['output']>;
  /** The name of the user in this workspace - legacy - orgUnitIdentity is the new approach but may not make sense at the request stage */
  workspaceUserName?: Maybe<Scalars['String']['output']>;
};

export enum ReviewCadence {
  Annually = 'ANNUALLY',
  Biannually = 'BIANNUALLY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Quarterly = 'QUARTERLY'
}

export enum RiskConsequence {
  BusinessDisruption = 'BUSINESS_DISRUPTION',
  DamagedInvestorRelations = 'DAMAGED_INVESTOR_RELATIONS',
  DamagedRegulatorRelations = 'DAMAGED_REGULATOR_RELATIONS',
  DamagedReputation = 'DAMAGED_REPUTATION',
  EmbarrassingReporting = 'EMBARRASSING_REPORTING',
  EnvironmentalHarm = 'ENVIRONMENTAL_HARM',
  IncreasedCostsInefficiency = 'INCREASED_COSTS_INEFFICIENCY',
  IneffectiveChange = 'INEFFECTIVE_CHANGE',
  LegalChallenge = 'LEGAL_CHALLENGE',
  LossOfSuppliers = 'LOSS_OF_SUPPLIERS',
  MedicalHarm = 'MEDICAL_HARM',
  NonCompliance = 'NON_COMPLIANCE',
  PoorConductIntegrity = 'POOR_CONDUCT_INTEGRITY',
  ReducedAccessToStaffSkills = 'REDUCED_ACCESS_TO_STAFF_SKILLS',
  ReducedGrowth = 'REDUCED_GROWTH',
  RegulatoryFines = 'REGULATORY_FINES',
  SafetyFailure = 'SAFETY_FAILURE',
  SlowRecovery = 'SLOW_RECOVERY',
  SocialHarm = 'SOCIAL_HARM',
  TheftOfMoney = 'THEFT_OF_MONEY',
  UnplannedCosts = 'UNPLANNED_COSTS'
}

export enum RiskEvent {
  AccessToOurSystemBreach = 'ACCESS_TO_OUR_SYSTEM_BREACH',
  AuditFailure = 'AUDIT_FAILURE',
  Bribes = 'BRIBES',
  ChildSexualViolentContent = 'CHILD_SEXUAL_VIOLENT_CONTENT',
  ComplianceFailure = 'COMPLIANCE_FAILURE',
  ControlSystemBypass = 'CONTROL_SYSTEM_BYPASS',
  CriticalVulnerabilityPublished = 'CRITICAL_VULNERABILITY_PUBLISHED',
  CrossSiteScripting = 'CROSS_SITE_SCRIPTING',
  Dialler = 'DIALLER',
  DistributedDenialOfService = 'DISTRIBUTED_DENIAL_OF_SERVICE',
  FalseRepresentation = 'FALSE_REPRESENTATION',
  FileInclusion = 'FILE_INCLUSION',
  Harassment = 'HARASSMENT',
  HarmfulSpeech = 'HARMFUL_SPEECH',
  InformationBreach = 'INFORMATION_BREACH',
  Lies = 'LIES',
  MisappropriationMisuseOfResources = 'MISAPPROPRIATION_MISUSE_OF_RESOURCES',
  NetworkScanning = 'NETWORK_SCANNING',
  NetworkSniffing = 'NETWORK_SNIFFING',
  OpensourceIntelligenceAnalysis = 'OPENSOURCE_INTELLIGENCE_ANALYSIS',
  PasswordBruteforce = 'PASSWORD_BRUTEFORCE',
  Phishing = 'PHISHING',
  ProcessFailure = 'PROCESS_FAILURE',
  Ransomware = 'RANSOMWARE',
  Rootkit = 'ROOTKIT',
  RulesChange = 'RULES_CHANGE',
  Sabotage = 'SABOTAGE',
  ServiceCompromise = 'SERVICE_COMPROMISE',
  ServiceUnavailability = 'SERVICE_UNAVAILABILITY',
  SoftwareExploit = 'SOFTWARE_EXPLOIT',
  Spyware = 'SPYWARE',
  SqlInjection = 'SQL_INJECTION',
  TheftOfMoney = 'THEFT_OF_MONEY',
  Threats = 'THREATS',
  UnauthorisedAccessToInformation = 'UNAUTHORISED_ACCESS_TO_INFORMATION',
  UnauthorisedAccessToSystemComponent = 'UNAUTHORISED_ACCESS_TO_SYSTEM_COMPONENT',
  UnauthorisedDeletionOfInformation = 'UNAUTHORISED_DELETION_OF_INFORMATION',
  UnauthorisedModificationOfInformation = 'UNAUTHORISED_MODIFICATION_OF_INFORMATION',
  UnauthorisedSharingOfInformation = 'UNAUTHORISED_SHARING_OF_INFORMATION',
  UseOfStolenCredentials = 'USE_OF_STOLEN_CREDENTIALS',
  Worm = 'WORM'
}

/** Risk Managed by the application of controls */
export type RiskManagementPlan = {
  __typename?: 'RiskManagementPlan';
  /** The attached Control */
  control?: Maybe<Control>;
  /** RMP identifier */
  id: Scalars['UxId']['output'];
  /** Meta data */
  meta?: Maybe<Meta>;
  /** A set of Modifiers that may adjust the expected loss calculation as a result of the control */
  modifiers: Array<Modifier>;
  /** Order of this RMP within the Scenario */
  order?: Maybe<Scalars['Int']['output']>;
  /** A set of Recommended Modifiers that can be applied for this control */
  recommendedModifiers: Array<RecommendedModifier>;
  /** The Scenario the RMP is associated with */
  scenario?: Maybe<Scenario>;
  /** Starting frequency for this RMP */
  startingFrequency?: Maybe<Scalars['Float']['output']>;
  /** Starting lower consequence for this RMP */
  startingLower?: Maybe<Scalars['BigNumber']['output']>;
  /** Starting upper consequence for this RMP */
  startingUpper?: Maybe<Scalars['BigNumber']['output']>;
};

export enum RiskSource {
  Accidental = 'ACCIDENTAL',
  Coerced = 'COERCED',
  Competitor = 'COMPETITOR',
  Compromised = 'COMPROMISED',
  Criminal = 'CRIMINAL',
  Criminals = 'CRIMINALS',
  Disgruntled = 'DISGRUNTLED',
  Hacktivists = 'HACKTIVISTS',
  Ineffective = 'INEFFECTIVE',
  Press = 'PRESS',
  Regulator = 'REGULATOR',
  Researcher = 'RESEARCHER',
  StateSponsored = 'STATE_SPONSORED'
}

export enum Role {
  Collaborator = 'COLLABORATOR',
  CustomerManager = 'CUSTOMER_MANAGER',
  NoAccess = 'NO_ACCESS',
  OrganisationAdmin = 'ORGANISATION_ADMIN',
  PartnerBranchAdmin = 'PARTNER_BRANCH_ADMIN',
  PlatformAdmin = 'PLATFORM_ADMIN',
  WorkspaceAdmin = 'WORKSPACE_ADMIN'
}

/** Risk scenario being assessed */
export type Scenario = {
  __typename?: 'Scenario';
  /** Actions for this scenario */
  actions: Array<Event>;
  /** Parent assessment */
  assessment: Assessment;
  /** Base Risk */
  baseRisk: ScenarioRisk;
  /** Consequence type */
  consequence?: Maybe<Scalars['Int']['output']>;
  /** Some note space to describe the consequence */
  consequenceNote?: Maybe<Scalars['String']['output']>;
  /** Short description for the scenario/template */
  description?: Maybe<Scalars['String']['output']>;
  /** Edited at date - may be moved to the Meta type */
  editedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Event type */
  event?: Maybe<Scalars['Int']['output']>;
  /** Some note space to describe the frequency */
  frequencyNote?: Maybe<Scalars['String']['output']>;
  /** Primary group name for this scenario in the library */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Scenario identifier */
  id: Scalars['UxId']['output'];
  /** linked incidents */
  incidents: Array<Incident>;
  /** completion state (can expected los be calculated) */
  isIncomplete?: Maybe<CompletionState>;
  /** loss calculation can be broken by variable changes */
  isLossValid?: Maybe<Scalars['String']['output']>;
  /** Live Risk - equivalent to existing live variant */
  liveRisk: ScenarioRisk;
  /** Lower estimate formula */
  lowerFormula?: Maybe<Scalars['String']['output']>;
  /** Some note space for risk management details */
  managementNote?: Maybe<Scalars['String']['output']>;
  /** Chosen strategy for managing risk - Tolerate - Treat - Transfer - Terminate */
  managementStrategy?: Maybe<Scalars['String']['output']>;
  /** Meta data for Scenario */
  meta?: Maybe<Meta>;
  /** A name identifying the Scenario */
  name?: Maybe<Scalars['String']['output']>;
  /** Scenario owner email */
  ownerEmail?: Maybe<Scalars['String']['output']>;
  /** Owner of the Scenario */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Projected Risk - equivalent to existing complete variant */
  projectedRisk: ScenarioRisk;
  /** A user reference for comparing Scenario versions */
  referenceId?: Maybe<Scalars['String']['output']>;
  /** Date risk should be reviewed */
  reviewDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Date risk was identified */
  riskIdentifiedDate?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** now known as linked controls */
  riskManagementPlans: Array<RiskManagementPlan>;
  /** Narrative describing the risk */
  riskNarrative?: Maybe<Scalars['String']['output']>;
  /** Owner of the risk */
  riskOwner?: Maybe<Owner>;
  /** Source of the event being modeled */
  source?: Maybe<Scalars['Int']['output']>;
  /** Status of the Scenario */
  status?: Maybe<Scalars['String']['output']>;
  /** Upper estimate formula */
  upperFormula?: Maybe<Scalars['String']['output']>;
};


/** Risk scenario being assessed */
export type ScenarioActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedToId?: InputMaybe<Scalars['UxId']['input']>;
  completionStatus?: InputMaybe<EventCompletionStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScenarioFields = {
  /** The consequence arising from the event being modeled */
  consequence?: Maybe<Scalars['Int']['output']>;
  /** Some note space to describe the consequence */
  consequence_note?: Maybe<Scalars['String']['output']>;
  /** The event being modeled */
  event?: Maybe<Scalars['Int']['output']>;
  /** The monetary loss predicted by the scenario */
  expected_loss?: Maybe<Scalars['Float']['output']>;
  /** Some note space to describe the frequency */
  frequency_note?: Maybe<Scalars['String']['output']>;
  /** A number of times the event is predicted to occur */
  frequency_times?: Maybe<Scalars['Int']['output']>;
  /** A basis for the number of times */
  frequency_years?: Maybe<Scalars['Int']['output']>;
  /** Lower estimate of the monetary cost of the event */
  lower?: Maybe<Scalars['Int']['output']>;
  /** Lower estimate formula */
  lower_formula?: Maybe<Scalars['String']['output']>;
  /** Some note space for risk management details */
  management_note?: Maybe<Scalars['String']['output']>;
  /** Chosen strategy for managing risk - Tolerate - Treat - Transfer - Terminate */
  management_strategy?: Maybe<Scalars['String']['output']>;
  /** A name identifying the Scenario */
  name?: Maybe<Scalars['String']['output']>;
  /** A narrative description of the risk */
  risk_narrative?: Maybe<Scalars['String']['output']>;
  /** The person responsible for handling the risk */
  risk_owner?: Maybe<Scalars['String']['output']>;
  /** Source of the event being modeled */
  source?: Maybe<Scalars['Int']['output']>;
  /** Upper estimate of the monetary cost of the event */
  upper?: Maybe<Scalars['Int']['output']>;
  /** Upper estimate formula */
  upper_formula?: Maybe<Scalars['String']['output']>;
};

export type ScenarioGroup = {
  __typename?: 'ScenarioGroup';
  /** Author name used in tables / metadata */
  author?: Maybe<Scalars['String']['output']>;
  /** URL or path to the author logo */
  authorLogoPath?: Maybe<Scalars['String']['output']>;
  /** Optional high-level category (Technology, Health Care, Banks, etc.) */
  category?: Maybe<Scalars['String']['output']>;
  /** Optional free-text description shown on the tile and metadata box */
  description?: Maybe<Scalars['String']['output']>;
  /** Feature flag key controlling scenario pack visibility */
  featureKey?: Maybe<Scalars['String']['output']>;
  /** Group identifier */
  id: Scalars['UxId']['output'];
  /** Whether this version is the current visible version of the pack */
  isCurrentVersion?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is a system/global group (Cydea pack) */
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  /** Created/updated metadata for this scenario pack */
  meta?: Maybe<Meta>;
  /** Name of the pack (Common, Telecommunications, etc.) */
  name: Scalars['String']['output'];
  /** Scenarios explicitly assigned to this pack + global templates (for Common) */
  scenarios: Array<Scenario>;
  /** User who created this version */
  versionCreatedBy?: Maybe<Scalars['String']['output']>;
  /** Scenario pack version number */
  versionNumber?: Maybe<Scalars['Int']['output']>;
  /** All non-deleted versions for this scenario pack */
  versions: Array<ScenarioGroup>;
};

export type ScenarioGroupImportInput = {
  group: ScenarioPackGroupImportInput;
  scenarios: Array<ScenarioPackScenarioImportInput>;
};

export type ScenarioInput = {
  /** Consequence type */
  consequence?: InputMaybe<Scalars['Int']['input']>;
  /** Some note space to describe the consequence */
  consequenceNote?: InputMaybe<Scalars['String']['input']>;
  /** Event type */
  event?: InputMaybe<Scalars['Int']['input']>;
  /** Some note space to describe the frequency */
  frequencyNote?: InputMaybe<Scalars['String']['input']>;
  /** Number of times the risk is expected to occur */
  frequencyTimes?: InputMaybe<Scalars['Int']['input']>;
  /** Period of time for the frequency times */
  frequencyYears?: InputMaybe<Scalars['Int']['input']>;
  /** Scenario identifier */
  id?: InputMaybe<Scalars['UxId']['input']>;
  lower?: InputMaybe<Scalars['BigNumber']['input']>;
  /** formula or expected loss lower limit */
  lowerFormula?: InputMaybe<Scalars['String']['input']>;
  /** Some note space for risk management details */
  managementNote?: InputMaybe<Scalars['String']['input']>;
  /** Chosen strategy for managing risk - Tolerate - Treat - Transfer - Terminate */
  managementStrategy?: InputMaybe<Scalars['String']['input']>;
  /** A name identifying the Scenario */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A user reference for comparing Scenario versions */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** Date risk should be reviewed */
  reviewDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  /** Date risk was identified */
  riskIdentifiedDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  /** Narrative describing the risk */
  riskNarrative?: InputMaybe<Scalars['String']['input']>;
  /** Owner of the risk */
  riskOwner?: InputMaybe<OwnerInput>;
  /** Source of the risk being modeled */
  source?: InputMaybe<Scalars['Int']['input']>;
  /** Status of the Scenario */
  status?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['BigNumber']['input']>;
  /** formula or expected loss upper limit */
  upperFormula?: InputMaybe<Scalars['String']['input']>;
};

export type ScenarioPackGroupImportInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  authorLogoPath?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UxId']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type ScenarioPackScenarioImportInput = {
  consequence?: InputMaybe<Scalars['Int']['input']>;
  consequenceNote?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['Int']['input']>;
  frequencyNote?: InputMaybe<Scalars['String']['input']>;
  frequencyTimes?: InputMaybe<Scalars['Int']['input']>;
  frequencyYears?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UxId']['input']>;
  lower?: InputMaybe<Scalars['Int']['input']>;
  lowerFormula?: InputMaybe<Scalars['String']['input']>;
  managementNote?: InputMaybe<Scalars['String']['input']>;
  managementStrategy?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reviewDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  riskIdentifiedDate?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  riskNarrative?: InputMaybe<Scalars['String']['input']>;
  riskOwner?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  upper?: InputMaybe<Scalars['Int']['input']>;
  upperFormula?: InputMaybe<Scalars['String']['input']>;
};

/** Risk modelled by the Scenario */
export type ScenarioRisk = {
  __typename?: 'ScenarioRisk';
  /** Chart coordinates for graph */
  chart: Array<ChartCoordinate>;
  /** Calculated expected loss based on upper and lower estimates and frequency */
  expectedLoss?: Maybe<Scalars['Float']['output']>;
  /** Number of times the risk is expected to occur */
  frequencyTimes?: Maybe<Scalars['Int']['output']>;
  /** Period of time for the frequency times */
  frequencyYears?: Maybe<Scalars['Int']['output']>;
  /** Lower estimate of the monetary cost of the event */
  lower?: Maybe<Scalars['BigNumber']['output']>;
  /** low values can affect the graph */
  lowerThanMinimum?: Maybe<Scalars['String']['output']>;
  /** Upper estimate of the monetary cost of the event */
  upper?: Maybe<Scalars['BigNumber']['output']>;
};

export enum ScenarioStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

/** Templates from which new Scenarios can be based */
export type ScenarioTemplate = {
  __typename?: 'ScenarioTemplate';
  /** Author of the template */
  author?: Maybe<Scalars['String']['output']>;
  consequence?: Maybe<Scalars['Int']['output']>;
  consequenceNote?: Maybe<Scalars['String']['output']>;
  /** Describes the template */
  description?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['Int']['output']>;
  expectedLoss?: Maybe<Scalars['Float']['output']>;
  frequencyNote?: Maybe<Scalars['String']['output']>;
  frequencyTimes?: Maybe<Scalars['Int']['output']>;
  frequencyYears?: Maybe<Scalars['Int']['output']>;
  /** Name of the scenario group this template belongs to (if any) */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Scenario Template primary key */
  id: Scalars['UxId']['output'];
  lower?: Maybe<Scalars['Int']['output']>;
  lowerFormula?: Maybe<Scalars['String']['output']>;
  managementNote?: Maybe<Scalars['String']['output']>;
  managementStrategy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated please use consequenceNote instead */
  note?: Maybe<Scalars['String']['output']>;
  riskNarrative?: Maybe<Scalars['String']['output']>;
  riskOwner?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['Int']['output']>;
  upper?: Maybe<Scalars['Int']['output']>;
  upperFormula?: Maybe<Scalars['String']['output']>;
};

/** Lightweight option item used in filters */
export type SelectionOptionInput = {
  enabled: Scalars['Boolean']['input'];
  unifiedKey: Scalars['UnifiedKey']['input'];
};

export enum ServiceModel {
  ConsultingOnly = 'CONSULTING_ONLY',
  PlatformAndConsulting = 'PLATFORM_AND_CONSULTING',
  PlatformOnly = 'PLATFORM_ONLY'
}

export type SettingsOptions = {
  __typename?: 'SettingsOptions';
  billingType?: Maybe<Array<BillingType>>;
  businessType?: Maybe<Array<BusinessType>>;
  environmentType?: Maybe<Array<EnvironmentType>>;
  organisationType?: Maybe<OrganisationType>;
  planType?: Maybe<Array<PlanType>>;
  serviceModel?: Maybe<Array<ServiceModel>>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

/** Generic option for string-valued facets (e.g., strategy, status). */
export type StringFilterOption = {
  __typename?: 'StringFilterOption';
  count?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  unifiedKey: Scalars['UnifiedKey']['output'];
};

/** Terms & Conditions */
export type Terms = {
  __typename?: 'Terms';
  can_defer?: Maybe<Scalars['Boolean']['output']>;
  defer_expires?: Maybe<Scalars['DateTimeUtc']['output']>;
  organisation_id?: Maybe<Scalars['UxId']['output']>;
  organisation_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  terms_id?: Maybe<Scalars['UxId']['output']>;
  terms_url?: Maybe<Scalars['String']['output']>;
};

/** A group of timeline events occurring on a specific date. */
export type TimelineDay = {
  __typename?: 'TimelineDay';
  /** The date the events occurred (ISO 8601). */
  event_date: Scalars['String']['output'];
  /** List of events that happened on this day. */
  events: Array<TimelineEvent>;
  /** The index of the day in the timeline list. */
  index: Scalars['Int']['output'];
};

/** An individual event on the timeline. */
export type TimelineEvent = {
  __typename?: 'TimelineEvent';
  /** The structured payload of event-related data (e.g. control, scenario). */
  data: Scalars['JSON']['output'];
  /** The type of event. */
  type: TimelineEventType;
};

/** Represents the type of event shown in the timeline. */
export enum TimelineEventType {
  ActionsCompleted = 'ACTIONS_COMPLETED',
  ActionsDue = 'ACTIONS_DUE',
  /** Upcoming assessment review is due. */
  FutureAssessmentReviewDue = 'FUTURE_ASSESSMENT_REVIEW_DUE',
  /** Assessment start date is in the future. */
  FutureAssessmentStartDue = 'FUTURE_ASSESSMENT_START_DUE',
  /** Control is expected to go live (actual future date). */
  FutureControlDueLiveActual = 'FUTURE_CONTROL_DUE_LIVE_ACTUAL',
  /** Control is expected to go live in the future (based on expected date). */
  FutureControlDueLiveExpected = 'FUTURE_CONTROL_DUE_LIVE_EXPECTED',
  /** Upcoming control review is due. */
  FutureControlReviewDue = 'FUTURE_CONTROL_REVIEW_DUE',
  /** Incident is scheduled to occur in the future. */
  FutureIncidentCreated = 'FUTURE_INCIDENT_CREATED',
  /** Risk identification is scheduled in the future. */
  FutureScenarioIdentified = 'FUTURE_SCENARIO_IDENTIFIED',
  /** Upcoming scenario review is due. */
  FutureScenarioReviewDue = 'FUTURE_SCENARIO_REVIEW_DUE',
  OpenActions = 'OPEN_ACTIONS',
  /** Assessment was created. */
  PastAssessmentCreated = 'PAST_ASSESSMENT_CREATED',
  /** Assessment review was due. */
  PastAssessmentReviewDue = 'PAST_ASSESSMENT_REVIEW_DUE',
  /** Assessment started. */
  PastAssessmentStarted = 'PAST_ASSESSMENT_STARTED',
  /** A version of the assessment was published. */
  PastAssessmentVersionPublished = 'PAST_ASSESSMENT_VERSION_PUBLISHED',
  /** Control was added to a scenario. */
  PastControlAddedToScenario = 'PAST_CONTROL_ADDED_TO_SCENARIO',
  /** Control was created. */
  PastControlCreated = 'PAST_CONTROL_CREATED',
  /** Control was last edited. */
  PastControlEdited = 'PAST_CONTROL_EDITED',
  /** Control review was due. */
  PastControlReviewDue = 'PAST_CONTROL_REVIEW_DUE',
  /** Control was expected to go live. */
  PastControlWasExpectedLive = 'PAST_CONTROL_WAS_EXPECTED_LIVE',
  /** Control went live (actual date). */
  PastControlWentLive = 'PAST_CONTROL_WENT_LIVE',
  /** Incident was recorded. */
  PastIncidentCreated = 'PAST_INCIDENT_CREATED',
  /** Scenario was added to an assessment. */
  PastScenarioAddedAssessment = 'PAST_SCENARIO_ADDED_ASSESSMENT',
  /** Scenario was created alongside assessment. */
  PastScenarioCreatedAssessment = 'PAST_SCENARIO_CREATED_ASSESSMENT',
  /** Scenario was last edited. */
  PastScenarioEdited = 'PAST_SCENARIO_EDITED',
  /** Risk was identified in a scenario. */
  PastScenarioIdentified = 'PAST_SCENARIO_IDENTIFIED',
  /** Scenario review was due. */
  PastScenarioReviewDue = 'PAST_SCENARIO_REVIEW_DUE',
  /** Virtual marker representing today’s date in the timeline. */
  Today = 'TODAY'
}

/** Filters used to refine the timeline query. */
export type TimelineFilterInput = {
  /** Optional date range filter. */
  date_filter?: InputMaybe<DateRangeInput>;
  /** Event category filters. */
  events?: InputMaybe<Scalars['JSON']['input']>;
  /** Object filters (e.g. specific controls or scenarios). */
  objects?: InputMaybe<Scalars['JSON']['input']>;
  /** Owner filters. */
  owners?: InputMaybe<Scalars['JSON']['input']>;
};

/** The filters applied to timeline data. */
export type TimelineFilters = {
  __typename?: 'TimelineFilters';
  /** Event filters grouped by category and type. */
  events: Scalars['JSON']['output'];
  /** Object-level filters for assessments, scenarios, controls, and incidents. */
  objects: Scalars['JSON']['output'];
  /** Owner filters based on assigned users or 'No Owner'. */
  owners: Scalars['JSON']['output'];
};

/** The full timeline query result with filters, metadata, and event data. */
export type TimelineResponse = {
  __typename?: 'TimelineResponse';
  /** List of grouped events by day. */
  data: Array<TimelineDay>;
  /** Filter configuration returned with the timeline. */
  filters: TimelineFilters;
  /** Index of the current day (if 'TODAY' exists). */
  today?: Maybe<Scalars['Int']['output']>;
  /** Total number of days with events. */
  total: Scalars['Int']['output'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

/** Account of a person who utilizes this application. */
export type User = {
  __typename?: 'User';
  /** Unique email address. */
  email: Scalars['String']['output'];
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** The users invites to join Org Units */
  invites: Array<Invite>;
  /** Meta data for User */
  meta?: Maybe<Meta>;
  /** Non-unique name. */
  name: Scalars['String']['output'];
  /** User's Identity and role within an Org Unit */
  orgUnitIdentity?: Maybe<OrgUnitIdentity>;
  /** The actions available to organisation admins when this user is listed in organisation views */
  organisationUserActions?: Maybe<OrganisationUserActions>;
  /** The Organisations this user is associated with */
  organisations: Array<Organisation>;
  /** Path to Profile Image. */
  profilePhotoPath?: Maybe<Scalars['String']['output']>;
  /** Receive notifications for items needing attention. */
  receiveNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** The users requests to join Org Units */
  requests: Array<Request>;
  /** The actions available to workspace admins when this user is listed in workspace views */
  workspaceUserActions?: Maybe<WorkspaceUserActions>;
  /** The Workspaces this user has joined */
  workspaces: Array<Workspace>;
};


/** Account of a person who utilizes this application. */
export type UserInvitesArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** Account of a person who utilizes this application. */
export type UserOrganisationsArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** Account of a person who utilizes this application. */
export type UserRequestsArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** Account of a person who utilizes this application. */
export type UserWorkspacesArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};

/** Generic option for any entity with a UX ID. */
export type UxFilterOption = {
  __typename?: 'UxFilterOption';
  count?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  unifiedKey: Scalars['UnifiedKey']['output'];
};

/** A variable used in scenario formulas. */
export type Variable = {
  __typename?: 'Variable';
  /** @deprecated No longer used */
  alias?: Maybe<Scalars['String']['output']>;
  currency: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  isInUse: Array<Scalars['UxId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['BigNumber']['output']>;
  workspaceVariable?: Maybe<Scalars['Boolean']['output']>;
};

/** Input data for workspace variables */
export type VariableInput = {
  currency: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isGlobal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['BigNumber']['input']>;
};

/** Settings for variables used in risk assessments and other calculations. */
export type VariableSetting = {
  __typename?: 'VariableSetting';
  /** When this variable setting was created. */
  createdAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Unique primary key. */
  id: Scalars['ID']['output'];
  /** A unique key used to identify the variable setting programmatically. */
  key: Scalars['String']['output'];
  /** A human-readable name for this variable setting. */
  name: Scalars['String']['output'];
  /** Additional structured data related to this variable setting. */
  settings?: Maybe<Scalars['JSON']['output']>;
  /** When this variable setting was last updated. */
  updatedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
};

/** Input data for creating or updating a VariableSetting. */
export type VariableSettingInput = {
  /** Optional ID used for updates. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Unique key used to identify this variable setting. */
  key: Scalars['String']['input'];
  /** Human-readable name for the variable setting. */
  name: Scalars['String']['input'];
  /** Structured data to store any additional configuration or settings. */
  settings?: InputMaybe<Scalars['JSON']['input']>;
};

/** Point-in-time snapshot of a Risk Assessment */
export type Version = {
  __typename?: 'Version';
  /** The assessment snapshot at this version */
  assessment: Assessment;
  /** Whether this version can be edited */
  editable: Scalars['Boolean']['output'];
  /** The unique ID of this version */
  id: Scalars['UxId']['output'];
  /** Whether this version is from before versioning was fully implemented */
  legacyVersion: Scalars['Boolean']['output'];
  /** Meta data for Version */
  meta?: Maybe<Meta>;
  /** Name of this version */
  name: Scalars['String']['output'];
};

/** Dashboard widget for Average Incident Frequency. */
export type WidgetAverageIncidentFrequency = {
  __typename?: 'WidgetAverageIncidentFrequency';
  meantimeBetweenIncidents: Scalars['Float']['output'];
  meantimeBetweenNearMisses: Scalars['Float']['output'];
};

/** Dashboard widget for control implementation status. */
export type WidgetControlImplementation = {
  __typename?: 'WidgetControlImplementation';
  controlsWithoutCost: Scalars['Int']['output'];
  inProgressCost: Scalars['BigNumber']['output'];
  inProgressCount: Scalars['Int']['output'];
  liveCost: Scalars['BigNumber']['output'];
  liveCount: Scalars['Int']['output'];
  notApplicableCost: Scalars['BigNumber']['output'];
  notApplicableCount: Scalars['Int']['output'];
  notStartedCost: Scalars['BigNumber']['output'];
  notStartedCount: Scalars['Int']['output'];
  otherCost: Scalars['BigNumber']['output'];
  otherCount: Scalars['Int']['output'];
};

/** Dashboard widget for ecpected loss statistics. */
export type WidgetExpectedLoss = {
  __typename?: 'WidgetExpectedLoss';
  liveRisk: Scalars['BigNumber']['output'];
  projectedRisk: Scalars['BigNumber']['output'];
  unmodifiedRisk: Scalars['BigNumber']['output'];
};

/** Dashboard widget for future security programme status. */
export type WidgetFutureSecurityProgram = {
  __typename?: 'WidgetFutureSecurityProgram';
  additionalCost: Scalars['BigNumber']['output'];
  furtherReduction: Scalars['BigNumber']['output'];
  totalSavings: Scalars['BigNumber']['output'];
};

/** Dashboard widget for missing data */
export type WidgetMissingData = {
  __typename?: 'WidgetMissingData';
  scenariosWithoutCalculationData: Scalars['Int']['output'];
  scenariosWithoutLinkedControls: Scalars['Int']['output'];
  scenariosWithoutModifiers: Scalars['Int']['output'];
};

/** Dashboard widget for overdue reviews. */
export type WidgetOverdueReviews = {
  __typename?: 'WidgetOverdueReviews';
  assessments: Scalars['Int']['output'];
  controls: Scalars['Int']['output'];
  scenarios: Scalars['Int']['output'];
};

/** Dashboard widget for return on investment. */
export type WidgetReturnOnInvestment = {
  __typename?: 'WidgetReturnOnInvestment';
  currentProgramme: Scalars['Float']['output'];
  futureProgramme: Scalars['Float']['output'];
};

/** Dashboard widget for risk avoidance. */
export type WidgetRiskAvoidance = {
  __typename?: 'WidgetRiskAvoidance';
  days: Scalars['Int']['output'];
  estimatedLossLower: Scalars['BigNumber']['output'];
  estimatedLossUpper: Scalars['BigNumber']['output'];
  nearMisses: Scalars['Int']['output'];
};

/** Dashboard widget for risky scenarios. */
export type WidgetRiskyScenarios = {
  __typename?: 'WidgetRiskyScenarios';
  scenarios: Array<Scenario>;
};

/** Dashboard widget for current security program status. */
export type WidgetSecurityProgram = {
  __typename?: 'WidgetSecurityProgram';
  cost: Scalars['BigNumber']['output'];
  riskReduction: Scalars['BigNumber']['output'];
  savings: Scalars['BigNumber']['output'];
};

/** An area for organising risk assessments */
export type Workspace = OrgUnitFields & {
  __typename?: 'Workspace';
  /** Actions available to current user on this workspace */
  actionsOnThisWorkspace?: Maybe<OrgUnitActions>;
  /** Time the workspace was archived. */
  archivedAt?: Maybe<Scalars['DateTimeUtc']['output']>;
  /** Who archived the workspace. */
  archivedBy?: Maybe<User>;
  /** Assessments in this workspace */
  assessments: Array<Assessment>;
  /** Count of Assessments in this workspace */
  assessmentsCount: Scalars['Int']['output'];
  /** Billing Contact for the Workspace */
  billingContact?: Maybe<Scalars['String']['output']>;
  /** Controls in this workspace */
  controls?: Maybe<Array<Control>>;
  /** Workspace Engagement Counts */
  counts?: Maybe<WorkspaceCounts>;
  /** Currency descriptor or symbol to use for currency values in the Workspace */
  currency?: Maybe<Scalars['String']['output']>;
  /** Domain for the Workspace */
  domain?: Maybe<Scalars['String']['output']>;
  /** Main Workspace Identifier */
  id: Scalars['UxId']['output'];
  /** Incidents in this workspace */
  incidents?: Maybe<Array<Incident>>;
  /** Invites in this workspace */
  invites: Array<InvitedUser>;
  /** Whether this workspace is archived (soft-deleted). */
  isArchived: Scalars['Boolean']['output'];
  /** Restricted flag - unrestricted workspaces are open to all organisation domain users */
  isRestricted: Scalars['Boolean']['output'];
  /** current authenticated users membership */
  member?: Maybe<Member>;
  /** Meta data for Workspace */
  meta?: Maybe<Meta>;
  /** Workspace Name */
  name: Scalars['String']['output'];
  /** Daily time for notification schedule */
  notificationScheduleTime?: Maybe<Scalars['String']['output']>;
  /** Owners in this workspace */
  owners?: Maybe<Array<Owner>>;
  /** Parent Organisation for this workspace */
  parent?: Maybe<Organisation>;
  /** Workspace Plan */
  plan?: Maybe<Scalars['String']['output']>;
  /** Plan Type */
  planType?: Maybe<PlanType>;
  /** Primary Contact for the Workspace */
  primaryContact: Scalars['String']['output'];
  /** Questions in this workspace */
  questions?: Maybe<Questions>;
  /** Record Type: O -> Organisation , W -> Secondary Workspace, (later P -> Partner) */
  recordType: Scalars['String']['output'];
  /** Requests in this workspace */
  requests: Array<RequestUser>;
  /** Workspace-level cadence used for reviews */
  reviewCadence?: Maybe<ReviewCadence>;
  /** Workspace-level cadence used for reviews, in days */
  reviewCadenceDays?: Maybe<Scalars['Int']['output']>;
  /** Authenticated user in this Workspace */
  self?: Maybe<User>;
  /** Uses of this workspace */
  users: Array<User>;
  /** Variables in this workspace */
  variables: Array<Variable>;
};


/** An area for organising risk assessments */
export type WorkspaceAssessmentsArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An area for organising risk assessments */
export type WorkspaceControlsArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An area for organising risk assessments */
export type WorkspaceIncidentsArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An area for organising risk assessments */
export type WorkspaceInvitesArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An area for organising risk assessments */
export type WorkspaceOwnersArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** An area for organising risk assessments */
export type WorkspaceRequestsArgs = {
  id?: InputMaybe<Scalars['UxId']['input']>;
};


/** An area for organising risk assessments */
export type WorkspaceUsersArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  member_id?: InputMaybe<Scalars['UxId']['input']>;
};

/** Activity counts for workspace */
export type WorkspaceCounts = {
  __typename?: 'WorkspaceCounts';
  assessments?: Maybe<Scalars['Int']['output']>;
  controls?: Maybe<Scalars['Int']['output']>;
  incidents?: Maybe<Scalars['Int']['output']>;
  modifiers?: Maybe<Scalars['Int']['output']>;
  scenarios?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
};

export type WorkspaceCreateInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  isRestricted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notificationScheduleTime?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  primaryContact: Scalars['String']['input'];
};

/** Workspace User actions are the actions the current authenticated user can perform on a user of the Workspace */
export type WorkspaceUserActions = {
  __typename?: 'WorkspaceUserActions';
  /** Authenticated User can grant access to listed user for this Workspace */
  canAcceptRequest: Scalars['Boolean']['output'];
  /** Authenticated User can edit the profile of listed user for this Workspace */
  canEditProfile: Scalars['Boolean']['output'];
  /** Authenticated User can grant access to listed user for this Workspace */
  canGrantAccess: Scalars['Boolean']['output'];
  /** Authenticated User can grant admin privilege to listed user for this Workspace */
  canGrantAdmin: Scalars['Boolean']['output'];
  /** Authenticated User can revoke access to listed user for this Workspace */
  canRejectRequest: Scalars['Boolean']['output'];
  /** Authenticated User can remove listed user from this organisation */
  canRemoveUser: Scalars['Boolean']['output'];
  /** Authenticated User can revoke access to listed user for this Workspace */
  canRevokeAccess: Scalars['Boolean']['output'];
  /** Authenticated User can revoke admin privilege to listed user for this Workspace */
  canRevokeAdmin: Scalars['Boolean']['output'];
  /** Authenticated User can revoke invite to listed user for this Workspace */
  canRevokeInvite: Scalars['Boolean']['output'];
};

export type WsSettingsOptions = {
  __typename?: 'WsSettingsOptions';
  plan: Array<Scalars['String']['output']>;
  planType: Array<PlanType>;
};

export enum ComplianceStatus {
  Compliant = 'COMPLIANT',
  NotCompliant = 'NOT_COMPLIANT',
  PartialCompliant = 'PARTIAL_COMPLIANT'
}

export type UpsertAssessmentMutationVariables = Exact<{
  assessmentData: AssessmentInput;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type UpsertAssessmentMutation = { __typename?: 'Mutation', upsertAssessment?: boolean | null };

export type DeleteAssessmentMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type DeleteAssessmentMutation = { __typename?: 'Mutation', deleteAssessment?: boolean | null };

export type DeleteIncidentMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type DeleteIncidentMutation = { __typename?: 'Mutation', deleteIncident?: boolean | null };

export type LinkScenarioToIncidentsMutationVariables = Exact<{
  scenarioId: Scalars['UxId']['input'];
  incidentIds: Array<Scalars['UxId']['input']> | Scalars['UxId']['input'];
}>;


export type LinkScenarioToIncidentsMutation = { __typename?: 'Mutation', linkScenarioToIncidents?: boolean | null };

export type LinkIncidentToScenariosMutationVariables = Exact<{
  incidentId: Scalars['UxId']['input'];
  scenarioIds: Array<Scalars['UxId']['input']> | Scalars['UxId']['input'];
}>;


export type LinkIncidentToScenariosMutation = { __typename?: 'Mutation', linkIncidentToScenarios?: boolean | null };

export type UnlinkIncidentFromScenariosMutationVariables = Exact<{
  incidentId: Scalars['UxId']['input'];
  scenarioIds: Array<Scalars['UxId']['input']> | Scalars['UxId']['input'];
}>;


export type UnlinkIncidentFromScenariosMutation = { __typename?: 'Mutation', unlinkIncidentFromScenarios?: boolean | null };

export type UnlinkScenarioFromControlsMutationVariables = Exact<{
  scenarioId: Scalars['UxId']['input'];
  controlIds: Array<Scalars['UxId']['input']> | Scalars['UxId']['input'];
}>;


export type UnlinkScenarioFromControlsMutation = { __typename?: 'Mutation', unlinkScenarioFromControls?: boolean | null };

export type DeleteControlsMutationVariables = Exact<{
  ids: Array<Scalars['UxId']['input']> | Scalars['UxId']['input'];
}>;


export type DeleteControlsMutation = { __typename?: 'Mutation', deleteControls?: boolean | null };

export type LinkFrameworkControlsToScenariosMutationVariables = Exact<{
  frameworkControlScenarioLinks: Array<FrameworkControlScenarioInput> | FrameworkControlScenarioInput;
  addRecommendedModifiers: Scalars['Boolean']['input'];
}>;


export type LinkFrameworkControlsToScenariosMutation = { __typename?: 'Mutation', linkFrameworkControlsToScenarios?: Array<{ __typename?: 'Control', id: string } | null> | null };

export type AddControlsFromLibraryMutationVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
  controlIds: Array<ControlFromLibraryInput> | ControlFromLibraryInput;
  addRecommendedModifiers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddControlsFromLibraryMutation = { __typename?: 'Mutation', addControlsFromLibrary: Array<{ __typename?: 'Control', id: string }> };

export type DeleteScenarioMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type DeleteScenarioMutation = { __typename?: 'Mutation', deleteScenario?: boolean | null };

export type UpsertAssessmentVariablesMutationVariables = Exact<{
  assessmentId: Scalars['UxId']['input'];
  variables: Array<VariableInput> | VariableInput;
}>;


export type UpsertAssessmentVariablesMutation = { __typename?: 'Mutation', upsertAssessmentVariables?: { __typename?: 'Assessment', id: string } | null };

export type UpsertControlMutationVariables = Exact<{
  controlData: ControlInput;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type UpsertControlMutation = { __typename?: 'Mutation', upsertControl?: { __typename?: 'Control', id: string } | null };

export type UpsertControlsMutationVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
  controlsData: Array<ControlInput> | ControlInput;
}>;


export type UpsertControlsMutation = { __typename?: 'Mutation', upsertControls: Array<{ __typename?: 'Control', id: string }> };

export type UpsertIncidentsMutationVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
  incidentsData: Array<IncidentInput> | IncidentInput;
}>;


export type UpsertIncidentsMutation = { __typename?: 'Mutation', upsertIncidents?: Array<{ __typename?: 'Incident', id: string, ref?: string | null } | null> | null };

export type UpsertScenarioMutationVariables = Exact<{
  assessmentId?: InputMaybe<Scalars['UxId']['input']>;
  scenarioData: ScenarioInput;
}>;


export type UpsertScenarioMutation = { __typename?: 'Mutation', upsertScenario?: { __typename?: 'Scenario', id: string } | null };

export type AddScenarioToGroupMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['UxId']['input']>;
  scenarioId: Scalars['UxId']['input'];
}>;


export type AddScenarioToGroupMutation = { __typename?: 'Mutation', addScenarioToGroup?: { __typename?: 'ScenarioGroup', id: string } | null };

export type UpsertScenariosMutationVariables = Exact<{
  assessmentId?: InputMaybe<Scalars['UxId']['input']>;
  scenariosData: Array<ScenarioInput> | ScenarioInput;
}>;


export type UpsertScenariosMutation = { __typename?: 'Mutation', upsertScenarios?: Array<{ __typename?: 'Scenario', id: string } | null> | null };

export type CloneAssessmentMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
  incidents?: InputMaybe<LinkOptionInput>;
  riskManagementPlan?: InputMaybe<LinkOptionInput>;
}>;


export type CloneAssessmentMutation = { __typename?: 'Mutation', cloneAssessment?: { __typename?: 'Assessment', id: string, name: string } | null };

export type UpsertEventMutationVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
  eventData: Array<EventInput> | EventInput;
}>;


export type UpsertEventMutation = { __typename?: 'Mutation', upsertEvent: Array<{ __typename?: 'Event', id: string }> };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent?: boolean | null };

export type UpsertModifiersMutationVariables = Exact<{
  control_id: Scalars['UxId']['input'];
  scenario_id: Scalars['UxId']['input'];
  modifiers: ModifierInput;
}>;


export type UpsertModifiersMutation = { __typename?: 'Mutation', upsertModifiers?: boolean | null };

export type CreateExportJobMutationVariables = Exact<{
  reportType: ExportReportType;
  reportParams?: InputMaybe<Scalars['String']['input']>;
  access: ExportAccess;
}>;


export type CreateExportJobMutation = { __typename?: 'Mutation', createExportJob: { __typename?: 'ExportJob', id: string, status: ExportStatus } };

export type DeleteUserExportJobsMutationVariables = Exact<{
  jobIds: Array<Scalars['UxId']['input']> | Scalars['UxId']['input'];
}>;


export type DeleteUserExportJobsMutation = { __typename?: 'Mutation', deleteUserExportJobs: boolean };

export type ReportDownloadUrlMutationVariables = Exact<{
  jobId: Scalars['UxId']['input'];
}>;


export type ReportDownloadUrlMutation = { __typename?: 'Mutation', reportDownloadUrl?: string | null };

export type AcceptTermsMutationVariables = Exact<{
  termsId: Scalars['UxId']['input'];
  acceptedMethod: Scalars['String']['input'];
}>;


export type AcceptTermsMutation = { __typename?: 'Mutation', acceptTerms?: boolean | null };

export type RequestLogoUploadMutationVariables = Exact<{
  contentType: Scalars['String']['input'];
  extension: Scalars['String']['input'];
}>;


export type RequestLogoUploadMutation = { __typename?: 'Mutation', requestLogoUpload: { __typename?: 'LogoUpload', uploadUrl: string, key: string, publicUrl: string } };

export type DeferTermsMutationVariables = Exact<{
  termsId: Scalars['UxId']['input'];
}>;


export type DeferTermsMutation = { __typename?: 'Mutation', deferTerms?: boolean | null };

export type SetActiveWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
}>;


export type SetActiveWorkspaceMutation = { __typename?: 'Mutation', setActiveWorkspace?: { __typename?: 'Profile', activeWorkspace?: { __typename?: 'Workspace', id: string } | null } | null };

export type CancelInviteMutationVariables = Exact<{
  inviteId: Scalars['UxId']['input'];
}>;


export type CancelInviteMutation = { __typename?: 'Mutation', cancelInvite?: boolean | null };

export type AcceptInviteMutationVariables = Exact<{
  inviteId: Scalars['UxId']['input'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite?: boolean | null };

export type RejectInviteMutationVariables = Exact<{
  inviteId: Scalars['UxId']['input'];
}>;


export type RejectInviteMutation = { __typename?: 'Mutation', rejectInvite?: boolean | null };

export type GrantAdminMutationVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  userId: Scalars['Int']['input'];
}>;


export type GrantAdminMutation = { __typename?: 'Mutation', grantAdmin?: boolean | null };

export type RemoveUserMutationVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  userId: Scalars['Int']['input'];
}>;


export type RemoveUserMutation = { __typename?: 'Mutation', removeUser?: boolean | null };

export type RemovePeopleMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemovePeopleMutation = { __typename?: 'Mutation', removePeople?: boolean | null };

export type CancelRequestMutationVariables = Exact<{
  requestId?: InputMaybe<Scalars['UxId']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type CancelRequestMutation = { __typename?: 'Mutation', cancelRequest?: boolean | null };

export type AcceptRequestMutationVariables = Exact<{
  requestId: Scalars['UxId']['input'];
}>;


export type AcceptRequestMutation = { __typename?: 'Mutation', acceptRequest?: boolean | null };

export type RequestAccessMutationVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type RequestAccessMutation = { __typename?: 'Mutation', requestAccess?: boolean | null };

export type RejectRequestMutationVariables = Exact<{
  requestId: Scalars['UxId']['input'];
}>;


export type RejectRequestMutation = { __typename?: 'Mutation', rejectRequest?: boolean | null };

export type InviteUsersMutationVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  invitesData: Array<InviteInput> | InviteInput;
}>;


export type InviteUsersMutation = { __typename?: 'Mutation', inviteUsers?: boolean | null };

export type UpsertWorkspaceMutationVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  name: Scalars['String']['input'];
  primaryContact: Scalars['String']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  isRestricted: Scalars['Boolean']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  notificationScheduleTime?: InputMaybe<Scalars['String']['input']>;
  reviewCadenceDays?: InputMaybe<Scalars['Int']['input']>;
  planType?: InputMaybe<PlanType>;
}>;


export type UpsertWorkspaceMutation = { __typename?: 'Mutation', upsertWorkspace?: { __typename?: 'Workspace', id: string } | null };

export type UpsertOrganisationMutationVariables = Exact<{
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  primaryContact?: InputMaybe<Scalars['String']['input']>;
  billingContact?: InputMaybe<Scalars['String']['input']>;
  logoKey?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<BusinessType>;
  organisationType?: InputMaybe<OrganisationType>;
  parentId?: InputMaybe<Scalars['UxId']['input']>;
  createWorkspace?: InputMaybe<Scalars['Boolean']['input']>;
  workspace?: InputMaybe<WorkspaceCreateInput>;
}>;


export type UpsertOrganisationMutation = { __typename?: 'Mutation', upsertOrganisation?: { __typename?: 'Organisation', id: string } | null };

export type UpsertWorkspaceVariablesMutationVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
  variables: Array<VariableInput> | VariableInput;
}>;


export type UpsertWorkspaceVariablesMutation = { __typename?: 'Mutation', upsertWorkspaceVariables?: { __typename?: 'Workspace', id: string } | null };

export type UpsertWorkspaceQuestionsMutationVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
  questions: QuestionsInput;
}>;


export type UpsertWorkspaceQuestionsMutation = { __typename?: 'Mutation', upsertWorkspaceQuestions?: { __typename?: 'Workspace', id: string } | null };

export type UpdateUserMutationVariables = Exact<{
  orgUnitId?: InputMaybe<Scalars['UxId']['input']>;
  userId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  receiveNotifications: Scalars['Boolean']['input'];
  role?: InputMaybe<Role>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: boolean | null };

export type ArchiveWorkspaceMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type ArchiveWorkspaceMutation = { __typename?: 'Mutation', archiveWorkspace: boolean };

export type UnarchiveWorkspaceMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type UnarchiveWorkspaceMutation = { __typename?: 'Mutation', unarchiveWorkspace: boolean };

export type ArchiveOrganisationMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type ArchiveOrganisationMutation = { __typename?: 'Mutation', archiveOrganisation: boolean };

export type DeleteWorkspaceMutationVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutation', deleteWorkspace: boolean };

export type AssessmentsListQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type AssessmentsListQuery = { __typename?: 'Query', assessments: Array<{ __typename?: 'Assessment', id: string, name: string, description?: string | null, startedDate?: string | null, reviewDate?: string | null, AssessmentLiveRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null }, scenarios: Array<{ __typename?: 'Scenario', id: string, isIncomplete?: CompletionState | null }> }> };

export type AssessmentsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type AssessmentsQuery = { __typename?: 'Query', assessments: Array<{ __typename?: 'Assessment', id: string, name: string, description?: string | null, startedDate?: string | null, reviewDate?: string | null, AssessmentLiveRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null }, scenarios: Array<{ __typename?: 'Scenario', id: string, isIncomplete?: CompletionState | null, name?: string | null, ownerName?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskIdentifiedDate?: string | null, editedAt?: string | null, status?: string | null, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null, assessment: { __typename?: 'Assessment', id: string } }> }> };

export type AssessmentsScenarioNamesQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type AssessmentsScenarioNamesQuery = { __typename?: 'Query', assessments: Array<{ __typename?: 'Assessment', id: string, name: string, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null }> }> };

export type IncidentsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type IncidentsQuery = { __typename?: 'Query', incidents: Array<{ __typename?: 'Incident', id: string, name: string, ref?: string | null, source?: string | null, incidentType?: string | null, dateOfIncident?: string | null, description?: string | null, financialImpactLower?: number | null, financialImpactUpper?: number | null, impact?: string | null, severity?: string | null, owner?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, scenarios: Array<{ __typename?: 'Scenario', id: string }> }> };

export type IncidentsCheckQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type IncidentsCheckQuery = { __typename?: 'Query', incidents: Array<{ __typename?: 'Incident', id: string, scenarios: Array<{ __typename?: 'Scenario', id: string }> }> };

export type IncidentLinkedScenariosQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type IncidentLinkedScenariosQuery = { __typename?: 'Query', incident?: { __typename?: 'Incident', id: string, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, ownerName?: string | null, riskIdentifiedDate?: string | null, isIncomplete?: CompletionState | null, editedAt?: string | null, status?: string | null, assessment: { __typename?: 'Assessment', id: string, name: string }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }> } | null };

export type IncidentQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type IncidentQuery = { __typename?: 'Query', incident?: { __typename?: 'Incident', id: string, name: string, ref?: string | null, source?: string | null, incidentType?: string | null, dateOfIncident?: string | null, description?: string | null, financialImpactLower?: number | null, financialImpactUpper?: number | null, impact?: string | null, severity?: string | null, owner?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null } | null };

export type ScenarioTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ScenarioTemplatesQuery = { __typename?: 'Query', scenarioTemplates: Array<{ __typename?: 'ScenarioTemplate', id: string, name?: string | null, author?: string | null, groupName?: string | null, description?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskOwner?: string | null, riskNarrative?: string | null, expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, frequencyNote?: string | null, managementStrategy?: string | null, lowerFormula?: string | null, upperFormula?: string | null, note?: string | null }> };

export type ScenarioGroupsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ScenarioGroupsQuery = { __typename?: 'Query', scenarioGroups: Array<{ __typename?: 'ScenarioGroup', id: string, name: string, description?: string | null, author?: string | null, authorLogoPath?: string | null, category?: string | null, featureKey?: string | null, isSystem?: boolean | null, versionNumber?: number | null, isCurrentVersion?: boolean | null, versionCreatedBy?: string | null, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null, versions: Array<{ __typename?: 'ScenarioGroup', id: string, name: string, versionNumber?: number | null, isCurrentVersion?: boolean | null, versionCreatedBy?: string | null, scenarios: Array<{ __typename?: 'Scenario', id: string }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }>, scenarios: Array<{ __typename?: 'Scenario', id: string, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }> }> };

export type ScenarioGroupsWithScenariosQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ScenarioGroupsWithScenariosQuery = { __typename?: 'Query', scenarioGroups: Array<{ __typename?: 'ScenarioGroup', id: string, name: string, description?: string | null, author?: string | null, authorLogoPath?: string | null, category?: string | null, featureKey?: string | null, isSystem?: boolean | null, versionNumber?: number | null, isCurrentVersion?: boolean | null, versionCreatedBy?: string | null, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null, versions: Array<{ __typename?: 'ScenarioGroup', id: string, name: string, versionNumber?: number | null, isCurrentVersion?: boolean | null, versionCreatedBy?: string | null, scenarios: Array<{ __typename?: 'Scenario', id: string }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }>, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, description?: string | null, ownerName?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskNarrative?: string | null, frequencyNote?: string | null, managementStrategy?: string | null, managementNote?: string | null, consequenceNote?: string | null, lowerFormula?: string | null, upperFormula?: string | null, status?: string | null, riskIdentifiedDate?: string | null, reviewDate?: string | null, assessment: { __typename?: 'Assessment', id: string }, baseRisk: { __typename?: 'ScenarioRisk', frequencyTimes?: number | null, frequencyYears?: number | null, expectedLoss?: number | null, lower?: number | null, upper?: number | null }, projectedRisk: { __typename?: 'ScenarioRisk', frequencyTimes?: number | null, frequencyYears?: number | null, expectedLoss?: number | null, lower?: number | null, upper?: number | null }, liveRisk: { __typename?: 'ScenarioRisk', frequencyTimes?: number | null, frequencyYears?: number | null, expectedLoss?: number | null, lower?: number | null, upper?: number | null }, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }> }> };

export type ControlsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
  selection?: InputMaybe<ControlSelectionInput>;
}>;


export type ControlsQuery = { __typename?: 'Query', controls: Array<{ __typename?: 'Control', id: string, name: string, description?: string | null, ownerEmail?: string | null, ownerName?: string | null, annualCost?: number | null, vendor?: string | null, strategy?: string | null, status?: string | null, origin?: string | null, linkUrl?: string | null, linkText?: string | null, expectedActiveDate?: string | null, actualActiveDate?: string | null, reviewDate?: string | null, existingMaturity?: MaturityLevel | null, targetMaturity?: MaturityLevel | null, riskManagementPlansCount?: number | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, name: string, shortname?: string | null, control_identifier?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null } | null }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }> };

export type ControlsRmpCheckQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ControlsRmpCheckQuery = { __typename?: 'Query', controls: Array<{ __typename?: 'Control', id: string, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null }> }> };

export type ControlRmpQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ControlRmpQuery = { __typename?: 'Query', control?: { __typename?: 'Control', id: string, strategy?: string | null, status?: string | null, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, startingFrequency?: number | null, startingLower?: number | null, startingUpper?: number | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null, consequenceUpper?: number | null, consequenceLower?: number | null, frequencyReduction?: number | null, isPercentage?: boolean | null, totalPolicyCover?: number | null, excess?: number | null, note?: string | null }>, recommendedModifiers: Array<{ __typename?: 'RecommendedModifier', type?: string | null, data?: { __typename?: 'RecommendedModifierData', upper?: number | null, lower?: number | null, value?: number | null, isPercentage?: boolean | null } | null }>, scenario?: { __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, ownerName?: string | null, isIncomplete?: CompletionState | null, riskIdentifiedDate?: string | null, editedAt?: string | null, status?: string | null, assessment: { __typename?: 'Assessment', id: string, name: string }, baseRisk: { __typename?: 'ScenarioRisk', upper?: number | null, lower?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null } | null }> } | null };

export type ControlModifierQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type ControlModifierQuery = { __typename?: 'Query', control?: { __typename?: 'Control', id: string, strategy?: string | null, status?: string | null, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null, consequenceUpper?: number | null, consequenceLower?: number | null, frequencyReduction?: number | null, isPercentage?: boolean | null, totalPolicyCover?: number | null, excess?: number | null, note?: string | null }>, recommendedModifiers: Array<{ __typename?: 'RecommendedModifier', type?: string | null, data?: { __typename?: 'RecommendedModifierData', upper?: number | null, lower?: number | null, value?: number | null, isPercentage?: boolean | null } | null }>, scenario?: { __typename?: 'Scenario', id: string, baseRisk: { __typename?: 'ScenarioRisk', upper?: number | null, lower?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null } } | null }> } | null };

export type ControlsRmpQueryVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
}>;


export type ControlsRmpQuery = { __typename?: 'Query', controls: Array<{ __typename?: 'Control', id: string, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string } | null }>, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, scenario?: { __typename?: 'Scenario', id: string } | null }> }> };

export type ScenarioRmpQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ScenarioRmpQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, baseRisk: { __typename?: 'ScenarioRisk', upper?: number | null, lower?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, startingFrequency?: number | null, startingLower?: number | null, startingUpper?: number | null, control?: { __typename?: 'Control', id: string, name: string, strategy?: string | null, ownerName?: string | null, annualCost?: number | null, status?: string | null, existingMaturity?: MaturityLevel | null, targetMaturity?: MaturityLevel | null, linkUrl?: string | null, linkText?: string | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, name: string, shortname?: string | null, control_identifier?: string | null, strategy?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null } | null }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null, consequenceUpper?: number | null, consequenceLower?: number | null, frequencyReduction?: number | null, isPercentage?: boolean | null, totalPolicyCover?: number | null, excess?: number | null, note?: string | null }>, recommendedModifiers: Array<{ __typename?: 'RecommendedModifier', type?: string | null, data?: { __typename?: 'RecommendedModifierData', upper?: number | null, lower?: number | null, value?: number | null, isPercentage?: boolean | null } | null }> }> } | null };

export type ScenarioModifierQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ScenarioModifierQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, baseRisk: { __typename?: 'ScenarioRisk', upper?: number | null, lower?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, strategy?: string | null, status?: string | null } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null, consequenceUpper?: number | null, consequenceLower?: number | null, frequencyReduction?: number | null, isPercentage?: boolean | null, totalPolicyCover?: number | null, excess?: number | null, note?: string | null }>, recommendedModifiers: Array<{ __typename?: 'RecommendedModifier', type?: string | null, data?: { __typename?: 'RecommendedModifierData', upper?: number | null, lower?: number | null, value?: number | null, isPercentage?: boolean | null } | null }> }> } | null };

export type ControlFrameworksListQueryVariables = Exact<{ [key: string]: never; }>;


export type ControlFrameworksListQuery = { __typename?: 'Query', controlFrameworks: Array<{ __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null, controlCount?: number | null, author?: string | null, featureKey?: string | null, versionNumber?: number | null, isCurrentVersion?: boolean | null, versionCreatedBy?: string | null, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null, versions: Array<{ __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null, controlCount?: number | null, versionNumber?: number | null, isCurrentVersion?: boolean | null, versionCreatedBy?: string | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }>, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, shortname?: string | null, control_identifier?: string | null }> }> };

export type ControlFrameworkDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ControlFrameworkDetailsQuery = { __typename?: 'Query', controlFrameworks: Array<{ __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null, author?: string | null, description?: string | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, name: string, shortname?: string | null, control_identifier?: string | null, strategy?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, shortname?: string | null, author?: string | null, description?: string | null } | null }> }> };

export type FrameworkControlQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type FrameworkControlQuery = { __typename?: 'Query', frameworkControl?: { __typename?: 'FrameworkControl', id: string, name: string, shortname?: string | null, description?: string | null, control_identifier?: string | null, strategy?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null, author?: string | null, framework_identifier?: string | null, externalId?: string | null } | null } | null };

export type InsightsQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type InsightsQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, name: string, AssessmentLiveRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null }, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, reviewDate?: string | null, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, incidents: Array<{ __typename?: 'Incident', id: string, financialImpactLower?: number | null, financialImpactUpper?: number | null, dateOfIncident?: string | null, incidentType?: string | null }>, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, name: string, status?: string | null, existingMaturity?: MaturityLevel | null, targetMaturity?: MaturityLevel | null } | null }> }> } | null };

export type AssessmentQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type AssessmentQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, name: string, description?: string | null, executiveSummary?: string | null, riskTolerance?: string | null, startedDate?: string | null, reviewDate?: string | null, AssessmentBaseRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentProjectedRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentLiveRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, variables: Array<{ __typename?: 'Variable', id?: number | null, name?: string | null, value?: number | null, isInUse: Array<string>, currency: boolean, isGlobal?: boolean | null, alias?: string | null, workspaceVariable?: boolean | null }>, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, isIncomplete?: CompletionState | null, baseRisk: { __typename?: 'ScenarioRisk', upper?: number | null, lower?: number | null }, liveRisk: { __typename?: 'ScenarioRisk', upper?: number | null, lower?: number | null }, projectedRisk: { __typename?: 'ScenarioRisk', upper?: number | null, lower?: number | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, status?: string | null } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null }> }> }>, versions: Array<{ __typename?: 'Version', id: string, name: string, editable: boolean, legacyVersion: boolean, meta?: { __typename?: 'Meta', createdBy?: string | null, createdAt?: string | null } | null }> } | null };

export type AssessmentVariablesQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type AssessmentVariablesQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, variables: Array<{ __typename?: 'Variable', id?: number | null, name?: string | null, value?: number | null, isInUse: Array<string>, currency: boolean, isGlobal?: boolean | null, alias?: string | null, workspaceVariable?: boolean | null }> } | null };

export type AssessmentRiskRegisterQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type AssessmentRiskRegisterQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, name: string, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, ownerName?: string | null, riskIdentifiedDate?: string | null, reviewDate?: string | null, editedAt?: string | null, isIncomplete?: CompletionState | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, lowerFormula?: string | null, upperFormula?: string | null, managementStrategy?: string | null, managementNote?: string | null, status?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, status?: string | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null }> } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null }> }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }> } | null };

export type AssessmentScenariosWizardQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type AssessmentScenariosWizardQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, name: string, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, ownerName?: string | null, riskIdentifiedDate?: string | null, editedAt?: string | null, isIncomplete?: CompletionState | null, status?: string | null, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null }> } | null }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }> } | null };

export type ControlQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ControlQuery = { __typename?: 'Query', control?: { __typename?: 'Control', id: string, name: string, description?: string | null, annualCost?: number | null, vendor?: string | null, strategy?: string | null, status?: string | null, origin?: string | null, linkUrl?: string | null, linkText?: string | null, expectedActiveDate?: string | null, actualActiveDate?: string | null, reviewDate?: string | null, existingMaturity?: MaturityLevel | null, targetMaturity?: MaturityLevel | null, owner?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string }>, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, shortname?: string | null } | null, compatibleControls: Array<{ __typename?: 'FrameworkControl', id: string, name: string, shortname?: string | null, control_identifier?: string | null, description?: string | null, strategy?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null, description?: string | null, author?: string | null, framework_identifier?: string | null, externalId?: string | null } | null }> }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null } | null };

export type ControlLinkedScenariosQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ControlLinkedScenariosQuery = { __typename?: 'Query', control?: { __typename?: 'Control', id: string, strategy?: string | null, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, strategy?: string | null } | null, scenario?: { __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, ownerName?: string | null, riskIdentifiedDate?: string | null, editedAt?: string | null, isIncomplete?: CompletionState | null, status?: string | null, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, assessment: { __typename?: 'Assessment', id: string, name: string }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null }> }> } | null };

export type ScenarioQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ScenarioQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, name?: string | null, managementNote?: string | null, managementStrategy?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskIdentifiedDate?: string | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, isIncomplete?: CompletionState | null, status?: string | null, reviewDate?: string | null, groupName?: string | null, lowerFormula?: string | null, upperFormula?: string | null, editedAt?: string | null, assessment: { __typename?: 'Assessment', id: string, name: string }, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null, id?: string | null, profilePhotoPath?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, upper?: number | null, lower?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, lowerThanMinimum?: string | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, status?: string | null } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null }> }>, meta?: { __typename?: 'Meta', updatedAt?: string | null } | null } | null };

export type ScenarioIncidentsQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ScenarioIncidentsQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, name?: string | null, incidents: Array<{ __typename?: 'Incident', id: string, name: string, ref?: string | null, source?: string | null, incidentType?: string | null, dateOfIncident?: string | null, description?: string | null, financialImpactLower?: number | null, financialImpactUpper?: number | null, impact?: string | null, severity?: string | null, owner?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, scenarios: Array<{ __typename?: 'Scenario', id: string }> }> } | null };

export type DashboardQueryVariables = Exact<{
  assessmentId: Scalars['UxId']['input'];
}>;


export type DashboardQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, name: string, description?: string | null, startedDate?: string | null, editedAt?: string | null, scenarios: Array<{ __typename?: 'Scenario', id: string, isIncomplete?: CompletionState | null, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, status?: string | null } | null, modifiers: Array<{ __typename?: 'Modifier', id: string }> }>, incidents: Array<{ __typename?: 'Incident', id: string }> }>, meta?: { __typename?: 'Meta', updatedAt?: string | null } | null } | null, dashboard: { __typename?: 'Dashboard', expectedLoss?: { __typename?: 'WidgetExpectedLoss', unmodifiedRisk: number, liveRisk: number, projectedRisk: number } | null, securityProgram?: { __typename?: 'WidgetSecurityProgram', riskReduction: number, cost: number, savings: number } | null, futureSecurityProgram?: { __typename?: 'WidgetFutureSecurityProgram', furtherReduction: number, additionalCost: number, totalSavings: number } | null, returnOnInvestment?: { __typename?: 'WidgetReturnOnInvestment', currentProgramme: number, futureProgramme: number } | null, riskyScenarios?: { __typename?: 'WidgetRiskyScenarios', scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, assessment: { __typename?: 'Assessment', id: string } }> } | null, controlImplementation?: { __typename?: 'WidgetControlImplementation', notStartedCount: number, notStartedCost: number, inProgressCount: number, inProgressCost: number, liveCount: number, liveCost: number, otherCount: number, otherCost: number, controlsWithoutCost: number } | null, overdueReviews?: { __typename?: 'WidgetOverdueReviews', assessments: number, scenarios: number, controls: number } | null, averageIncidentFrequency?: { __typename?: 'WidgetAverageIncidentFrequency', meantimeBetweenIncidents: number, meantimeBetweenNearMisses: number } | null, riskAvoidance?: { __typename?: 'WidgetRiskAvoidance', nearMisses: number, days: number, estimatedLossLower: number, estimatedLossUpper: number } | null, missingData?: { __typename?: 'WidgetMissingData', scenariosWithoutCalculationData: number, scenariosWithoutLinkedControls: number, scenariosWithoutModifiers: number } | null } };

export type VersionsQueryVariables = Exact<{
  assessmentId: Scalars['UxId']['input'];
}>;


export type VersionsQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, versions: Array<{ __typename?: 'Version', id: string, name: string, editable: boolean, legacyVersion: boolean, meta?: { __typename?: 'Meta', createdBy?: string | null, createdAt?: string | null } | null }> } | null };

export type EventFieldsFragment = { __typename?: 'Event', id: string, objectType?: ObjectKind | null, objectId?: string | null, eventType?: EventKind | null, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, completedAt?: string | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, completedBy?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null, createdBy?: string | null } | null };

export type EventsQueryVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
  objectType?: InputMaybe<ObjectKind>;
  objectId?: InputMaybe<Scalars['UxId']['input']>;
  eventType?: InputMaybe<EventKind>;
  completionStatus?: InputMaybe<EventCompletionStatus>;
  onlyOpen?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'Event', id: string, objectType?: ObjectKind | null, objectId?: string | null, eventType?: EventKind | null, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, completedAt?: string | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, completedBy?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null, createdBy?: string | null } | null }> };

export type EventQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
}>;


export type EventQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, objectType?: ObjectKind | null, objectId?: string | null, eventType?: EventKind | null, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, completedAt?: string | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, completedBy?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null } | null, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null, createdBy?: string | null } | null } | null };

export type ComparisonAssessmentDataFragment = { __typename?: 'Assessment', id: string, name: string, riskTolerance?: string | null, reviewDate?: string | null, AssessmentBaseRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentProjectedRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentLiveRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, ownerName?: string | null, referenceId?: string | null, isIncomplete?: CompletionState | null, lowerFormula?: string | null, upperFormula?: string | null, managementStrategy?: string | null, managementNote?: string | null, riskIdentifiedDate?: string | null, reviewDate?: string | null, editedAt?: string | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, status?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, lowerThanMinimum?: string | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, status?: string | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null }> } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null }> }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }>, versions: Array<{ __typename?: 'Version', id: string, name: string, editable: boolean, legacyVersion: boolean, meta?: { __typename?: 'Meta', createdBy?: string | null, createdAt?: string | null } | null }> };

export type ComparisonAssessmentQueryVariables = Exact<{
  assessmentAId: Scalars['UxId']['input'];
  assessmentBId: Scalars['UxId']['input'];
  versionAId?: InputMaybe<Scalars['UxId']['input']>;
  versionBId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ComparisonAssessmentQuery = { __typename?: 'Query', assessmentA?: { __typename?: 'Assessment', id: string, name: string, riskTolerance?: string | null, reviewDate?: string | null, AssessmentBaseRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentProjectedRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentLiveRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, ownerName?: string | null, referenceId?: string | null, isIncomplete?: CompletionState | null, lowerFormula?: string | null, upperFormula?: string | null, managementStrategy?: string | null, managementNote?: string | null, riskIdentifiedDate?: string | null, reviewDate?: string | null, editedAt?: string | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, status?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, lowerThanMinimum?: string | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, status?: string | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null }> } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null }> }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }>, versions: Array<{ __typename?: 'Version', id: string, name: string, editable: boolean, legacyVersion: boolean, meta?: { __typename?: 'Meta', createdBy?: string | null, createdAt?: string | null } | null }> } | null, assessmentB?: { __typename?: 'Assessment', id: string, name: string, riskTolerance?: string | null, reviewDate?: string | null, AssessmentBaseRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentProjectedRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentLiveRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, ownerName?: string | null, referenceId?: string | null, isIncomplete?: CompletionState | null, lowerFormula?: string | null, upperFormula?: string | null, managementStrategy?: string | null, managementNote?: string | null, riskIdentifiedDate?: string | null, reviewDate?: string | null, editedAt?: string | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, status?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, lowerThanMinimum?: string | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, status?: string | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null }> } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null }> }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }>, versions: Array<{ __typename?: 'Version', id: string, name: string, editable: boolean, legacyVersion: boolean, meta?: { __typename?: 'Meta', createdBy?: string | null, createdAt?: string | null } | null }> } | null };

export type ComparisonScenarioDataFragment = { __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, managementStrategy?: string | null, managementNote?: string | null, status?: string | null, reviewDate?: string | null, riskIdentifiedDate?: string | null, editedAt?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null, id?: string | null, profilePhotoPath?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, lowerThanMinimum?: string | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, assessment: { __typename?: 'Assessment', id: string, name: string, versions: Array<{ __typename?: 'Version', id: string, name: string, editable: boolean, legacyVersion: boolean, meta?: { __typename?: 'Meta', createdBy?: string | null, createdAt?: string | null } | null }> } };

export type CompareScenariosQueryVariables = Exact<{
  scenarioAId: Scalars['UxId']['input'];
  scenarioBId: Scalars['UxId']['input'];
  versionAId?: InputMaybe<Scalars['UxId']['input']>;
  versionBId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type CompareScenariosQuery = { __typename?: 'Query', scenarioA?: { __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, managementStrategy?: string | null, managementNote?: string | null, status?: string | null, reviewDate?: string | null, riskIdentifiedDate?: string | null, editedAt?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null, id?: string | null, profilePhotoPath?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, lowerThanMinimum?: string | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, assessment: { __typename?: 'Assessment', id: string, name: string, versions: Array<{ __typename?: 'Version', id: string, name: string, editable: boolean, legacyVersion: boolean, meta?: { __typename?: 'Meta', createdBy?: string | null, createdAt?: string | null } | null }> } } | null, scenarioB?: { __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, managementStrategy?: string | null, managementNote?: string | null, status?: string | null, reviewDate?: string | null, riskIdentifiedDate?: string | null, editedAt?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null, id?: string | null, profilePhotoPath?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, lowerThanMinimum?: string | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, assessment: { __typename?: 'Assessment', id: string, name: string, versions: Array<{ __typename?: 'Version', id: string, name: string, editable: boolean, legacyVersion: boolean, meta?: { __typename?: 'Meta', createdBy?: string | null, createdAt?: string | null } | null }> } } | null };

export type ScenarioControlsQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ScenarioControlsQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, name?: string | null, baseRisk: { __typename?: 'ScenarioRisk', upper?: number | null, lower?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, startingFrequency?: number | null, startingLower?: number | null, startingUpper?: number | null, order?: number | null, control?: { __typename?: 'Control', id: string, name: string, shortname?: string | null, description?: string | null, strategy?: string | null, status?: string | null, origin?: string | null, annualCost?: number | null, vendor?: string | null, linkUrl?: string | null, linkText?: string | null, expectedActiveDate?: string | null, actualActiveDate?: string | null, reviewDate?: string | null, existingMaturity?: MaturityLevel | null, targetMaturity?: MaturityLevel | null, owner?: { __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, memberId?: string | null, inviteId?: string | null, profilePhotoPath?: string | null } | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, name: string, shortname?: string | null, control_identifier?: string | null, strategy?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null } | null }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null } | null, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null }> }> } | null };

export type FiltersForQueryVariables = Exact<{
  workspaceId: Scalars['UxId']['input'];
  object: FilterObjectKey;
  includeCounts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FiltersForQuery = { __typename?: 'Query', filtersFor: { __typename?: 'ObjectFilterSets', controls?: { __typename?: 'ControlFilterSet', strategy: Array<{ __typename?: 'StringFilterOption', unifiedKey: string, label: string, enabled: boolean }>, status: Array<{ __typename?: 'StringFilterOption', unifiedKey: string, label: string, enabled: boolean }>, owners: Array<{ __typename?: 'OwnerFilterOption', unifiedKey: string, label: string, enabled: boolean, email?: string | null }>, frameworks: Array<{ __typename?: 'UxFilterOption', unifiedKey: string, label: string, enabled: boolean }>, assessments: Array<{ __typename?: 'UxFilterOption', unifiedKey: string, label: string, enabled: boolean }>, existingMaturity: Array<{ __typename?: 'StringFilterOption', unifiedKey: string, label: string, enabled: boolean }>, targetMaturity: Array<{ __typename?: 'StringFilterOption', unifiedKey: string, label: string, enabled: boolean }> } | null } };

export type ComplianceFrameworkGaugeQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  workspaceId: Scalars['UxId']['input'];
}>;


export type ComplianceFrameworkGaugeQuery = { __typename?: 'Query', complianceFrameworks: Array<{ __typename?: 'ComplianceFramework', controlsCount: number, controlsImplementedCount: number, controlsPlannedCount: number }> };

export type ComplianceFrameworkQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  workspaceId: Scalars['UxId']['input'];
}>;


export type ComplianceFrameworkQuery = { __typename?: 'Query', complianceFrameworks: Array<{ __typename?: 'ComplianceFramework', controlsCount: number, controlsImplementedCount: number, controlsPlannedCount: number, controlFramework: { __typename?: 'ControlFramework', id: string, shortname?: string | null, name: string, description?: string | null, author?: string | null, framework_identifier?: string | null, featureKey?: string | null, version?: string | null, versionNumber?: number | null, isCurrentVersion?: boolean | null, versionCreatedBy?: string | null, publishDate?: string | null, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null, versions: Array<{ __typename?: 'ControlFramework', id: string, name: string, shortname?: string | null, controlCount?: number | null, versionNumber?: number | null, isCurrentVersion?: boolean | null, versionCreatedBy?: string | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string }>, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null }> }, complianceControls: Array<{ __typename?: 'ComplianceControl', complianceStatus?: ComplianceStatus | null, frameworkControl: { __typename?: 'FrameworkControl', id: string, control_identifier?: string | null, name: string, shortname?: string | null, strategy?: string | null, description?: string | null, meta?: { __typename?: 'Meta', createdAt?: string | null, updatedAt?: string | null } | null, controlFramework?: { __typename?: 'ControlFramework', shortname?: string | null, author?: string | null } | null }, compliantRmpControls: Array<{ __typename?: 'Control', id: string, name: string, strategy?: string | null, status?: string | null, owner?: { __typename?: 'Owner', id?: string | null, text?: string | null } | null, frameworkControls: Array<{ __typename?: 'FrameworkControl', controlFramework?: { __typename?: 'ControlFramework', id: string, shortname?: string | null } | null }> }> }> }> };

export type MyExportJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyExportJobsQuery = { __typename?: 'Query', myExportJobs: Array<{ __typename?: 'ExportJob', id: string, reportType: ExportReportType, reportParams?: string | null, status: ExportStatus, access: ExportAccess, progress: number, createdAt: string, expiresAt: string, completedAt?: string | null, failedAt?: string | null, canceledAt?: string | null, errorMessage?: string | null, requestedBy: { __typename?: 'User', id: string, name: string, email: string } }> };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', userFlowSignature: string, user: { __typename?: 'User', id: string, name: string, email: string, profilePhotoPath?: string | null, receiveNotifications?: boolean | null, orgUnitIdentity?: { __typename?: 'OrgUnitIdentity', baseRole?: Role | null, name: string } | null, invites: Array<{ __typename?: 'Invite', id?: string | null, userEmail?: string | null, invitedDate?: string | null, workspaceName?: string | null, workspaceId?: string | null, organisationName?: string | null, organisationId?: string | null, orgUnitType?: string | null }>, requests: Array<{ __typename?: 'Request', id?: string | null, workspaceName?: string | null, workspaceId?: string | null, organisationName?: string | null, organisationId?: string | null, userEmail?: string | null, requestedDate?: string | null, orgUnitType?: string | null }> }, activeWorkspace?: { __typename?: 'Workspace', id: string, name: string, currency?: string | null, owners?: Array<{ __typename?: 'Owner', id?: string | null, text?: string | null, email?: string | null, inviteId?: string | null, memberId?: string | null, profilePhotoPath?: string | null }> | null, actionsOnThisWorkspace?: { __typename?: 'OrgUnitActions', canAccess: boolean, canSeeSettings: boolean, canInviteUsers: boolean, canSeeAuditLogs: boolean } | null } | null, activeOrganisation?: { __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null, logoDataUrl?: string | null, primaryColor?: string | null, secondaryColor?: string | null, actionsOnThisOrganisation?: { __typename?: 'OrgUnitActions', canAccess: boolean, canSeeSettings: boolean } | null } | null, features: Array<{ __typename?: 'FeatureFlag', feature: string, isActive: boolean }>, permissions: { __typename?: 'Permissions', canCreateOrganisation: boolean, canCreateWorkspace: boolean, canCreateChild: boolean, canEditUsers: boolean, canManageUsers: boolean, isPlatformAdmin: boolean, isPartnerAdmin: boolean }, terms: { __typename?: 'Terms', organisation_id?: string | null, organisation_name?: string | null, status?: string | null, can_defer?: boolean | null, defer_expires?: string | null, terms_id?: string | null, terms_url?: string | null } } };

export type ProfileSettingsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileSettingsOptionsQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', wsSettingsOptions: { __typename?: 'WsSettingsOptions', planType: Array<PlanType>, plan: Array<string> }, orgSettingsOptions: Array<{ __typename?: 'OrgSettingsOptions', organisationType?: OrganisationType | null, businessType?: Array<BusinessType> | null }> } };

export type WorkspaceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type WorkspaceQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, name: string, recordType: string, primaryContact: string, currency?: string | null, isRestricted: boolean, plan?: string | null, planType?: PlanType | null, notificationScheduleTime?: string | null, reviewCadenceDays?: number | null, isArchived: boolean, parent?: { __typename?: 'Organisation', id: string, name: string, domain?: string | null, isArchived: boolean } | null, users: Array<{ __typename?: 'User', id: string, name: string, email: string }>, member?: { __typename?: 'Member', effectiveRole?: Role | null } | null, actionsOnThisWorkspace?: { __typename?: 'OrgUnitActions', canEditSettings: boolean, canDelete: boolean, canArchive: boolean, canUnarchive: boolean } | null } | null };

export type WorkspaceMembersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type WorkspaceMembersQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, users: Array<{ __typename?: 'User', id: string, name: string, email: string, profilePhotoPath?: string | null, orgUnitIdentity?: { __typename?: 'OrgUnitIdentity', baseRole?: Role | null, assumedRole?: Role | null, name: string } | null, workspaceUserActions?: { __typename?: 'WorkspaceUserActions', canGrantAccess: boolean, canRevokeAccess: boolean, canRemoveUser: boolean, canGrantAdmin: boolean, canRevokeAdmin: boolean, canAcceptRequest: boolean, canRejectRequest: boolean, canRevokeInvite: boolean, canEditProfile: boolean } | null }>, invites: Array<{ __typename?: 'InvitedUser', id?: number | null, name?: string | null, email?: string | null, profilePhotoPath?: string | null, invite?: { __typename?: 'Invite', id?: string | null, invitedDate?: string | null, invitedRole?: Role | null } | null }>, requests: Array<{ __typename?: 'RequestUser', id?: number | null, name?: string | null, email?: string | null, profilePhotoPath?: string | null, request?: { __typename?: 'Request', id?: string | null, requestedDate?: string | null } | null }>, actionsOnThisWorkspace?: { __typename?: 'OrgUnitActions', canSeeMembers: boolean, canInviteUsers: boolean, canSeeInvites: boolean, canSeeRequests: boolean } | null } | null };

export type WorkspaceVariablesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type WorkspaceVariablesQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, variables: Array<{ __typename?: 'Variable', id?: number | null, name?: string | null, value?: number | null, isInUse: Array<string>, currency: boolean, isGlobal?: boolean | null, alias?: string | null, workspaceVariable?: boolean | null }> } | null };

export type WizardQueryVariables = Exact<{ [key: string]: never; }>;


export type WizardQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', activeWorkspace?: { __typename?: 'Workspace', questions?: { __typename?: 'Questions', scenarios?: { __typename?: 'QuestionScenarios', B2B: boolean, B2C: boolean, publiclyAccessibleInternetBusiness: boolean, paymentVolumeOrValue: boolean, significantITContributionToRevenue: boolean, significantDataInCloud: boolean, softwareBusiness: boolean, cniOrDefenseInvolvement: boolean, significantRandD: boolean, regulated: boolean, operationalTechnology: boolean, supplyChainReliant: boolean, aiThirdPartyReliant: boolean, aiCustomerFacingApp: boolean } | null, assessment?: { __typename?: 'QuestionAssessment', name?: string | null, description?: string | null, review_date?: string | null, started_date?: string | null } | null, regulations?: { __typename?: 'QuestionRegulations', legislation: Array<string>, controlFrameworks: Array<string>, controlFrameworksOther: Array<string>, primaryControlFramework?: string | null, primaryFrameworkControls: Array<string>, pinnedControlFrameworks: Array<string> } | null, softwareDev?: { __typename?: 'QuestionSoftwareDev', developsSoftware: boolean } | null, organisation?: { __typename?: 'QuestionOrganisation', sector?: string | null, usesManagedServiceProvider: boolean } | null, cyberInsurance?: { __typename?: 'QuestionCyberInsurance', cyberInsurance: boolean } | null } | null } | null } };

export type OrganisationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type OrganisationQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null, logoDataUrl?: string | null, primaryColor?: string | null, secondaryColor?: string | null, domain?: string | null, parentId?: string | null, primaryContact: string, billingContact?: string | null, organisationType?: OrganisationType | null, businessType?: BusinessType | null, isArchived: boolean, actionsOnThisOrganisation?: { __typename?: 'OrgUnitActions', canEditSettings: boolean, canInviteUsers: boolean, canSeeInvites: boolean, canSeeRequests: boolean, canArchive: boolean, canSeeParent: boolean, canEditParent: boolean, canEditOrganisationType: boolean } | null, member?: { __typename?: 'Member', effectiveRole?: Role | null } | null } | null };

export type OrganisationMembersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type OrganisationMembersQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', id: string, users: Array<{ __typename?: 'User', id: string, name: string, email: string, profilePhotoPath?: string | null, orgUnitIdentity?: { __typename?: 'OrgUnitIdentity', baseRole?: Role | null, assumedRole?: Role | null, name: string } | null, organisationUserActions?: { __typename?: 'OrganisationUserActions', canGrantAccess: boolean, canRevokeAccess: boolean, canRemoveUser: boolean, canGrantAdmin: boolean, canRevokeAdmin: boolean, canEditProfile: boolean } | null }>, requests: Array<{ __typename?: 'RequestUser', id?: number | null, name?: string | null, email?: string | null, profilePhotoPath?: string | null, request?: { __typename?: 'Request', id?: string | null, requestedDate?: string | null } | null }>, invites: Array<{ __typename?: 'InvitedUser', id?: number | null, name?: string | null, email?: string | null, profilePhotoPath?: string | null, invite?: { __typename?: 'Invite', id?: string | null, invitedDate?: string | null, invitedRole?: Role | null } | null }>, actionsOnThisOrganisation?: { __typename?: 'OrgUnitActions', canEditSettings: boolean, canInviteUsers: boolean, canSeeInvites: boolean, canSeeRequests: boolean, canArchive: boolean, canSeeParent: boolean, canEditParent: boolean, canEditOrganisationType: boolean } | null } | null };

export type FlatOrganisationsHomeQueryVariables = Exact<{
  memberEmail?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FlatOrganisationsHomeQuery = { __typename?: 'Query', flatOrganisations: Array<{ __typename?: 'FlatOrganisation', id: string, name: string, domain: string, parentId?: string | null, childIds: Array<string>, primaryContact: string, recordType: string, isArchived: boolean, plan?: string | null, organisationType?: OrganisationType | null, businessType?: BusinessType | null, planType?: PlanType | null, isRestricted: boolean, actionsOnThisOrgUnit?: { __typename?: 'OrgUnitActions', canAccess: boolean, canRequest: boolean, canSeeSettings: boolean, canArchive: boolean, canUnarchive: boolean, canDelete: boolean, canInviteUsers: boolean } | null, member?: { __typename?: 'Member', access: MemberAccess } | null }> };

export type FlatOrganisationsUserQueryVariables = Exact<{
  memberEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type FlatOrganisationsUserQuery = { __typename?: 'Query', flatOrganisations: Array<{ __typename?: 'FlatOrganisation', id: string, name: string, parentId?: string | null, recordType: string, isArchived: boolean, actionsOnThisOrgUnit?: { __typename?: 'OrgUnitActions', canSeeSettings: boolean, canRequest: boolean, canInviteUsers: boolean } | null, member?: { __typename?: 'Member', access: MemberAccess, effectiveRole?: Role | null, association?: { __typename?: 'MemberAssociation', userName: string, userEmail: string, role?: Role | null, requestedDate?: string | null, acceptedDate?: string | null, notifications: boolean } | null, memberActions: { __typename?: 'MemberActions', canEditProfile: boolean, canMakeAdmin: boolean, canMakePartnerAdmin: boolean, canRequestAccess: boolean, canCancelRequest: boolean }, user: { __typename?: 'User', profilePhotoPath?: string | null, name: string, email: string } } | null }> };

export type MemberQueryVariables = Exact<{
  orgUnitId: Scalars['UxId']['input'];
  memberEmail: Scalars['UxId']['input'];
}>;


export type MemberQuery = { __typename?: 'Query', member?: { __typename?: 'Member', access: MemberAccess, effectiveRole?: Role | null, association?: { __typename?: 'MemberAssociation', userName: string, userEmail: string, role?: Role | null, requestedDate?: string | null, acceptedDate?: string | null, notifications: boolean } | null, memberActions: { __typename?: 'MemberActions', canEditProfile: boolean, canMakeAdmin: boolean, canMakePartnerAdmin: boolean, canRequestAccess: boolean, canCancelRequest: boolean }, user: { __typename?: 'User', id: string, name: string, email: string, profilePhotoPath?: string | null } } | null };

export type OrganisationAccessCheckQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type OrganisationAccessCheckQuery = { __typename?: 'Query', organisation?: { __typename?: 'Organisation', id: string, isArchived: boolean, actionsOnThisOrganisation?: { __typename?: 'OrgUnitActions', canSeeSettings: boolean } | null } | null };

export type WorkspaceAccessCheckQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type WorkspaceAccessCheckQuery = { __typename?: 'Query', workspace?: { __typename?: 'Workspace', id: string, isArchived: boolean, actionsOnThisWorkspace?: { __typename?: 'OrgUnitActions', canAccess: boolean, canSeeSettings: boolean, canSeeAuditLogs: boolean } | null } | null };

export type FlatOrganisationsNavQueryVariables = Exact<{
  memberEmail?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FlatOrganisationsNavQuery = { __typename?: 'Query', flatOrganisations: Array<{ __typename?: 'FlatOrganisation', id: string, name: string, recordType: string, parentId?: string | null, childIds: Array<string>, isArchived: boolean, organisationType?: OrganisationType | null, businessType?: BusinessType | null }> };

export type InviteRolesQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
  organisationId?: InputMaybe<Scalars['UxId']['input']>;
  userEmail: Scalars['String']['input'];
}>;


export type InviteRolesQuery = { __typename?: 'Query', inviteRoles: { __typename?: 'InvitedUserRoles', roles: Array<Role>, isTrustedEmail: boolean, isPartnerAdmin: boolean } };

export type ScenarioPdfQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ScenarioPdfQuery = { __typename?: 'Query', scenario?: { __typename?: 'Scenario', id: string, name?: string | null, managementNote?: string | null, managementStrategy?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskIdentifiedDate?: string | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, lowerFormula?: string | null, upperFormula?: string | null, isIncomplete?: CompletionState | null, status?: string | null, reviewDate?: string | null, editedAt?: string | null, actions: Array<{ __typename?: 'Event', id: string, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null }>, assessment: { __typename?: 'Assessment', id: string, name: string, reviewDate?: string | null, variables: Array<{ __typename?: 'Variable', id?: number | null, name?: string | null, value?: number | null, currency: boolean, isGlobal?: boolean | null, alias?: string | null, workspaceVariable?: boolean | null }>, workspace?: { __typename?: 'Workspace', variables: Array<{ __typename?: 'Variable', id?: number | null, name?: string | null, value?: number | null, currency: boolean, isGlobal?: boolean | null, alias?: string | null, workspaceVariable?: boolean | null }> } | null }, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, upper?: number | null, lower?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, incidents: Array<{ __typename?: 'Incident', id: string, name: string, ref?: string | null, source?: string | null, incidentType?: string | null, dateOfIncident?: string | null, description?: string | null, financialImpactLower?: number | null, financialImpactUpper?: number | null, impact?: string | null, severity?: string | null, actions: Array<{ __typename?: 'Event', id: string, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null }>, owner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, status?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, assessment: { __typename?: 'Assessment', id: string, name: string } }> }>, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, name: string, description?: string | null, status?: string | null, strategy?: string | null, annualCost?: number | null, vendor?: string | null, linkUrl?: string | null, linkText?: string | null, expectedActiveDate?: string | null, actualActiveDate?: string | null, reviewDate?: string | null, existingMaturity?: MaturityLevel | null, targetMaturity?: MaturityLevel | null, actions: Array<{ __typename?: 'Event', id: string, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null }>, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, shortname?: string | null } | null }>, owner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, meta?: { __typename?: 'Meta', updatedAt?: string | null } | null } | null }>, meta?: { __typename?: 'Meta', updatedAt?: string | null } | null } | null };

export type AssessmentPdfQueryVariables = Exact<{
  id: Scalars['UxId']['input'];
  versionId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type AssessmentPdfQuery = { __typename?: 'Query', assessment?: { __typename?: 'Assessment', id: string, name: string, description?: string | null, executiveSummary?: string | null, riskTolerance?: string | null, startedDate?: string | null, reviewDate?: string | null, editedAt?: string | null, actions: Array<{ __typename?: 'Event', id: string, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null }>, AssessmentBaseRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentProjectedRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, AssessmentLiveRisk: { __typename?: 'AssessmentRisk', expectedLoss?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, meta?: { __typename?: 'Meta', updatedAt?: string | null } | null, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, riskIdentifiedDate?: string | null, reviewDate?: string | null, editedAt?: string | null, isIncomplete?: CompletionState | null, riskNarrative?: string | null, frequencyNote?: string | null, consequenceNote?: string | null, managementStrategy?: string | null, managementNote?: string | null, status?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, actions: Array<{ __typename?: 'Event', id: string, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null }>, baseRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, projectedRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null, frequencyTimes?: number | null, frequencyYears?: number | null, lower?: number | null, upper?: number | null, chart: Array<{ __typename?: 'ChartCoordinate', x: number, y: number }> }, assessment: { __typename?: 'Assessment', id: string, name: string, reviewDate?: string | null }, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, control?: { __typename?: 'Control', id: string, name: string, description?: string | null, status?: string | null, strategy?: string | null, annualCost?: number | null, vendor?: string | null, linkUrl?: string | null, linkText?: string | null, expectedActiveDate?: string | null, actualActiveDate?: string | null, reviewDate?: string | null, existingMaturity?: MaturityLevel | null, targetMaturity?: MaturityLevel | null, actions: Array<{ __typename?: 'Event', id: string, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null }>, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, shortname?: string | null } | null }>, owner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null, consequenceUpper?: number | null, consequenceLower?: number | null, frequencyReduction?: number | null, isPercentage?: boolean | null, totalPolicyCover?: number | null, excess?: number | null, note?: string | null }>, scenario?: { __typename?: 'Scenario', id: string } | null }>, meta?: { __typename?: 'Meta', updatedAt?: string | null } | null } | null }>, incidents: Array<{ __typename?: 'Incident', id: string, name: string, ref?: string | null, source?: string | null, incidentType?: string | null, dateOfIncident?: string | null, description?: string | null, financialImpactLower?: number | null, financialImpactUpper?: number | null, impact?: string | null, severity?: string | null, actions: Array<{ __typename?: 'Event', id: string, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null }>, owner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, scenarios: Array<{ __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, status?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, assessment: { __typename?: 'Assessment', id: string, name: string } }> }>, meta?: { __typename?: 'Meta', updatedAt?: string | null } | null }> } | null };

export type ControlsPdfQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['UxId']['input']>;
}>;


export type ControlsPdfQuery = { __typename?: 'Query', controls: Array<{ __typename?: 'Control', id: string, name: string, description?: string | null, annualCost?: number | null, vendor?: string | null, strategy?: string | null, status?: string | null, linkUrl?: string | null, linkText?: string | null, expectedActiveDate?: string | null, actualActiveDate?: string | null, reviewDate?: string | null, existingMaturity?: MaturityLevel | null, targetMaturity?: MaturityLevel | null, owner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, actions: Array<{ __typename?: 'Event', id: string, notes?: string | null, dueDate?: string | null, completionStatus?: EventCompletionStatus | null, isOverdue: boolean, assignedTo?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null }>, frameworkControls: Array<{ __typename?: 'FrameworkControl', id: string, control_identifier?: string | null, controlFramework?: { __typename?: 'ControlFramework', id: string, shortname?: string | null } | null }>, riskManagementPlans: Array<{ __typename?: 'RiskManagementPlan', id: string, modifiers: Array<{ __typename?: 'Modifier', id: string, type?: string | null, consequenceUpper?: number | null, consequenceLower?: number | null, frequencyReduction?: number | null, isPercentage?: boolean | null, totalPolicyCover?: number | null, excess?: number | null, note?: string | null }>, scenario?: { __typename?: 'Scenario', id: string, name?: string | null, source?: number | null, event?: number | null, consequence?: number | null, status?: string | null, riskOwner?: { __typename?: 'Owner', text?: string | null, email?: string | null } | null, liveRisk: { __typename?: 'ScenarioRisk', expectedLoss?: number | null }, assessment: { __typename?: 'Assessment', id: string, name: string } } | null }>, meta?: { __typename?: 'Meta', updatedAt?: string | null } | null }> };

export const EventFieldsFragmentDoc = gql`
    fragment EventFields on Event {
  id
  objectType
  objectId
  eventType
  notes
  assignedTo {
    id
    text
    email
    inviteId
    memberId
    profilePhotoPath
  }
  dueDate
  completionStatus
  completedBy {
    id
    text
    email
    inviteId
    memberId
    profilePhotoPath
  }
  completedAt
  isOverdue
  meta {
    createdAt
    updatedAt
    createdBy
  }
}
    `;
export const ComparisonAssessmentDataFragmentDoc = gql`
    fragment ComparisonAssessmentData on Assessment {
  id
  name
  riskTolerance
  reviewDate
  AssessmentBaseRisk {
    expectedLoss
    chart {
      x
      y
    }
  }
  AssessmentProjectedRisk {
    expectedLoss
    chart {
      x
      y
    }
  }
  AssessmentLiveRisk {
    expectedLoss
    chart {
      x
      y
    }
  }
  scenarios {
    id
    name
    source
    event
    consequence
    ownerName
    riskOwner {
      text
    }
    referenceId
    isIncomplete
    lowerFormula
    upperFormula
    baseRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      lower
      upper
    }
    projectedRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      lower
      upper
    }
    liveRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      lower
      upper
      lowerThanMinimum
    }
    riskManagementPlans {
      id
      control {
        id
        status
        frameworkControls {
          id
          control_identifier
        }
      }
      modifiers {
        id
        type
      }
    }
    managementStrategy
    managementNote
    riskIdentifiedDate
    reviewDate
    editedAt
    riskNarrative
    frequencyNote
    consequenceNote
    status
    meta {
      createdAt
      updatedAt
    }
  }
  versions {
    id
    name
    editable
    legacyVersion
    meta {
      createdBy
      createdAt
    }
  }
}
    `;
export const ComparisonScenarioDataFragmentDoc = gql`
    fragment ComparisonScenarioData on Scenario {
  id
  name
  source
  event
  consequence
  riskOwner {
    text
    email
    id
    profilePhotoPath
  }
  riskNarrative
  frequencyNote
  consequenceNote
  managementStrategy
  managementNote
  status
  reviewDate
  riskIdentifiedDate
  editedAt
  baseRisk {
    expectedLoss
    frequencyTimes
    frequencyYears
    lower
    upper
    chart {
      x
      y
    }
  }
  projectedRisk {
    expectedLoss
    frequencyTimes
    frequencyYears
    lower
    upper
    chart {
      x
      y
    }
  }
  liveRisk {
    expectedLoss
    frequencyTimes
    frequencyYears
    lower
    upper
    lowerThanMinimum
    chart {
      x
      y
    }
  }
  assessment {
    id
    name
    versions {
      id
      name
      editable
      legacyVersion
      meta {
        createdBy
        createdAt
      }
    }
  }
}
    `;
export const UpsertAssessmentDocument = gql`
    mutation upsertAssessment($assessmentData: AssessmentInput!, $workspaceId: UxId) {
  upsertAssessment(assessmentData: $assessmentData, workspaceId: $workspaceId)
}
    `;
export type UpsertAssessmentMutationFn = Apollo.MutationFunction<UpsertAssessmentMutation, UpsertAssessmentMutationVariables>;

/**
 * __useUpsertAssessmentMutation__
 *
 * To run a mutation, you first call `useUpsertAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssessmentMutation, { data, loading, error }] = useUpsertAssessmentMutation({
 *   variables: {
 *      assessmentData: // value for 'assessmentData'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpsertAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAssessmentMutation, UpsertAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAssessmentMutation, UpsertAssessmentMutationVariables>(UpsertAssessmentDocument, options);
      }
export type UpsertAssessmentMutationHookResult = ReturnType<typeof useUpsertAssessmentMutation>;
export type UpsertAssessmentMutationResult = Apollo.MutationResult<UpsertAssessmentMutation>;
export type UpsertAssessmentMutationOptions = Apollo.BaseMutationOptions<UpsertAssessmentMutation, UpsertAssessmentMutationVariables>;
export const DeleteAssessmentDocument = gql`
    mutation deleteAssessment($id: UxId!) {
  deleteAssessment(id: $id)
}
    `;
export type DeleteAssessmentMutationFn = Apollo.MutationFunction<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>;

/**
 * __useDeleteAssessmentMutation__
 *
 * To run a mutation, you first call `useDeleteAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssessmentMutation, { data, loading, error }] = useDeleteAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>(DeleteAssessmentDocument, options);
      }
export type DeleteAssessmentMutationHookResult = ReturnType<typeof useDeleteAssessmentMutation>;
export type DeleteAssessmentMutationResult = Apollo.MutationResult<DeleteAssessmentMutation>;
export type DeleteAssessmentMutationOptions = Apollo.BaseMutationOptions<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>;
export const DeleteIncidentDocument = gql`
    mutation deleteIncident($id: UxId!) {
  deleteIncident(id: $id)
}
    `;
export type DeleteIncidentMutationFn = Apollo.MutationFunction<DeleteIncidentMutation, DeleteIncidentMutationVariables>;

/**
 * __useDeleteIncidentMutation__
 *
 * To run a mutation, you first call `useDeleteIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncidentMutation, { data, loading, error }] = useDeleteIncidentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIncidentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIncidentMutation, DeleteIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIncidentMutation, DeleteIncidentMutationVariables>(DeleteIncidentDocument, options);
      }
export type DeleteIncidentMutationHookResult = ReturnType<typeof useDeleteIncidentMutation>;
export type DeleteIncidentMutationResult = Apollo.MutationResult<DeleteIncidentMutation>;
export type DeleteIncidentMutationOptions = Apollo.BaseMutationOptions<DeleteIncidentMutation, DeleteIncidentMutationVariables>;
export const LinkScenarioToIncidentsDocument = gql`
    mutation linkScenarioToIncidents($scenarioId: UxId!, $incidentIds: [UxId!]!) {
  linkScenarioToIncidents(scenarioId: $scenarioId, incidentIds: $incidentIds)
}
    `;
export type LinkScenarioToIncidentsMutationFn = Apollo.MutationFunction<LinkScenarioToIncidentsMutation, LinkScenarioToIncidentsMutationVariables>;

/**
 * __useLinkScenarioToIncidentsMutation__
 *
 * To run a mutation, you first call `useLinkScenarioToIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkScenarioToIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkScenarioToIncidentsMutation, { data, loading, error }] = useLinkScenarioToIncidentsMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      incidentIds: // value for 'incidentIds'
 *   },
 * });
 */
export function useLinkScenarioToIncidentsMutation(baseOptions?: Apollo.MutationHookOptions<LinkScenarioToIncidentsMutation, LinkScenarioToIncidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkScenarioToIncidentsMutation, LinkScenarioToIncidentsMutationVariables>(LinkScenarioToIncidentsDocument, options);
      }
export type LinkScenarioToIncidentsMutationHookResult = ReturnType<typeof useLinkScenarioToIncidentsMutation>;
export type LinkScenarioToIncidentsMutationResult = Apollo.MutationResult<LinkScenarioToIncidentsMutation>;
export type LinkScenarioToIncidentsMutationOptions = Apollo.BaseMutationOptions<LinkScenarioToIncidentsMutation, LinkScenarioToIncidentsMutationVariables>;
export const LinkIncidentToScenariosDocument = gql`
    mutation linkIncidentToScenarios($incidentId: UxId!, $scenarioIds: [UxId!]!) {
  linkIncidentToScenarios(incidentId: $incidentId, scenarioIds: $scenarioIds)
}
    `;
export type LinkIncidentToScenariosMutationFn = Apollo.MutationFunction<LinkIncidentToScenariosMutation, LinkIncidentToScenariosMutationVariables>;

/**
 * __useLinkIncidentToScenariosMutation__
 *
 * To run a mutation, you first call `useLinkIncidentToScenariosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkIncidentToScenariosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkIncidentToScenariosMutation, { data, loading, error }] = useLinkIncidentToScenariosMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      scenarioIds: // value for 'scenarioIds'
 *   },
 * });
 */
export function useLinkIncidentToScenariosMutation(baseOptions?: Apollo.MutationHookOptions<LinkIncidentToScenariosMutation, LinkIncidentToScenariosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkIncidentToScenariosMutation, LinkIncidentToScenariosMutationVariables>(LinkIncidentToScenariosDocument, options);
      }
export type LinkIncidentToScenariosMutationHookResult = ReturnType<typeof useLinkIncidentToScenariosMutation>;
export type LinkIncidentToScenariosMutationResult = Apollo.MutationResult<LinkIncidentToScenariosMutation>;
export type LinkIncidentToScenariosMutationOptions = Apollo.BaseMutationOptions<LinkIncidentToScenariosMutation, LinkIncidentToScenariosMutationVariables>;
export const UnlinkIncidentFromScenariosDocument = gql`
    mutation unlinkIncidentFromScenarios($incidentId: UxId!, $scenarioIds: [UxId!]!) {
  unlinkIncidentFromScenarios(incidentId: $incidentId, scenarioIds: $scenarioIds)
}
    `;
export type UnlinkIncidentFromScenariosMutationFn = Apollo.MutationFunction<UnlinkIncidentFromScenariosMutation, UnlinkIncidentFromScenariosMutationVariables>;

/**
 * __useUnlinkIncidentFromScenariosMutation__
 *
 * To run a mutation, you first call `useUnlinkIncidentFromScenariosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkIncidentFromScenariosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkIncidentFromScenariosMutation, { data, loading, error }] = useUnlinkIncidentFromScenariosMutation({
 *   variables: {
 *      incidentId: // value for 'incidentId'
 *      scenarioIds: // value for 'scenarioIds'
 *   },
 * });
 */
export function useUnlinkIncidentFromScenariosMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkIncidentFromScenariosMutation, UnlinkIncidentFromScenariosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkIncidentFromScenariosMutation, UnlinkIncidentFromScenariosMutationVariables>(UnlinkIncidentFromScenariosDocument, options);
      }
export type UnlinkIncidentFromScenariosMutationHookResult = ReturnType<typeof useUnlinkIncidentFromScenariosMutation>;
export type UnlinkIncidentFromScenariosMutationResult = Apollo.MutationResult<UnlinkIncidentFromScenariosMutation>;
export type UnlinkIncidentFromScenariosMutationOptions = Apollo.BaseMutationOptions<UnlinkIncidentFromScenariosMutation, UnlinkIncidentFromScenariosMutationVariables>;
export const UnlinkScenarioFromControlsDocument = gql`
    mutation unlinkScenarioFromControls($scenarioId: UxId!, $controlIds: [UxId!]!) {
  unlinkScenarioFromControls(scenarioId: $scenarioId, controlIds: $controlIds)
}
    `;
export type UnlinkScenarioFromControlsMutationFn = Apollo.MutationFunction<UnlinkScenarioFromControlsMutation, UnlinkScenarioFromControlsMutationVariables>;

/**
 * __useUnlinkScenarioFromControlsMutation__
 *
 * To run a mutation, you first call `useUnlinkScenarioFromControlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkScenarioFromControlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkScenarioFromControlsMutation, { data, loading, error }] = useUnlinkScenarioFromControlsMutation({
 *   variables: {
 *      scenarioId: // value for 'scenarioId'
 *      controlIds: // value for 'controlIds'
 *   },
 * });
 */
export function useUnlinkScenarioFromControlsMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkScenarioFromControlsMutation, UnlinkScenarioFromControlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkScenarioFromControlsMutation, UnlinkScenarioFromControlsMutationVariables>(UnlinkScenarioFromControlsDocument, options);
      }
export type UnlinkScenarioFromControlsMutationHookResult = ReturnType<typeof useUnlinkScenarioFromControlsMutation>;
export type UnlinkScenarioFromControlsMutationResult = Apollo.MutationResult<UnlinkScenarioFromControlsMutation>;
export type UnlinkScenarioFromControlsMutationOptions = Apollo.BaseMutationOptions<UnlinkScenarioFromControlsMutation, UnlinkScenarioFromControlsMutationVariables>;
export const DeleteControlsDocument = gql`
    mutation deleteControls($ids: [UxId!]!) {
  deleteControls(ids: $ids)
}
    `;
export type DeleteControlsMutationFn = Apollo.MutationFunction<DeleteControlsMutation, DeleteControlsMutationVariables>;

/**
 * __useDeleteControlsMutation__
 *
 * To run a mutation, you first call `useDeleteControlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteControlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteControlsMutation, { data, loading, error }] = useDeleteControlsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteControlsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteControlsMutation, DeleteControlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteControlsMutation, DeleteControlsMutationVariables>(DeleteControlsDocument, options);
      }
export type DeleteControlsMutationHookResult = ReturnType<typeof useDeleteControlsMutation>;
export type DeleteControlsMutationResult = Apollo.MutationResult<DeleteControlsMutation>;
export type DeleteControlsMutationOptions = Apollo.BaseMutationOptions<DeleteControlsMutation, DeleteControlsMutationVariables>;
export const LinkFrameworkControlsToScenariosDocument = gql`
    mutation linkFrameworkControlsToScenarios($frameworkControlScenarioLinks: [FrameworkControlScenarioInput!]!, $addRecommendedModifiers: Boolean!) {
  linkFrameworkControlsToScenarios(
    frameworkControlScenarioLinks: $frameworkControlScenarioLinks
    addRecommendedModifiers: $addRecommendedModifiers
  ) {
    id
  }
}
    `;
export type LinkFrameworkControlsToScenariosMutationFn = Apollo.MutationFunction<LinkFrameworkControlsToScenariosMutation, LinkFrameworkControlsToScenariosMutationVariables>;

/**
 * __useLinkFrameworkControlsToScenariosMutation__
 *
 * To run a mutation, you first call `useLinkFrameworkControlsToScenariosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkFrameworkControlsToScenariosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkFrameworkControlsToScenariosMutation, { data, loading, error }] = useLinkFrameworkControlsToScenariosMutation({
 *   variables: {
 *      frameworkControlScenarioLinks: // value for 'frameworkControlScenarioLinks'
 *      addRecommendedModifiers: // value for 'addRecommendedModifiers'
 *   },
 * });
 */
export function useLinkFrameworkControlsToScenariosMutation(baseOptions?: Apollo.MutationHookOptions<LinkFrameworkControlsToScenariosMutation, LinkFrameworkControlsToScenariosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkFrameworkControlsToScenariosMutation, LinkFrameworkControlsToScenariosMutationVariables>(LinkFrameworkControlsToScenariosDocument, options);
      }
export type LinkFrameworkControlsToScenariosMutationHookResult = ReturnType<typeof useLinkFrameworkControlsToScenariosMutation>;
export type LinkFrameworkControlsToScenariosMutationResult = Apollo.MutationResult<LinkFrameworkControlsToScenariosMutation>;
export type LinkFrameworkControlsToScenariosMutationOptions = Apollo.BaseMutationOptions<LinkFrameworkControlsToScenariosMutation, LinkFrameworkControlsToScenariosMutationVariables>;
export const AddControlsFromLibraryDocument = gql`
    mutation addControlsFromLibrary($workspaceId: UxId!, $controlIds: [ControlFromLibraryInput!]!, $addRecommendedModifiers: Boolean) {
  addControlsFromLibrary(
    workspaceId: $workspaceId
    controlIds: $controlIds
    addRecommendedModifiers: $addRecommendedModifiers
  ) {
    id
  }
}
    `;
export type AddControlsFromLibraryMutationFn = Apollo.MutationFunction<AddControlsFromLibraryMutation, AddControlsFromLibraryMutationVariables>;

/**
 * __useAddControlsFromLibraryMutation__
 *
 * To run a mutation, you first call `useAddControlsFromLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddControlsFromLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addControlsFromLibraryMutation, { data, loading, error }] = useAddControlsFromLibraryMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      controlIds: // value for 'controlIds'
 *      addRecommendedModifiers: // value for 'addRecommendedModifiers'
 *   },
 * });
 */
export function useAddControlsFromLibraryMutation(baseOptions?: Apollo.MutationHookOptions<AddControlsFromLibraryMutation, AddControlsFromLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddControlsFromLibraryMutation, AddControlsFromLibraryMutationVariables>(AddControlsFromLibraryDocument, options);
      }
export type AddControlsFromLibraryMutationHookResult = ReturnType<typeof useAddControlsFromLibraryMutation>;
export type AddControlsFromLibraryMutationResult = Apollo.MutationResult<AddControlsFromLibraryMutation>;
export type AddControlsFromLibraryMutationOptions = Apollo.BaseMutationOptions<AddControlsFromLibraryMutation, AddControlsFromLibraryMutationVariables>;
export const DeleteScenarioDocument = gql`
    mutation deleteScenario($id: UxId!) {
  deleteScenario(id: $id)
}
    `;
export type DeleteScenarioMutationFn = Apollo.MutationFunction<DeleteScenarioMutation, DeleteScenarioMutationVariables>;

/**
 * __useDeleteScenarioMutation__
 *
 * To run a mutation, you first call `useDeleteScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScenarioMutation, { data, loading, error }] = useDeleteScenarioMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScenarioMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScenarioMutation, DeleteScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScenarioMutation, DeleteScenarioMutationVariables>(DeleteScenarioDocument, options);
      }
export type DeleteScenarioMutationHookResult = ReturnType<typeof useDeleteScenarioMutation>;
export type DeleteScenarioMutationResult = Apollo.MutationResult<DeleteScenarioMutation>;
export type DeleteScenarioMutationOptions = Apollo.BaseMutationOptions<DeleteScenarioMutation, DeleteScenarioMutationVariables>;
export const UpsertAssessmentVariablesDocument = gql`
    mutation upsertAssessmentVariables($assessmentId: UxId!, $variables: [VariableInput!]!) {
  upsertAssessmentVariables(assessmentId: $assessmentId, variables: $variables) {
    id
  }
}
    `;
export type UpsertAssessmentVariablesMutationFn = Apollo.MutationFunction<UpsertAssessmentVariablesMutation, UpsertAssessmentVariablesMutationVariables>;

/**
 * __useUpsertAssessmentVariablesMutation__
 *
 * To run a mutation, you first call `useUpsertAssessmentVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssessmentVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssessmentVariablesMutation, { data, loading, error }] = useUpsertAssessmentVariablesMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useUpsertAssessmentVariablesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAssessmentVariablesMutation, UpsertAssessmentVariablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAssessmentVariablesMutation, UpsertAssessmentVariablesMutationVariables>(UpsertAssessmentVariablesDocument, options);
      }
export type UpsertAssessmentVariablesMutationHookResult = ReturnType<typeof useUpsertAssessmentVariablesMutation>;
export type UpsertAssessmentVariablesMutationResult = Apollo.MutationResult<UpsertAssessmentVariablesMutation>;
export type UpsertAssessmentVariablesMutationOptions = Apollo.BaseMutationOptions<UpsertAssessmentVariablesMutation, UpsertAssessmentVariablesMutationVariables>;
export const UpsertControlDocument = gql`
    mutation upsertControl($controlData: ControlInput!, $workspaceId: UxId) {
  upsertControl(controlData: $controlData, workspaceId: $workspaceId) {
    id
  }
}
    `;
export type UpsertControlMutationFn = Apollo.MutationFunction<UpsertControlMutation, UpsertControlMutationVariables>;

/**
 * __useUpsertControlMutation__
 *
 * To run a mutation, you first call `useUpsertControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertControlMutation, { data, loading, error }] = useUpsertControlMutation({
 *   variables: {
 *      controlData: // value for 'controlData'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUpsertControlMutation(baseOptions?: Apollo.MutationHookOptions<UpsertControlMutation, UpsertControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertControlMutation, UpsertControlMutationVariables>(UpsertControlDocument, options);
      }
export type UpsertControlMutationHookResult = ReturnType<typeof useUpsertControlMutation>;
export type UpsertControlMutationResult = Apollo.MutationResult<UpsertControlMutation>;
export type UpsertControlMutationOptions = Apollo.BaseMutationOptions<UpsertControlMutation, UpsertControlMutationVariables>;
export const UpsertControlsDocument = gql`
    mutation upsertControls($workspaceId: UxId!, $controlsData: [ControlInput!]!) {
  upsertControls(workspaceId: $workspaceId, controlsData: $controlsData) {
    id
  }
}
    `;
export type UpsertControlsMutationFn = Apollo.MutationFunction<UpsertControlsMutation, UpsertControlsMutationVariables>;

/**
 * __useUpsertControlsMutation__
 *
 * To run a mutation, you first call `useUpsertControlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertControlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertControlsMutation, { data, loading, error }] = useUpsertControlsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      controlsData: // value for 'controlsData'
 *   },
 * });
 */
export function useUpsertControlsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertControlsMutation, UpsertControlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertControlsMutation, UpsertControlsMutationVariables>(UpsertControlsDocument, options);
      }
export type UpsertControlsMutationHookResult = ReturnType<typeof useUpsertControlsMutation>;
export type UpsertControlsMutationResult = Apollo.MutationResult<UpsertControlsMutation>;
export type UpsertControlsMutationOptions = Apollo.BaseMutationOptions<UpsertControlsMutation, UpsertControlsMutationVariables>;
export const UpsertIncidentsDocument = gql`
    mutation upsertIncidents($workspaceId: UxId!, $incidentsData: [IncidentInput!]!) {
  upsertIncidents(workspaceId: $workspaceId, incidentsData: $incidentsData) {
    id
    ref
  }
}
    `;
export type UpsertIncidentsMutationFn = Apollo.MutationFunction<UpsertIncidentsMutation, UpsertIncidentsMutationVariables>;

/**
 * __useUpsertIncidentsMutation__
 *
 * To run a mutation, you first call `useUpsertIncidentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertIncidentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertIncidentsMutation, { data, loading, error }] = useUpsertIncidentsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      incidentsData: // value for 'incidentsData'
 *   },
 * });
 */
export function useUpsertIncidentsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertIncidentsMutation, UpsertIncidentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertIncidentsMutation, UpsertIncidentsMutationVariables>(UpsertIncidentsDocument, options);
      }
export type UpsertIncidentsMutationHookResult = ReturnType<typeof useUpsertIncidentsMutation>;
export type UpsertIncidentsMutationResult = Apollo.MutationResult<UpsertIncidentsMutation>;
export type UpsertIncidentsMutationOptions = Apollo.BaseMutationOptions<UpsertIncidentsMutation, UpsertIncidentsMutationVariables>;
export const UpsertScenarioDocument = gql`
    mutation upsertScenario($assessmentId: UxId, $scenarioData: ScenarioInput!) {
  upsertScenario(assessmentId: $assessmentId, scenarioData: $scenarioData) {
    id
  }
}
    `;
export type UpsertScenarioMutationFn = Apollo.MutationFunction<UpsertScenarioMutation, UpsertScenarioMutationVariables>;

/**
 * __useUpsertScenarioMutation__
 *
 * To run a mutation, you first call `useUpsertScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertScenarioMutation, { data, loading, error }] = useUpsertScenarioMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      scenarioData: // value for 'scenarioData'
 *   },
 * });
 */
export function useUpsertScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpsertScenarioMutation, UpsertScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertScenarioMutation, UpsertScenarioMutationVariables>(UpsertScenarioDocument, options);
      }
export type UpsertScenarioMutationHookResult = ReturnType<typeof useUpsertScenarioMutation>;
export type UpsertScenarioMutationResult = Apollo.MutationResult<UpsertScenarioMutation>;
export type UpsertScenarioMutationOptions = Apollo.BaseMutationOptions<UpsertScenarioMutation, UpsertScenarioMutationVariables>;
export const AddScenarioToGroupDocument = gql`
    mutation addScenarioToGroup($groupId: UxId, $scenarioId: UxId!) {
  addScenarioToGroup(groupId: $groupId, scenarioId: $scenarioId) {
    id
  }
}
    `;
export type AddScenarioToGroupMutationFn = Apollo.MutationFunction<AddScenarioToGroupMutation, AddScenarioToGroupMutationVariables>;

/**
 * __useAddScenarioToGroupMutation__
 *
 * To run a mutation, you first call `useAddScenarioToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScenarioToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScenarioToGroupMutation, { data, loading, error }] = useAddScenarioToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useAddScenarioToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddScenarioToGroupMutation, AddScenarioToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddScenarioToGroupMutation, AddScenarioToGroupMutationVariables>(AddScenarioToGroupDocument, options);
      }
export type AddScenarioToGroupMutationHookResult = ReturnType<typeof useAddScenarioToGroupMutation>;
export type AddScenarioToGroupMutationResult = Apollo.MutationResult<AddScenarioToGroupMutation>;
export type AddScenarioToGroupMutationOptions = Apollo.BaseMutationOptions<AddScenarioToGroupMutation, AddScenarioToGroupMutationVariables>;
export const UpsertScenariosDocument = gql`
    mutation upsertScenarios($assessmentId: UxId, $scenariosData: [ScenarioInput!]!) {
  upsertScenarios(assessmentId: $assessmentId, scenariosData: $scenariosData) {
    id
  }
}
    `;
export type UpsertScenariosMutationFn = Apollo.MutationFunction<UpsertScenariosMutation, UpsertScenariosMutationVariables>;

/**
 * __useUpsertScenariosMutation__
 *
 * To run a mutation, you first call `useUpsertScenariosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertScenariosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertScenariosMutation, { data, loading, error }] = useUpsertScenariosMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      scenariosData: // value for 'scenariosData'
 *   },
 * });
 */
export function useUpsertScenariosMutation(baseOptions?: Apollo.MutationHookOptions<UpsertScenariosMutation, UpsertScenariosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertScenariosMutation, UpsertScenariosMutationVariables>(UpsertScenariosDocument, options);
      }
export type UpsertScenariosMutationHookResult = ReturnType<typeof useUpsertScenariosMutation>;
export type UpsertScenariosMutationResult = Apollo.MutationResult<UpsertScenariosMutation>;
export type UpsertScenariosMutationOptions = Apollo.BaseMutationOptions<UpsertScenariosMutation, UpsertScenariosMutationVariables>;
export const CloneAssessmentDocument = gql`
    mutation cloneAssessment($id: UxId!, $incidents: LinkOptionInput, $riskManagementPlan: LinkOptionInput) {
  cloneAssessment(
    id: $id
    incidents: $incidents
    riskManagementPlan: $riskManagementPlan
  ) {
    id
    name
  }
}
    `;
export type CloneAssessmentMutationFn = Apollo.MutationFunction<CloneAssessmentMutation, CloneAssessmentMutationVariables>;

/**
 * __useCloneAssessmentMutation__
 *
 * To run a mutation, you first call `useCloneAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneAssessmentMutation, { data, loading, error }] = useCloneAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      incidents: // value for 'incidents'
 *      riskManagementPlan: // value for 'riskManagementPlan'
 *   },
 * });
 */
export function useCloneAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<CloneAssessmentMutation, CloneAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneAssessmentMutation, CloneAssessmentMutationVariables>(CloneAssessmentDocument, options);
      }
export type CloneAssessmentMutationHookResult = ReturnType<typeof useCloneAssessmentMutation>;
export type CloneAssessmentMutationResult = Apollo.MutationResult<CloneAssessmentMutation>;
export type CloneAssessmentMutationOptions = Apollo.BaseMutationOptions<CloneAssessmentMutation, CloneAssessmentMutationVariables>;
export const UpsertEventDocument = gql`
    mutation upsertEvent($workspaceId: UxId, $eventData: [EventInput!]!) {
  upsertEvent(workspaceId: $workspaceId, eventData: $eventData) {
    id
  }
}
    `;
export type UpsertEventMutationFn = Apollo.MutationFunction<UpsertEventMutation, UpsertEventMutationVariables>;

/**
 * __useUpsertEventMutation__
 *
 * To run a mutation, you first call `useUpsertEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEventMutation, { data, loading, error }] = useUpsertEventMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      eventData: // value for 'eventData'
 *   },
 * });
 */
export function useUpsertEventMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEventMutation, UpsertEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEventMutation, UpsertEventMutationVariables>(UpsertEventDocument, options);
      }
export type UpsertEventMutationHookResult = ReturnType<typeof useUpsertEventMutation>;
export type UpsertEventMutationResult = Apollo.MutationResult<UpsertEventMutation>;
export type UpsertEventMutationOptions = Apollo.BaseMutationOptions<UpsertEventMutation, UpsertEventMutationVariables>;
export const DeleteEventDocument = gql`
    mutation deleteEvent($id: UxId!) {
  deleteEvent(id: $id)
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const UpsertModifiersDocument = gql`
    mutation upsertModifiers($control_id: UxId!, $scenario_id: UxId!, $modifiers: ModifierInput!) {
  upsertModifiers(
    control_id: $control_id
    scenario_id: $scenario_id
    modifiers: $modifiers
  )
}
    `;
export type UpsertModifiersMutationFn = Apollo.MutationFunction<UpsertModifiersMutation, UpsertModifiersMutationVariables>;

/**
 * __useUpsertModifiersMutation__
 *
 * To run a mutation, you first call `useUpsertModifiersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertModifiersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertModifiersMutation, { data, loading, error }] = useUpsertModifiersMutation({
 *   variables: {
 *      control_id: // value for 'control_id'
 *      scenario_id: // value for 'scenario_id'
 *      modifiers: // value for 'modifiers'
 *   },
 * });
 */
export function useUpsertModifiersMutation(baseOptions?: Apollo.MutationHookOptions<UpsertModifiersMutation, UpsertModifiersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertModifiersMutation, UpsertModifiersMutationVariables>(UpsertModifiersDocument, options);
      }
export type UpsertModifiersMutationHookResult = ReturnType<typeof useUpsertModifiersMutation>;
export type UpsertModifiersMutationResult = Apollo.MutationResult<UpsertModifiersMutation>;
export type UpsertModifiersMutationOptions = Apollo.BaseMutationOptions<UpsertModifiersMutation, UpsertModifiersMutationVariables>;
export const CreateExportJobDocument = gql`
    mutation createExportJob($reportType: ExportReportType!, $reportParams: String, $access: ExportAccess!) {
  createExportJob(
    reportType: $reportType
    reportParams: $reportParams
    access: $access
  ) {
    id
    status
  }
}
    `;
export type CreateExportJobMutationFn = Apollo.MutationFunction<CreateExportJobMutation, CreateExportJobMutationVariables>;

/**
 * __useCreateExportJobMutation__
 *
 * To run a mutation, you first call `useCreateExportJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportJobMutation, { data, loading, error }] = useCreateExportJobMutation({
 *   variables: {
 *      reportType: // value for 'reportType'
 *      reportParams: // value for 'reportParams'
 *      access: // value for 'access'
 *   },
 * });
 */
export function useCreateExportJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportJobMutation, CreateExportJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportJobMutation, CreateExportJobMutationVariables>(CreateExportJobDocument, options);
      }
export type CreateExportJobMutationHookResult = ReturnType<typeof useCreateExportJobMutation>;
export type CreateExportJobMutationResult = Apollo.MutationResult<CreateExportJobMutation>;
export type CreateExportJobMutationOptions = Apollo.BaseMutationOptions<CreateExportJobMutation, CreateExportJobMutationVariables>;
export const DeleteUserExportJobsDocument = gql`
    mutation deleteUserExportJobs($jobIds: [UxId!]!) {
  deleteUserExportJobs(jobIds: $jobIds)
}
    `;
export type DeleteUserExportJobsMutationFn = Apollo.MutationFunction<DeleteUserExportJobsMutation, DeleteUserExportJobsMutationVariables>;

/**
 * __useDeleteUserExportJobsMutation__
 *
 * To run a mutation, you first call `useDeleteUserExportJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserExportJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserExportJobsMutation, { data, loading, error }] = useDeleteUserExportJobsMutation({
 *   variables: {
 *      jobIds: // value for 'jobIds'
 *   },
 * });
 */
export function useDeleteUserExportJobsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserExportJobsMutation, DeleteUserExportJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserExportJobsMutation, DeleteUserExportJobsMutationVariables>(DeleteUserExportJobsDocument, options);
      }
export type DeleteUserExportJobsMutationHookResult = ReturnType<typeof useDeleteUserExportJobsMutation>;
export type DeleteUserExportJobsMutationResult = Apollo.MutationResult<DeleteUserExportJobsMutation>;
export type DeleteUserExportJobsMutationOptions = Apollo.BaseMutationOptions<DeleteUserExportJobsMutation, DeleteUserExportJobsMutationVariables>;
export const ReportDownloadUrlDocument = gql`
    mutation reportDownloadUrl($jobId: UxId!) {
  reportDownloadUrl(jobId: $jobId)
}
    `;
export type ReportDownloadUrlMutationFn = Apollo.MutationFunction<ReportDownloadUrlMutation, ReportDownloadUrlMutationVariables>;

/**
 * __useReportDownloadUrlMutation__
 *
 * To run a mutation, you first call `useReportDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportDownloadUrlMutation, { data, loading, error }] = useReportDownloadUrlMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useReportDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<ReportDownloadUrlMutation, ReportDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportDownloadUrlMutation, ReportDownloadUrlMutationVariables>(ReportDownloadUrlDocument, options);
      }
export type ReportDownloadUrlMutationHookResult = ReturnType<typeof useReportDownloadUrlMutation>;
export type ReportDownloadUrlMutationResult = Apollo.MutationResult<ReportDownloadUrlMutation>;
export type ReportDownloadUrlMutationOptions = Apollo.BaseMutationOptions<ReportDownloadUrlMutation, ReportDownloadUrlMutationVariables>;
export const AcceptTermsDocument = gql`
    mutation acceptTerms($termsId: UxId!, $acceptedMethod: String!) {
  acceptTerms(termsId: $termsId, acceptedMethod: $acceptedMethod)
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *      termsId: // value for 'termsId'
 *      acceptedMethod: // value for 'acceptedMethod'
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const RequestLogoUploadDocument = gql`
    mutation requestLogoUpload($contentType: String!, $extension: String!) {
  requestLogoUpload(contentType: $contentType, extension: $extension) {
    uploadUrl
    key
    publicUrl
  }
}
    `;
export type RequestLogoUploadMutationFn = Apollo.MutationFunction<RequestLogoUploadMutation, RequestLogoUploadMutationVariables>;

/**
 * __useRequestLogoUploadMutation__
 *
 * To run a mutation, you first call `useRequestLogoUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestLogoUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestLogoUploadMutation, { data, loading, error }] = useRequestLogoUploadMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      extension: // value for 'extension'
 *   },
 * });
 */
export function useRequestLogoUploadMutation(baseOptions?: Apollo.MutationHookOptions<RequestLogoUploadMutation, RequestLogoUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestLogoUploadMutation, RequestLogoUploadMutationVariables>(RequestLogoUploadDocument, options);
      }
export type RequestLogoUploadMutationHookResult = ReturnType<typeof useRequestLogoUploadMutation>;
export type RequestLogoUploadMutationResult = Apollo.MutationResult<RequestLogoUploadMutation>;
export type RequestLogoUploadMutationOptions = Apollo.BaseMutationOptions<RequestLogoUploadMutation, RequestLogoUploadMutationVariables>;
export const DeferTermsDocument = gql`
    mutation deferTerms($termsId: UxId!) {
  deferTerms(termsId: $termsId)
}
    `;
export type DeferTermsMutationFn = Apollo.MutationFunction<DeferTermsMutation, DeferTermsMutationVariables>;

/**
 * __useDeferTermsMutation__
 *
 * To run a mutation, you first call `useDeferTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeferTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deferTermsMutation, { data, loading, error }] = useDeferTermsMutation({
 *   variables: {
 *      termsId: // value for 'termsId'
 *   },
 * });
 */
export function useDeferTermsMutation(baseOptions?: Apollo.MutationHookOptions<DeferTermsMutation, DeferTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeferTermsMutation, DeferTermsMutationVariables>(DeferTermsDocument, options);
      }
export type DeferTermsMutationHookResult = ReturnType<typeof useDeferTermsMutation>;
export type DeferTermsMutationResult = Apollo.MutationResult<DeferTermsMutation>;
export type DeferTermsMutationOptions = Apollo.BaseMutationOptions<DeferTermsMutation, DeferTermsMutationVariables>;
export const SetActiveWorkspaceDocument = gql`
    mutation setActiveWorkspace($workspaceId: UxId!) {
  setActiveWorkspace(workspaceId: $workspaceId) {
    activeWorkspace {
      id
    }
  }
}
    `;
export type SetActiveWorkspaceMutationFn = Apollo.MutationFunction<SetActiveWorkspaceMutation, SetActiveWorkspaceMutationVariables>;

/**
 * __useSetActiveWorkspaceMutation__
 *
 * To run a mutation, you first call `useSetActiveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveWorkspaceMutation, { data, loading, error }] = useSetActiveWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useSetActiveWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveWorkspaceMutation, SetActiveWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveWorkspaceMutation, SetActiveWorkspaceMutationVariables>(SetActiveWorkspaceDocument, options);
      }
export type SetActiveWorkspaceMutationHookResult = ReturnType<typeof useSetActiveWorkspaceMutation>;
export type SetActiveWorkspaceMutationResult = Apollo.MutationResult<SetActiveWorkspaceMutation>;
export type SetActiveWorkspaceMutationOptions = Apollo.BaseMutationOptions<SetActiveWorkspaceMutation, SetActiveWorkspaceMutationVariables>;
export const CancelInviteDocument = gql`
    mutation cancelInvite($inviteId: UxId!) {
  cancelInvite(inviteId: $inviteId)
}
    `;
export type CancelInviteMutationFn = Apollo.MutationFunction<CancelInviteMutation, CancelInviteMutationVariables>;

/**
 * __useCancelInviteMutation__
 *
 * To run a mutation, you first call `useCancelInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInviteMutation, { data, loading, error }] = useCancelInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useCancelInviteMutation(baseOptions?: Apollo.MutationHookOptions<CancelInviteMutation, CancelInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInviteMutation, CancelInviteMutationVariables>(CancelInviteDocument, options);
      }
export type CancelInviteMutationHookResult = ReturnType<typeof useCancelInviteMutation>;
export type CancelInviteMutationResult = Apollo.MutationResult<CancelInviteMutation>;
export type CancelInviteMutationOptions = Apollo.BaseMutationOptions<CancelInviteMutation, CancelInviteMutationVariables>;
export const AcceptInviteDocument = gql`
    mutation acceptInvite($inviteId: UxId!) {
  acceptInvite(inviteId: $inviteId)
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const RejectInviteDocument = gql`
    mutation rejectInvite($inviteId: UxId!) {
  rejectInvite(inviteId: $inviteId)
}
    `;
export type RejectInviteMutationFn = Apollo.MutationFunction<RejectInviteMutation, RejectInviteMutationVariables>;

/**
 * __useRejectInviteMutation__
 *
 * To run a mutation, you first call `useRejectInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectInviteMutation, { data, loading, error }] = useRejectInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useRejectInviteMutation(baseOptions?: Apollo.MutationHookOptions<RejectInviteMutation, RejectInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectInviteMutation, RejectInviteMutationVariables>(RejectInviteDocument, options);
      }
export type RejectInviteMutationHookResult = ReturnType<typeof useRejectInviteMutation>;
export type RejectInviteMutationResult = Apollo.MutationResult<RejectInviteMutation>;
export type RejectInviteMutationOptions = Apollo.BaseMutationOptions<RejectInviteMutation, RejectInviteMutationVariables>;
export const GrantAdminDocument = gql`
    mutation grantAdmin($workspaceId: UxId, $organisationId: UxId, $userId: Int!) {
  grantAdmin(
    workspaceId: $workspaceId
    organisationId: $organisationId
    userId: $userId
  )
}
    `;
export type GrantAdminMutationFn = Apollo.MutationFunction<GrantAdminMutation, GrantAdminMutationVariables>;

/**
 * __useGrantAdminMutation__
 *
 * To run a mutation, you first call `useGrantAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantAdminMutation, { data, loading, error }] = useGrantAdminMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGrantAdminMutation(baseOptions?: Apollo.MutationHookOptions<GrantAdminMutation, GrantAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantAdminMutation, GrantAdminMutationVariables>(GrantAdminDocument, options);
      }
export type GrantAdminMutationHookResult = ReturnType<typeof useGrantAdminMutation>;
export type GrantAdminMutationResult = Apollo.MutationResult<GrantAdminMutation>;
export type GrantAdminMutationOptions = Apollo.BaseMutationOptions<GrantAdminMutation, GrantAdminMutationVariables>;
export const RemoveUserDocument = gql`
    mutation removeUser($workspaceId: UxId, $organisationId: UxId, $userId: Int!) {
  removeUser(
    workspaceId: $workspaceId
    organisationId: $organisationId
    userId: $userId
  )
}
    `;
export type RemoveUserMutationFn = Apollo.MutationFunction<RemoveUserMutation, RemoveUserMutationVariables>;

/**
 * __useRemoveUserMutation__
 *
 * To run a mutation, you first call `useRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserMutation, { data, loading, error }] = useRemoveUserMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserMutation, RemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument, options);
      }
export type RemoveUserMutationHookResult = ReturnType<typeof useRemoveUserMutation>;
export type RemoveUserMutationResult = Apollo.MutationResult<RemoveUserMutation>;
export type RemoveUserMutationOptions = Apollo.BaseMutationOptions<RemoveUserMutation, RemoveUserMutationVariables>;
export const RemovePeopleDocument = gql`
    mutation removePeople($id: String!) {
  removePeople(id: $id)
}
    `;
export type RemovePeopleMutationFn = Apollo.MutationFunction<RemovePeopleMutation, RemovePeopleMutationVariables>;

/**
 * __useRemovePeopleMutation__
 *
 * To run a mutation, you first call `useRemovePeopleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePeopleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePeopleMutation, { data, loading, error }] = useRemovePeopleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePeopleMutation(baseOptions?: Apollo.MutationHookOptions<RemovePeopleMutation, RemovePeopleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePeopleMutation, RemovePeopleMutationVariables>(RemovePeopleDocument, options);
      }
export type RemovePeopleMutationHookResult = ReturnType<typeof useRemovePeopleMutation>;
export type RemovePeopleMutationResult = Apollo.MutationResult<RemovePeopleMutation>;
export type RemovePeopleMutationOptions = Apollo.BaseMutationOptions<RemovePeopleMutation, RemovePeopleMutationVariables>;
export const CancelRequestDocument = gql`
    mutation cancelRequest($requestId: UxId, $organisationId: UxId, $workspaceId: UxId) {
  cancelRequest(
    requestId: $requestId
    organisationId: $organisationId
    workspaceId: $workspaceId
  )
}
    `;
export type CancelRequestMutationFn = Apollo.MutationFunction<CancelRequestMutation, CancelRequestMutationVariables>;

/**
 * __useCancelRequestMutation__
 *
 * To run a mutation, you first call `useCancelRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRequestMutation, { data, loading, error }] = useCancelRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      organisationId: // value for 'organisationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCancelRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelRequestMutation, CancelRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelRequestMutation, CancelRequestMutationVariables>(CancelRequestDocument, options);
      }
export type CancelRequestMutationHookResult = ReturnType<typeof useCancelRequestMutation>;
export type CancelRequestMutationResult = Apollo.MutationResult<CancelRequestMutation>;
export type CancelRequestMutationOptions = Apollo.BaseMutationOptions<CancelRequestMutation, CancelRequestMutationVariables>;
export const AcceptRequestDocument = gql`
    mutation acceptRequest($requestId: UxId!) {
  acceptRequest(requestId: $requestId)
}
    `;
export type AcceptRequestMutationFn = Apollo.MutationFunction<AcceptRequestMutation, AcceptRequestMutationVariables>;

/**
 * __useAcceptRequestMutation__
 *
 * To run a mutation, you first call `useAcceptRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptRequestMutation, { data, loading, error }] = useAcceptRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useAcceptRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptRequestMutation, AcceptRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptRequestMutation, AcceptRequestMutationVariables>(AcceptRequestDocument, options);
      }
export type AcceptRequestMutationHookResult = ReturnType<typeof useAcceptRequestMutation>;
export type AcceptRequestMutationResult = Apollo.MutationResult<AcceptRequestMutation>;
export type AcceptRequestMutationOptions = Apollo.BaseMutationOptions<AcceptRequestMutation, AcceptRequestMutationVariables>;
export const RequestAccessDocument = gql`
    mutation requestAccess($workspaceId: UxId, $organisationId: UxId) {
  requestAccess(workspaceId: $workspaceId, organisationId: $organisationId)
}
    `;
export type RequestAccessMutationFn = Apollo.MutationFunction<RequestAccessMutation, RequestAccessMutationVariables>;

/**
 * __useRequestAccessMutation__
 *
 * To run a mutation, you first call `useRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccessMutation, { data, loading, error }] = useRequestAccessMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useRequestAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestAccessMutation, RequestAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAccessMutation, RequestAccessMutationVariables>(RequestAccessDocument, options);
      }
export type RequestAccessMutationHookResult = ReturnType<typeof useRequestAccessMutation>;
export type RequestAccessMutationResult = Apollo.MutationResult<RequestAccessMutation>;
export type RequestAccessMutationOptions = Apollo.BaseMutationOptions<RequestAccessMutation, RequestAccessMutationVariables>;
export const RejectRequestDocument = gql`
    mutation rejectRequest($requestId: UxId!) {
  rejectRequest(requestId: $requestId)
}
    `;
export type RejectRequestMutationFn = Apollo.MutationFunction<RejectRequestMutation, RejectRequestMutationVariables>;

/**
 * __useRejectRequestMutation__
 *
 * To run a mutation, you first call `useRejectRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRequestMutation, { data, loading, error }] = useRejectRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRejectRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectRequestMutation, RejectRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectRequestMutation, RejectRequestMutationVariables>(RejectRequestDocument, options);
      }
export type RejectRequestMutationHookResult = ReturnType<typeof useRejectRequestMutation>;
export type RejectRequestMutationResult = Apollo.MutationResult<RejectRequestMutation>;
export type RejectRequestMutationOptions = Apollo.BaseMutationOptions<RejectRequestMutation, RejectRequestMutationVariables>;
export const InviteUsersDocument = gql`
    mutation inviteUsers($workspaceId: UxId, $organisationId: UxId, $invitesData: [InviteInput!]!) {
  inviteUsers(
    workspaceId: $workspaceId
    organisationId: $organisationId
    invitesData: $invitesData
  )
}
    `;
export type InviteUsersMutationFn = Apollo.MutationFunction<InviteUsersMutation, InviteUsersMutationVariables>;

/**
 * __useInviteUsersMutation__
 *
 * To run a mutation, you first call `useInviteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersMutation, { data, loading, error }] = useInviteUsersMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      organisationId: // value for 'organisationId'
 *      invitesData: // value for 'invitesData'
 *   },
 * });
 */
export function useInviteUsersMutation(baseOptions?: Apollo.MutationHookOptions<InviteUsersMutation, InviteUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsersMutation, InviteUsersMutationVariables>(InviteUsersDocument, options);
      }
export type InviteUsersMutationHookResult = ReturnType<typeof useInviteUsersMutation>;
export type InviteUsersMutationResult = Apollo.MutationResult<InviteUsersMutation>;
export type InviteUsersMutationOptions = Apollo.BaseMutationOptions<InviteUsersMutation, InviteUsersMutationVariables>;
export const UpsertWorkspaceDocument = gql`
    mutation upsertWorkspace($workspaceId: UxId, $organisationId: UxId, $name: String!, $primaryContact: String!, $plan: String, $isRestricted: Boolean!, $currency: String, $notificationScheduleTime: String, $reviewCadenceDays: Int, $planType: PlanType) {
  upsertWorkspace(
    workspaceId: $workspaceId
    organisationId: $organisationId
    name: $name
    primaryContact: $primaryContact
    plan: $plan
    isRestricted: $isRestricted
    currency: $currency
    notificationScheduleTime: $notificationScheduleTime
    reviewCadenceDays: $reviewCadenceDays
    planType: $planType
  ) {
    id
  }
}
    `;
export type UpsertWorkspaceMutationFn = Apollo.MutationFunction<UpsertWorkspaceMutation, UpsertWorkspaceMutationVariables>;

/**
 * __useUpsertWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpsertWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWorkspaceMutation, { data, loading, error }] = useUpsertWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      primaryContact: // value for 'primaryContact'
 *      plan: // value for 'plan'
 *      isRestricted: // value for 'isRestricted'
 *      currency: // value for 'currency'
 *      notificationScheduleTime: // value for 'notificationScheduleTime'
 *      reviewCadenceDays: // value for 'reviewCadenceDays'
 *      planType: // value for 'planType'
 *   },
 * });
 */
export function useUpsertWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<UpsertWorkspaceMutation, UpsertWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertWorkspaceMutation, UpsertWorkspaceMutationVariables>(UpsertWorkspaceDocument, options);
      }
export type UpsertWorkspaceMutationHookResult = ReturnType<typeof useUpsertWorkspaceMutation>;
export type UpsertWorkspaceMutationResult = Apollo.MutationResult<UpsertWorkspaceMutation>;
export type UpsertWorkspaceMutationOptions = Apollo.BaseMutationOptions<UpsertWorkspaceMutation, UpsertWorkspaceMutationVariables>;
export const UpsertOrganisationDocument = gql`
    mutation upsertOrganisation($organisationId: UxId, $name: String, $domain: String, $primaryContact: String, $billingContact: String, $logoKey: String, $primaryColor: String, $secondaryColor: String, $businessType: BusinessType, $organisationType: OrganisationType, $parentId: UxId, $createWorkspace: Boolean, $workspace: WorkspaceCreateInput) {
  upsertOrganisation(
    organisationId: $organisationId
    name: $name
    domain: $domain
    primaryContact: $primaryContact
    billingContact: $billingContact
    logoKey: $logoKey
    primaryColor: $primaryColor
    secondaryColor: $secondaryColor
    businessType: $businessType
    organisationType: $organisationType
    parentId: $parentId
    createWorkspace: $createWorkspace
    workspace: $workspace
  ) {
    id
  }
}
    `;
export type UpsertOrganisationMutationFn = Apollo.MutationFunction<UpsertOrganisationMutation, UpsertOrganisationMutationVariables>;

/**
 * __useUpsertOrganisationMutation__
 *
 * To run a mutation, you first call `useUpsertOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrganisationMutation, { data, loading, error }] = useUpsertOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      domain: // value for 'domain'
 *      primaryContact: // value for 'primaryContact'
 *      billingContact: // value for 'billingContact'
 *      logoKey: // value for 'logoKey'
 *      primaryColor: // value for 'primaryColor'
 *      secondaryColor: // value for 'secondaryColor'
 *      businessType: // value for 'businessType'
 *      organisationType: // value for 'organisationType'
 *      parentId: // value for 'parentId'
 *      createWorkspace: // value for 'createWorkspace'
 *      workspace: // value for 'workspace'
 *   },
 * });
 */
export function useUpsertOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOrganisationMutation, UpsertOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOrganisationMutation, UpsertOrganisationMutationVariables>(UpsertOrganisationDocument, options);
      }
export type UpsertOrganisationMutationHookResult = ReturnType<typeof useUpsertOrganisationMutation>;
export type UpsertOrganisationMutationResult = Apollo.MutationResult<UpsertOrganisationMutation>;
export type UpsertOrganisationMutationOptions = Apollo.BaseMutationOptions<UpsertOrganisationMutation, UpsertOrganisationMutationVariables>;
export const UpsertWorkspaceVariablesDocument = gql`
    mutation upsertWorkspaceVariables($workspaceId: UxId!, $variables: [VariableInput!]!) {
  upsertWorkspaceVariables(workspaceId: $workspaceId, variables: $variables) {
    id
  }
}
    `;
export type UpsertWorkspaceVariablesMutationFn = Apollo.MutationFunction<UpsertWorkspaceVariablesMutation, UpsertWorkspaceVariablesMutationVariables>;

/**
 * __useUpsertWorkspaceVariablesMutation__
 *
 * To run a mutation, you first call `useUpsertWorkspaceVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWorkspaceVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWorkspaceVariablesMutation, { data, loading, error }] = useUpsertWorkspaceVariablesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useUpsertWorkspaceVariablesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertWorkspaceVariablesMutation, UpsertWorkspaceVariablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertWorkspaceVariablesMutation, UpsertWorkspaceVariablesMutationVariables>(UpsertWorkspaceVariablesDocument, options);
      }
export type UpsertWorkspaceVariablesMutationHookResult = ReturnType<typeof useUpsertWorkspaceVariablesMutation>;
export type UpsertWorkspaceVariablesMutationResult = Apollo.MutationResult<UpsertWorkspaceVariablesMutation>;
export type UpsertWorkspaceVariablesMutationOptions = Apollo.BaseMutationOptions<UpsertWorkspaceVariablesMutation, UpsertWorkspaceVariablesMutationVariables>;
export const UpsertWorkspaceQuestionsDocument = gql`
    mutation upsertWorkspaceQuestions($workspaceId: UxId!, $questions: QuestionsInput!) {
  upsertWorkspaceQuestions(workspaceId: $workspaceId, questions: $questions) {
    id
  }
}
    `;
export type UpsertWorkspaceQuestionsMutationFn = Apollo.MutationFunction<UpsertWorkspaceQuestionsMutation, UpsertWorkspaceQuestionsMutationVariables>;

/**
 * __useUpsertWorkspaceQuestionsMutation__
 *
 * To run a mutation, you first call `useUpsertWorkspaceQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWorkspaceQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWorkspaceQuestionsMutation, { data, loading, error }] = useUpsertWorkspaceQuestionsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      questions: // value for 'questions'
 *   },
 * });
 */
export function useUpsertWorkspaceQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertWorkspaceQuestionsMutation, UpsertWorkspaceQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertWorkspaceQuestionsMutation, UpsertWorkspaceQuestionsMutationVariables>(UpsertWorkspaceQuestionsDocument, options);
      }
export type UpsertWorkspaceQuestionsMutationHookResult = ReturnType<typeof useUpsertWorkspaceQuestionsMutation>;
export type UpsertWorkspaceQuestionsMutationResult = Apollo.MutationResult<UpsertWorkspaceQuestionsMutation>;
export type UpsertWorkspaceQuestionsMutationOptions = Apollo.BaseMutationOptions<UpsertWorkspaceQuestionsMutation, UpsertWorkspaceQuestionsMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($orgUnitId: UxId, $userId: Int!, $name: String!, $receiveNotifications: Boolean!, $role: Role) {
  updateUser(
    orgUnitId: $orgUnitId
    userId: $userId
    name: $name
    receiveNotifications: $receiveNotifications
    role: $role
  )
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      orgUnitId: // value for 'orgUnitId'
 *      userId: // value for 'userId'
 *      name: // value for 'name'
 *      receiveNotifications: // value for 'receiveNotifications'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ArchiveWorkspaceDocument = gql`
    mutation archiveWorkspace($id: UxId!) {
  archiveWorkspace(id: $id)
}
    `;
export type ArchiveWorkspaceMutationFn = Apollo.MutationFunction<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>;

/**
 * __useArchiveWorkspaceMutation__
 *
 * To run a mutation, you first call `useArchiveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorkspaceMutation, { data, loading, error }] = useArchiveWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>(ArchiveWorkspaceDocument, options);
      }
export type ArchiveWorkspaceMutationHookResult = ReturnType<typeof useArchiveWorkspaceMutation>;
export type ArchiveWorkspaceMutationResult = Apollo.MutationResult<ArchiveWorkspaceMutation>;
export type ArchiveWorkspaceMutationOptions = Apollo.BaseMutationOptions<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>;
export const UnarchiveWorkspaceDocument = gql`
    mutation unarchiveWorkspace($id: UxId!) {
  unarchiveWorkspace(id: $id)
}
    `;
export type UnarchiveWorkspaceMutationFn = Apollo.MutationFunction<UnarchiveWorkspaceMutation, UnarchiveWorkspaceMutationVariables>;

/**
 * __useUnarchiveWorkspaceMutation__
 *
 * To run a mutation, you first call `useUnarchiveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveWorkspaceMutation, { data, loading, error }] = useUnarchiveWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveWorkspaceMutation, UnarchiveWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveWorkspaceMutation, UnarchiveWorkspaceMutationVariables>(UnarchiveWorkspaceDocument, options);
      }
export type UnarchiveWorkspaceMutationHookResult = ReturnType<typeof useUnarchiveWorkspaceMutation>;
export type UnarchiveWorkspaceMutationResult = Apollo.MutationResult<UnarchiveWorkspaceMutation>;
export type UnarchiveWorkspaceMutationOptions = Apollo.BaseMutationOptions<UnarchiveWorkspaceMutation, UnarchiveWorkspaceMutationVariables>;
export const ArchiveOrganisationDocument = gql`
    mutation archiveOrganisation($id: UxId!) {
  archiveOrganisation(id: $id)
}
    `;
export type ArchiveOrganisationMutationFn = Apollo.MutationFunction<ArchiveOrganisationMutation, ArchiveOrganisationMutationVariables>;

/**
 * __useArchiveOrganisationMutation__
 *
 * To run a mutation, you first call `useArchiveOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOrganisationMutation, { data, loading, error }] = useArchiveOrganisationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOrganisationMutation, ArchiveOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOrganisationMutation, ArchiveOrganisationMutationVariables>(ArchiveOrganisationDocument, options);
      }
export type ArchiveOrganisationMutationHookResult = ReturnType<typeof useArchiveOrganisationMutation>;
export type ArchiveOrganisationMutationResult = Apollo.MutationResult<ArchiveOrganisationMutation>;
export type ArchiveOrganisationMutationOptions = Apollo.BaseMutationOptions<ArchiveOrganisationMutation, ArchiveOrganisationMutationVariables>;
export const DeleteWorkspaceDocument = gql`
    mutation deleteWorkspace($id: UxId!) {
  deleteWorkspace(id: $id)
}
    `;
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(DeleteWorkspaceDocument, options);
      }
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationResult = Apollo.MutationResult<DeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;
export const AssessmentsListDocument = gql`
    query assessmentsList($workspaceId: UxId) {
  assessments(workspaceId: $workspaceId) {
    id
    name
    description
    AssessmentLiveRisk {
      expectedLoss
    }
    startedDate
    reviewDate
    scenarios {
      id
      isIncomplete
    }
  }
}
    `;

/**
 * __useAssessmentsListQuery__
 *
 * To run a query within a React component, call `useAssessmentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentsListQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useAssessmentsListQuery(baseOptions?: Apollo.QueryHookOptions<AssessmentsListQuery, AssessmentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentsListQuery, AssessmentsListQueryVariables>(AssessmentsListDocument, options);
      }
export function useAssessmentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentsListQuery, AssessmentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentsListQuery, AssessmentsListQueryVariables>(AssessmentsListDocument, options);
        }
export function useAssessmentsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentsListQuery, AssessmentsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentsListQuery, AssessmentsListQueryVariables>(AssessmentsListDocument, options);
        }
export type AssessmentsListQueryHookResult = ReturnType<typeof useAssessmentsListQuery>;
export type AssessmentsListLazyQueryHookResult = ReturnType<typeof useAssessmentsListLazyQuery>;
export type AssessmentsListSuspenseQueryHookResult = ReturnType<typeof useAssessmentsListSuspenseQuery>;
export type AssessmentsListQueryResult = Apollo.QueryResult<AssessmentsListQuery, AssessmentsListQueryVariables>;
export const AssessmentsDocument = gql`
    query assessments($workspaceId: UxId) {
  assessments(workspaceId: $workspaceId) {
    id
    name
    description
    AssessmentLiveRisk {
      expectedLoss
    }
    startedDate
    reviewDate
    scenarios {
      id
      isIncomplete
      name
      ownerName
      liveRisk {
        expectedLoss
      }
      source
      event
      consequence
      riskIdentifiedDate
      editedAt
      status
      meta {
        createdAt
        updatedAt
      }
      assessment {
        id
      }
    }
  }
}
    `;

/**
 * __useAssessmentsQuery__
 *
 * To run a query within a React component, call `useAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<AssessmentsQuery, AssessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentsQuery, AssessmentsQueryVariables>(AssessmentsDocument, options);
      }
export function useAssessmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentsQuery, AssessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentsQuery, AssessmentsQueryVariables>(AssessmentsDocument, options);
        }
export function useAssessmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentsQuery, AssessmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentsQuery, AssessmentsQueryVariables>(AssessmentsDocument, options);
        }
export type AssessmentsQueryHookResult = ReturnType<typeof useAssessmentsQuery>;
export type AssessmentsLazyQueryHookResult = ReturnType<typeof useAssessmentsLazyQuery>;
export type AssessmentsSuspenseQueryHookResult = ReturnType<typeof useAssessmentsSuspenseQuery>;
export type AssessmentsQueryResult = Apollo.QueryResult<AssessmentsQuery, AssessmentsQueryVariables>;
export const AssessmentsScenarioNamesDocument = gql`
    query assessmentsScenarioNames($workspaceId: UxId) {
  assessments(workspaceId: $workspaceId) {
    id
    name
    scenarios {
      id
      name
    }
  }
}
    `;

/**
 * __useAssessmentsScenarioNamesQuery__
 *
 * To run a query within a React component, call `useAssessmentsScenarioNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentsScenarioNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentsScenarioNamesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useAssessmentsScenarioNamesQuery(baseOptions?: Apollo.QueryHookOptions<AssessmentsScenarioNamesQuery, AssessmentsScenarioNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentsScenarioNamesQuery, AssessmentsScenarioNamesQueryVariables>(AssessmentsScenarioNamesDocument, options);
      }
export function useAssessmentsScenarioNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentsScenarioNamesQuery, AssessmentsScenarioNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentsScenarioNamesQuery, AssessmentsScenarioNamesQueryVariables>(AssessmentsScenarioNamesDocument, options);
        }
export function useAssessmentsScenarioNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentsScenarioNamesQuery, AssessmentsScenarioNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentsScenarioNamesQuery, AssessmentsScenarioNamesQueryVariables>(AssessmentsScenarioNamesDocument, options);
        }
export type AssessmentsScenarioNamesQueryHookResult = ReturnType<typeof useAssessmentsScenarioNamesQuery>;
export type AssessmentsScenarioNamesLazyQueryHookResult = ReturnType<typeof useAssessmentsScenarioNamesLazyQuery>;
export type AssessmentsScenarioNamesSuspenseQueryHookResult = ReturnType<typeof useAssessmentsScenarioNamesSuspenseQuery>;
export type AssessmentsScenarioNamesQueryResult = Apollo.QueryResult<AssessmentsScenarioNamesQuery, AssessmentsScenarioNamesQueryVariables>;
export const IncidentsDocument = gql`
    query incidents($workspaceId: UxId) {
  incidents(workspaceId: $workspaceId) {
    id
    name
    ref
    source
    incidentType
    dateOfIncident
    description
    financialImpactLower
    financialImpactUpper
    impact
    severity
    owner {
      id
      text
      email
      inviteId
      memberId
      profilePhotoPath
    }
    scenarios {
      id
    }
  }
}
    `;

/**
 * __useIncidentsQuery__
 *
 * To run a query within a React component, call `useIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useIncidentsQuery(baseOptions?: Apollo.QueryHookOptions<IncidentsQuery, IncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncidentsQuery, IncidentsQueryVariables>(IncidentsDocument, options);
      }
export function useIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncidentsQuery, IncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncidentsQuery, IncidentsQueryVariables>(IncidentsDocument, options);
        }
export function useIncidentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncidentsQuery, IncidentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncidentsQuery, IncidentsQueryVariables>(IncidentsDocument, options);
        }
export type IncidentsQueryHookResult = ReturnType<typeof useIncidentsQuery>;
export type IncidentsLazyQueryHookResult = ReturnType<typeof useIncidentsLazyQuery>;
export type IncidentsSuspenseQueryHookResult = ReturnType<typeof useIncidentsSuspenseQuery>;
export type IncidentsQueryResult = Apollo.QueryResult<IncidentsQuery, IncidentsQueryVariables>;
export const IncidentsCheckDocument = gql`
    query incidentsCheck($workspaceId: UxId) {
  incidents(workspaceId: $workspaceId) {
    id
    scenarios {
      id
    }
  }
}
    `;

/**
 * __useIncidentsCheckQuery__
 *
 * To run a query within a React component, call `useIncidentsCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentsCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentsCheckQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useIncidentsCheckQuery(baseOptions?: Apollo.QueryHookOptions<IncidentsCheckQuery, IncidentsCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncidentsCheckQuery, IncidentsCheckQueryVariables>(IncidentsCheckDocument, options);
      }
export function useIncidentsCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncidentsCheckQuery, IncidentsCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncidentsCheckQuery, IncidentsCheckQueryVariables>(IncidentsCheckDocument, options);
        }
export function useIncidentsCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncidentsCheckQuery, IncidentsCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncidentsCheckQuery, IncidentsCheckQueryVariables>(IncidentsCheckDocument, options);
        }
export type IncidentsCheckQueryHookResult = ReturnType<typeof useIncidentsCheckQuery>;
export type IncidentsCheckLazyQueryHookResult = ReturnType<typeof useIncidentsCheckLazyQuery>;
export type IncidentsCheckSuspenseQueryHookResult = ReturnType<typeof useIncidentsCheckSuspenseQuery>;
export type IncidentsCheckQueryResult = Apollo.QueryResult<IncidentsCheckQuery, IncidentsCheckQueryVariables>;
export const IncidentLinkedScenariosDocument = gql`
    query incidentLinkedScenarios($id: UxId!, $versionId: UxId) {
  incident(id: $id, versionId: $versionId) {
    id
    scenarios {
      id
      name
      assessment {
        id
        name
      }
      source
      event
      consequence
      liveRisk {
        expectedLoss
      }
      ownerName
      riskIdentifiedDate
      isIncomplete
      editedAt
      status
      riskManagementPlans {
        id
      }
      meta {
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useIncidentLinkedScenariosQuery__
 *
 * To run a query within a React component, call `useIncidentLinkedScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentLinkedScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentLinkedScenariosQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useIncidentLinkedScenariosQuery(baseOptions: Apollo.QueryHookOptions<IncidentLinkedScenariosQuery, IncidentLinkedScenariosQueryVariables> & ({ variables: IncidentLinkedScenariosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncidentLinkedScenariosQuery, IncidentLinkedScenariosQueryVariables>(IncidentLinkedScenariosDocument, options);
      }
export function useIncidentLinkedScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncidentLinkedScenariosQuery, IncidentLinkedScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncidentLinkedScenariosQuery, IncidentLinkedScenariosQueryVariables>(IncidentLinkedScenariosDocument, options);
        }
export function useIncidentLinkedScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncidentLinkedScenariosQuery, IncidentLinkedScenariosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncidentLinkedScenariosQuery, IncidentLinkedScenariosQueryVariables>(IncidentLinkedScenariosDocument, options);
        }
export type IncidentLinkedScenariosQueryHookResult = ReturnType<typeof useIncidentLinkedScenariosQuery>;
export type IncidentLinkedScenariosLazyQueryHookResult = ReturnType<typeof useIncidentLinkedScenariosLazyQuery>;
export type IncidentLinkedScenariosSuspenseQueryHookResult = ReturnType<typeof useIncidentLinkedScenariosSuspenseQuery>;
export type IncidentLinkedScenariosQueryResult = Apollo.QueryResult<IncidentLinkedScenariosQuery, IncidentLinkedScenariosQueryVariables>;
export const IncidentDocument = gql`
    query incident($id: UxId!, $versionId: UxId) {
  incident(id: $id, versionId: $versionId) {
    id
    name
    ref
    source
    incidentType
    dateOfIncident
    description
    financialImpactLower
    financialImpactUpper
    impact
    severity
    owner {
      id
      text
      email
      inviteId
      memberId
      profilePhotoPath
    }
  }
}
    `;

/**
 * __useIncidentQuery__
 *
 * To run a query within a React component, call `useIncidentQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useIncidentQuery(baseOptions: Apollo.QueryHookOptions<IncidentQuery, IncidentQueryVariables> & ({ variables: IncidentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncidentQuery, IncidentQueryVariables>(IncidentDocument, options);
      }
export function useIncidentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncidentQuery, IncidentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncidentQuery, IncidentQueryVariables>(IncidentDocument, options);
        }
export function useIncidentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncidentQuery, IncidentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncidentQuery, IncidentQueryVariables>(IncidentDocument, options);
        }
export type IncidentQueryHookResult = ReturnType<typeof useIncidentQuery>;
export type IncidentLazyQueryHookResult = ReturnType<typeof useIncidentLazyQuery>;
export type IncidentSuspenseQueryHookResult = ReturnType<typeof useIncidentSuspenseQuery>;
export type IncidentQueryResult = Apollo.QueryResult<IncidentQuery, IncidentQueryVariables>;
export const ScenarioTemplatesDocument = gql`
    query scenarioTemplates {
  scenarioTemplates {
    id
    name
    author
    groupName
    description
    source
    event
    consequence
    riskOwner
    riskNarrative
    expectedLoss
    frequencyTimes
    frequencyYears
    frequencyNote
    managementStrategy
    lowerFormula
    upperFormula
    note
  }
}
    `;

/**
 * __useScenarioTemplatesQuery__
 *
 * To run a query within a React component, call `useScenarioTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useScenarioTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ScenarioTemplatesQuery, ScenarioTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioTemplatesQuery, ScenarioTemplatesQueryVariables>(ScenarioTemplatesDocument, options);
      }
export function useScenarioTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioTemplatesQuery, ScenarioTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioTemplatesQuery, ScenarioTemplatesQueryVariables>(ScenarioTemplatesDocument, options);
        }
export function useScenarioTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioTemplatesQuery, ScenarioTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioTemplatesQuery, ScenarioTemplatesQueryVariables>(ScenarioTemplatesDocument, options);
        }
export type ScenarioTemplatesQueryHookResult = ReturnType<typeof useScenarioTemplatesQuery>;
export type ScenarioTemplatesLazyQueryHookResult = ReturnType<typeof useScenarioTemplatesLazyQuery>;
export type ScenarioTemplatesSuspenseQueryHookResult = ReturnType<typeof useScenarioTemplatesSuspenseQuery>;
export type ScenarioTemplatesQueryResult = Apollo.QueryResult<ScenarioTemplatesQuery, ScenarioTemplatesQueryVariables>;
export const ScenarioGroupsDocument = gql`
    query scenarioGroups($workspaceId: UxId) {
  scenarioGroups(workspaceId: $workspaceId) {
    id
    name
    description
    author
    authorLogoPath
    category
    featureKey
    isSystem
    versionNumber
    isCurrentVersion
    versionCreatedBy
    meta {
      createdAt
      updatedAt
    }
    versions {
      id
      name
      versionNumber
      isCurrentVersion
      versionCreatedBy
      scenarios {
        id
      }
      meta {
        createdAt
        updatedAt
      }
    }
    scenarios {
      id
      meta {
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useScenarioGroupsQuery__
 *
 * To run a query within a React component, call `useScenarioGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioGroupsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useScenarioGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ScenarioGroupsQuery, ScenarioGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioGroupsQuery, ScenarioGroupsQueryVariables>(ScenarioGroupsDocument, options);
      }
export function useScenarioGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioGroupsQuery, ScenarioGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioGroupsQuery, ScenarioGroupsQueryVariables>(ScenarioGroupsDocument, options);
        }
export function useScenarioGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioGroupsQuery, ScenarioGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioGroupsQuery, ScenarioGroupsQueryVariables>(ScenarioGroupsDocument, options);
        }
export type ScenarioGroupsQueryHookResult = ReturnType<typeof useScenarioGroupsQuery>;
export type ScenarioGroupsLazyQueryHookResult = ReturnType<typeof useScenarioGroupsLazyQuery>;
export type ScenarioGroupsSuspenseQueryHookResult = ReturnType<typeof useScenarioGroupsSuspenseQuery>;
export type ScenarioGroupsQueryResult = Apollo.QueryResult<ScenarioGroupsQuery, ScenarioGroupsQueryVariables>;
export const ScenarioGroupsWithScenariosDocument = gql`
    query scenarioGroupsWithScenarios($workspaceId: UxId) {
  scenarioGroups(workspaceId: $workspaceId) {
    id
    name
    description
    author
    authorLogoPath
    category
    featureKey
    isSystem
    versionNumber
    isCurrentVersion
    versionCreatedBy
    meta {
      createdAt
      updatedAt
    }
    versions {
      id
      name
      versionNumber
      isCurrentVersion
      versionCreatedBy
      scenarios {
        id
      }
      meta {
        createdAt
        updatedAt
      }
    }
    scenarios {
      id
      name
      description
      ownerName
      source
      event
      consequence
      riskNarrative
      frequencyNote
      managementStrategy
      managementNote
      consequenceNote
      lowerFormula
      upperFormula
      status
      riskIdentifiedDate
      reviewDate
      assessment {
        id
      }
      baseRisk {
        frequencyTimes
        frequencyYears
        expectedLoss
        lower
        upper
      }
      projectedRisk {
        frequencyTimes
        frequencyYears
        expectedLoss
        lower
        upper
      }
      liveRisk {
        frequencyTimes
        frequencyYears
        expectedLoss
        lower
        upper
      }
      meta {
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useScenarioGroupsWithScenariosQuery__
 *
 * To run a query within a React component, call `useScenarioGroupsWithScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioGroupsWithScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioGroupsWithScenariosQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useScenarioGroupsWithScenariosQuery(baseOptions?: Apollo.QueryHookOptions<ScenarioGroupsWithScenariosQuery, ScenarioGroupsWithScenariosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioGroupsWithScenariosQuery, ScenarioGroupsWithScenariosQueryVariables>(ScenarioGroupsWithScenariosDocument, options);
      }
export function useScenarioGroupsWithScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioGroupsWithScenariosQuery, ScenarioGroupsWithScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioGroupsWithScenariosQuery, ScenarioGroupsWithScenariosQueryVariables>(ScenarioGroupsWithScenariosDocument, options);
        }
export function useScenarioGroupsWithScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioGroupsWithScenariosQuery, ScenarioGroupsWithScenariosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioGroupsWithScenariosQuery, ScenarioGroupsWithScenariosQueryVariables>(ScenarioGroupsWithScenariosDocument, options);
        }
export type ScenarioGroupsWithScenariosQueryHookResult = ReturnType<typeof useScenarioGroupsWithScenariosQuery>;
export type ScenarioGroupsWithScenariosLazyQueryHookResult = ReturnType<typeof useScenarioGroupsWithScenariosLazyQuery>;
export type ScenarioGroupsWithScenariosSuspenseQueryHookResult = ReturnType<typeof useScenarioGroupsWithScenariosSuspenseQuery>;
export type ScenarioGroupsWithScenariosQueryResult = Apollo.QueryResult<ScenarioGroupsWithScenariosQuery, ScenarioGroupsWithScenariosQueryVariables>;
export const ControlsDocument = gql`
    query controls($workspaceId: UxId, $selection: ControlSelectionInput) {
  controls(workspaceId: $workspaceId, selection: $selection) {
    id
    name
    description
    ownerEmail
    ownerName
    annualCost
    vendor
    strategy
    status
    origin
    linkUrl
    linkText
    expectedActiveDate
    actualActiveDate
    reviewDate
    existingMaturity
    targetMaturity
    frameworkControls {
      id
      name
      shortname
      control_identifier
      controlFramework {
        id
        name
        shortname
      }
    }
    riskManagementPlansCount
    meta {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useControlsQuery__
 *
 * To run a query within a React component, call `useControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useControlsQuery(baseOptions?: Apollo.QueryHookOptions<ControlsQuery, ControlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlsQuery, ControlsQueryVariables>(ControlsDocument, options);
      }
export function useControlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlsQuery, ControlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlsQuery, ControlsQueryVariables>(ControlsDocument, options);
        }
export function useControlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlsQuery, ControlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlsQuery, ControlsQueryVariables>(ControlsDocument, options);
        }
export type ControlsQueryHookResult = ReturnType<typeof useControlsQuery>;
export type ControlsLazyQueryHookResult = ReturnType<typeof useControlsLazyQuery>;
export type ControlsSuspenseQueryHookResult = ReturnType<typeof useControlsSuspenseQuery>;
export type ControlsQueryResult = Apollo.QueryResult<ControlsQuery, ControlsQueryVariables>;
export const ControlsRmpCheckDocument = gql`
    query controlsRmpCheck($workspaceId: UxId) {
  controls(workspaceId: $workspaceId) {
    id
    frameworkControls {
      id
      control_identifier
    }
  }
}
    `;

/**
 * __useControlsRmpCheckQuery__
 *
 * To run a query within a React component, call `useControlsRmpCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlsRmpCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlsRmpCheckQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useControlsRmpCheckQuery(baseOptions?: Apollo.QueryHookOptions<ControlsRmpCheckQuery, ControlsRmpCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlsRmpCheckQuery, ControlsRmpCheckQueryVariables>(ControlsRmpCheckDocument, options);
      }
export function useControlsRmpCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlsRmpCheckQuery, ControlsRmpCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlsRmpCheckQuery, ControlsRmpCheckQueryVariables>(ControlsRmpCheckDocument, options);
        }
export function useControlsRmpCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlsRmpCheckQuery, ControlsRmpCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlsRmpCheckQuery, ControlsRmpCheckQueryVariables>(ControlsRmpCheckDocument, options);
        }
export type ControlsRmpCheckQueryHookResult = ReturnType<typeof useControlsRmpCheckQuery>;
export type ControlsRmpCheckLazyQueryHookResult = ReturnType<typeof useControlsRmpCheckLazyQuery>;
export type ControlsRmpCheckSuspenseQueryHookResult = ReturnType<typeof useControlsRmpCheckSuspenseQuery>;
export type ControlsRmpCheckQueryResult = Apollo.QueryResult<ControlsRmpCheckQuery, ControlsRmpCheckQueryVariables>;
export const ControlRmpDocument = gql`
    query controlRmp($id: UxId!, $versionId: UxId) {
  control(id: $id, versionId: $versionId) {
    id
    strategy
    status
    riskManagementPlans {
      id
      startingFrequency
      startingLower
      startingUpper
      modifiers {
        id
        type
        consequenceUpper
        consequenceLower
        frequencyReduction
        isPercentage
        totalPolicyCover
        excess
        note
      }
      recommendedModifiers {
        type
        data {
          upper
          lower
          value
          isPercentage
        }
      }
      scenario {
        id
        name
        source
        event
        consequence
        ownerName
        isIncomplete
        assessment {
          id
          name
        }
        baseRisk {
          upper
          lower
          frequencyTimes
          frequencyYears
        }
        riskIdentifiedDate
        editedAt
        liveRisk {
          expectedLoss
        }
        status
        meta {
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useControlRmpQuery__
 *
 * To run a query within a React component, call `useControlRmpQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlRmpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlRmpQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useControlRmpQuery(baseOptions: Apollo.QueryHookOptions<ControlRmpQuery, ControlRmpQueryVariables> & ({ variables: ControlRmpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlRmpQuery, ControlRmpQueryVariables>(ControlRmpDocument, options);
      }
export function useControlRmpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlRmpQuery, ControlRmpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlRmpQuery, ControlRmpQueryVariables>(ControlRmpDocument, options);
        }
export function useControlRmpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlRmpQuery, ControlRmpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlRmpQuery, ControlRmpQueryVariables>(ControlRmpDocument, options);
        }
export type ControlRmpQueryHookResult = ReturnType<typeof useControlRmpQuery>;
export type ControlRmpLazyQueryHookResult = ReturnType<typeof useControlRmpLazyQuery>;
export type ControlRmpSuspenseQueryHookResult = ReturnType<typeof useControlRmpSuspenseQuery>;
export type ControlRmpQueryResult = Apollo.QueryResult<ControlRmpQuery, ControlRmpQueryVariables>;
export const ControlModifierDocument = gql`
    query controlModifier($id: UxId!) {
  control(id: $id) {
    id
    strategy
    status
    riskManagementPlans {
      id
      modifiers {
        id
        type
        consequenceUpper
        consequenceLower
        frequencyReduction
        isPercentage
        totalPolicyCover
        excess
        note
      }
      recommendedModifiers {
        type
        data {
          upper
          lower
          value
          isPercentage
        }
      }
      scenario {
        id
        baseRisk {
          upper
          lower
          frequencyTimes
          frequencyYears
        }
      }
    }
  }
}
    `;

/**
 * __useControlModifierQuery__
 *
 * To run a query within a React component, call `useControlModifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlModifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlModifierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useControlModifierQuery(baseOptions: Apollo.QueryHookOptions<ControlModifierQuery, ControlModifierQueryVariables> & ({ variables: ControlModifierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlModifierQuery, ControlModifierQueryVariables>(ControlModifierDocument, options);
      }
export function useControlModifierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlModifierQuery, ControlModifierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlModifierQuery, ControlModifierQueryVariables>(ControlModifierDocument, options);
        }
export function useControlModifierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlModifierQuery, ControlModifierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlModifierQuery, ControlModifierQueryVariables>(ControlModifierDocument, options);
        }
export type ControlModifierQueryHookResult = ReturnType<typeof useControlModifierQuery>;
export type ControlModifierLazyQueryHookResult = ReturnType<typeof useControlModifierLazyQuery>;
export type ControlModifierSuspenseQueryHookResult = ReturnType<typeof useControlModifierSuspenseQuery>;
export type ControlModifierQueryResult = Apollo.QueryResult<ControlModifierQuery, ControlModifierQueryVariables>;
export const ControlsRmpDocument = gql`
    query controlsRmp($workspaceId: UxId!) {
  controls(workspaceId: $workspaceId) {
    id
    frameworkControls {
      id
      control_identifier
      controlFramework {
        id
      }
    }
    riskManagementPlans {
      id
      scenario {
        id
      }
    }
  }
}
    `;

/**
 * __useControlsRmpQuery__
 *
 * To run a query within a React component, call `useControlsRmpQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlsRmpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlsRmpQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useControlsRmpQuery(baseOptions: Apollo.QueryHookOptions<ControlsRmpQuery, ControlsRmpQueryVariables> & ({ variables: ControlsRmpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlsRmpQuery, ControlsRmpQueryVariables>(ControlsRmpDocument, options);
      }
export function useControlsRmpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlsRmpQuery, ControlsRmpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlsRmpQuery, ControlsRmpQueryVariables>(ControlsRmpDocument, options);
        }
export function useControlsRmpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlsRmpQuery, ControlsRmpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlsRmpQuery, ControlsRmpQueryVariables>(ControlsRmpDocument, options);
        }
export type ControlsRmpQueryHookResult = ReturnType<typeof useControlsRmpQuery>;
export type ControlsRmpLazyQueryHookResult = ReturnType<typeof useControlsRmpLazyQuery>;
export type ControlsRmpSuspenseQueryHookResult = ReturnType<typeof useControlsRmpSuspenseQuery>;
export type ControlsRmpQueryResult = Apollo.QueryResult<ControlsRmpQuery, ControlsRmpQueryVariables>;
export const ScenarioRmpDocument = gql`
    query scenarioRmp($id: UxId!, $versionId: UxId) {
  scenario(id: $id, versionId: $versionId) {
    id
    baseRisk {
      upper
      lower
      frequencyTimes
      frequencyYears
    }
    riskManagementPlans {
      id
      startingFrequency
      startingLower
      startingUpper
      control {
        id
        name
        strategy
        ownerName
        annualCost
        status
        existingMaturity
        targetMaturity
        linkUrl
        linkText
        frameworkControls {
          id
          name
          shortname
          control_identifier
          strategy
          controlFramework {
            id
            name
            shortname
          }
        }
        meta {
          createdAt
          updatedAt
        }
      }
      modifiers {
        id
        type
        consequenceUpper
        consequenceLower
        frequencyReduction
        isPercentage
        totalPolicyCover
        excess
        note
      }
      recommendedModifiers {
        type
        data {
          upper
          lower
          value
          isPercentage
        }
      }
    }
  }
}
    `;

/**
 * __useScenarioRmpQuery__
 *
 * To run a query within a React component, call `useScenarioRmpQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioRmpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioRmpQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useScenarioRmpQuery(baseOptions: Apollo.QueryHookOptions<ScenarioRmpQuery, ScenarioRmpQueryVariables> & ({ variables: ScenarioRmpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioRmpQuery, ScenarioRmpQueryVariables>(ScenarioRmpDocument, options);
      }
export function useScenarioRmpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioRmpQuery, ScenarioRmpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioRmpQuery, ScenarioRmpQueryVariables>(ScenarioRmpDocument, options);
        }
export function useScenarioRmpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioRmpQuery, ScenarioRmpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioRmpQuery, ScenarioRmpQueryVariables>(ScenarioRmpDocument, options);
        }
export type ScenarioRmpQueryHookResult = ReturnType<typeof useScenarioRmpQuery>;
export type ScenarioRmpLazyQueryHookResult = ReturnType<typeof useScenarioRmpLazyQuery>;
export type ScenarioRmpSuspenseQueryHookResult = ReturnType<typeof useScenarioRmpSuspenseQuery>;
export type ScenarioRmpQueryResult = Apollo.QueryResult<ScenarioRmpQuery, ScenarioRmpQueryVariables>;
export const ScenarioModifierDocument = gql`
    query scenarioModifier($id: UxId!, $versionId: UxId) {
  scenario(id: $id, versionId: $versionId) {
    id
    baseRisk {
      upper
      lower
      frequencyTimes
      frequencyYears
    }
    riskManagementPlans {
      id
      control {
        id
        strategy
        status
      }
      modifiers {
        id
        type
        consequenceUpper
        consequenceLower
        frequencyReduction
        isPercentage
        totalPolicyCover
        excess
        note
      }
      recommendedModifiers {
        type
        data {
          upper
          lower
          value
          isPercentage
        }
      }
    }
  }
}
    `;

/**
 * __useScenarioModifierQuery__
 *
 * To run a query within a React component, call `useScenarioModifierQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioModifierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioModifierQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useScenarioModifierQuery(baseOptions: Apollo.QueryHookOptions<ScenarioModifierQuery, ScenarioModifierQueryVariables> & ({ variables: ScenarioModifierQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioModifierQuery, ScenarioModifierQueryVariables>(ScenarioModifierDocument, options);
      }
export function useScenarioModifierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioModifierQuery, ScenarioModifierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioModifierQuery, ScenarioModifierQueryVariables>(ScenarioModifierDocument, options);
        }
export function useScenarioModifierSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioModifierQuery, ScenarioModifierQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioModifierQuery, ScenarioModifierQueryVariables>(ScenarioModifierDocument, options);
        }
export type ScenarioModifierQueryHookResult = ReturnType<typeof useScenarioModifierQuery>;
export type ScenarioModifierLazyQueryHookResult = ReturnType<typeof useScenarioModifierLazyQuery>;
export type ScenarioModifierSuspenseQueryHookResult = ReturnType<typeof useScenarioModifierSuspenseQuery>;
export type ScenarioModifierQueryResult = Apollo.QueryResult<ScenarioModifierQuery, ScenarioModifierQueryVariables>;
export const ControlFrameworksListDocument = gql`
    query controlFrameworksList {
  controlFrameworks {
    id
    name
    shortname
    controlCount
    author
    featureKey
    versionNumber
    isCurrentVersion
    versionCreatedBy
    meta {
      createdAt
      updatedAt
    }
    versions {
      id
      name
      shortname
      controlCount
      versionNumber
      isCurrentVersion
      versionCreatedBy
      frameworkControls {
        id
      }
      meta {
        createdAt
        updatedAt
      }
    }
    frameworkControls {
      id
      shortname
      control_identifier
    }
  }
}
    `;

/**
 * __useControlFrameworksListQuery__
 *
 * To run a query within a React component, call `useControlFrameworksListQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlFrameworksListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlFrameworksListQuery({
 *   variables: {
 *   },
 * });
 */
export function useControlFrameworksListQuery(baseOptions?: Apollo.QueryHookOptions<ControlFrameworksListQuery, ControlFrameworksListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlFrameworksListQuery, ControlFrameworksListQueryVariables>(ControlFrameworksListDocument, options);
      }
export function useControlFrameworksListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlFrameworksListQuery, ControlFrameworksListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlFrameworksListQuery, ControlFrameworksListQueryVariables>(ControlFrameworksListDocument, options);
        }
export function useControlFrameworksListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlFrameworksListQuery, ControlFrameworksListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlFrameworksListQuery, ControlFrameworksListQueryVariables>(ControlFrameworksListDocument, options);
        }
export type ControlFrameworksListQueryHookResult = ReturnType<typeof useControlFrameworksListQuery>;
export type ControlFrameworksListLazyQueryHookResult = ReturnType<typeof useControlFrameworksListLazyQuery>;
export type ControlFrameworksListSuspenseQueryHookResult = ReturnType<typeof useControlFrameworksListSuspenseQuery>;
export type ControlFrameworksListQueryResult = Apollo.QueryResult<ControlFrameworksListQuery, ControlFrameworksListQueryVariables>;
export const ControlFrameworkDetailsDocument = gql`
    query controlFrameworkDetails($id: UxId) {
  controlFrameworks(id: $id) {
    id
    name
    shortname
    author
    description
    frameworkControls {
      id
      name
      shortname
      control_identifier
      strategy
      controlFramework {
        id
        shortname
        author
        description
      }
    }
  }
}
    `;

/**
 * __useControlFrameworkDetailsQuery__
 *
 * To run a query within a React component, call `useControlFrameworkDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlFrameworkDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlFrameworkDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useControlFrameworkDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ControlFrameworkDetailsQuery, ControlFrameworkDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlFrameworkDetailsQuery, ControlFrameworkDetailsQueryVariables>(ControlFrameworkDetailsDocument, options);
      }
export function useControlFrameworkDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlFrameworkDetailsQuery, ControlFrameworkDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlFrameworkDetailsQuery, ControlFrameworkDetailsQueryVariables>(ControlFrameworkDetailsDocument, options);
        }
export function useControlFrameworkDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlFrameworkDetailsQuery, ControlFrameworkDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlFrameworkDetailsQuery, ControlFrameworkDetailsQueryVariables>(ControlFrameworkDetailsDocument, options);
        }
export type ControlFrameworkDetailsQueryHookResult = ReturnType<typeof useControlFrameworkDetailsQuery>;
export type ControlFrameworkDetailsLazyQueryHookResult = ReturnType<typeof useControlFrameworkDetailsLazyQuery>;
export type ControlFrameworkDetailsSuspenseQueryHookResult = ReturnType<typeof useControlFrameworkDetailsSuspenseQuery>;
export type ControlFrameworkDetailsQueryResult = Apollo.QueryResult<ControlFrameworkDetailsQuery, ControlFrameworkDetailsQueryVariables>;
export const FrameworkControlDocument = gql`
    query frameworkControl($id: UxId!) {
  frameworkControl(id: $id) {
    id
    name
    shortname
    description
    control_identifier
    strategy
    controlFramework {
      id
      name
      shortname
      author
      framework_identifier
      externalId
    }
  }
}
    `;

/**
 * __useFrameworkControlQuery__
 *
 * To run a query within a React component, call `useFrameworkControlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrameworkControlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrameworkControlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFrameworkControlQuery(baseOptions: Apollo.QueryHookOptions<FrameworkControlQuery, FrameworkControlQueryVariables> & ({ variables: FrameworkControlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FrameworkControlQuery, FrameworkControlQueryVariables>(FrameworkControlDocument, options);
      }
export function useFrameworkControlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrameworkControlQuery, FrameworkControlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FrameworkControlQuery, FrameworkControlQueryVariables>(FrameworkControlDocument, options);
        }
export function useFrameworkControlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FrameworkControlQuery, FrameworkControlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FrameworkControlQuery, FrameworkControlQueryVariables>(FrameworkControlDocument, options);
        }
export type FrameworkControlQueryHookResult = ReturnType<typeof useFrameworkControlQuery>;
export type FrameworkControlLazyQueryHookResult = ReturnType<typeof useFrameworkControlLazyQuery>;
export type FrameworkControlSuspenseQueryHookResult = ReturnType<typeof useFrameworkControlSuspenseQuery>;
export type FrameworkControlQueryResult = Apollo.QueryResult<FrameworkControlQuery, FrameworkControlQueryVariables>;
export const InsightsDocument = gql`
    query insights($id: UxId!) {
  assessment(id: $id) {
    id
    name
    AssessmentLiveRisk {
      expectedLoss
    }
    scenarios {
      id
      name
      liveRisk {
        expectedLoss
      }
      incidents {
        id
        financialImpactLower
        financialImpactUpper
        dateOfIncident
        incidentType
      }
      reviewDate
      riskManagementPlans {
        id
        control {
          id
          name
          status
          existingMaturity
          targetMaturity
        }
      }
    }
  }
}
    `;

/**
 * __useInsightsQuery__
 *
 * To run a query within a React component, call `useInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightsQuery(baseOptions: Apollo.QueryHookOptions<InsightsQuery, InsightsQueryVariables> & ({ variables: InsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
      }
export function useInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export function useInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsQuery, InsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightsQuery, InsightsQueryVariables>(InsightsDocument, options);
        }
export type InsightsQueryHookResult = ReturnType<typeof useInsightsQuery>;
export type InsightsLazyQueryHookResult = ReturnType<typeof useInsightsLazyQuery>;
export type InsightsSuspenseQueryHookResult = ReturnType<typeof useInsightsSuspenseQuery>;
export type InsightsQueryResult = Apollo.QueryResult<InsightsQuery, InsightsQueryVariables>;
export const AssessmentDocument = gql`
    query assessment($id: UxId!, $versionId: UxId) {
  assessment(id: $id, versionId: $versionId) {
    id
    name
    description
    executiveSummary
    riskTolerance
    AssessmentBaseRisk {
      expectedLoss
      chart {
        x
        y
      }
    }
    AssessmentProjectedRisk {
      expectedLoss
      chart {
        x
        y
      }
    }
    AssessmentLiveRisk {
      expectedLoss
      chart {
        x
        y
      }
    }
    startedDate
    reviewDate
    variables {
      id
      name
      value
      isInUse
      currency
      isGlobal
      alias
      workspaceVariable
    }
    scenarios {
      id
      name
      isIncomplete
      baseRisk {
        upper
        lower
      }
      liveRisk {
        upper
        lower
      }
      projectedRisk {
        upper
        lower
      }
      riskManagementPlans {
        id
        control {
          id
          status
        }
        modifiers {
          id
          type
        }
      }
    }
    versions {
      id
      name
      editable
      legacyVersion
      meta {
        createdBy
        createdAt
      }
    }
  }
}
    `;

/**
 * __useAssessmentQuery__
 *
 * To run a query within a React component, call `useAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useAssessmentQuery(baseOptions: Apollo.QueryHookOptions<AssessmentQuery, AssessmentQueryVariables> & ({ variables: AssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
      }
export function useAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentQuery, AssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
        }
export function useAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentQuery, AssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentQuery, AssessmentQueryVariables>(AssessmentDocument, options);
        }
export type AssessmentQueryHookResult = ReturnType<typeof useAssessmentQuery>;
export type AssessmentLazyQueryHookResult = ReturnType<typeof useAssessmentLazyQuery>;
export type AssessmentSuspenseQueryHookResult = ReturnType<typeof useAssessmentSuspenseQuery>;
export type AssessmentQueryResult = Apollo.QueryResult<AssessmentQuery, AssessmentQueryVariables>;
export const AssessmentVariablesDocument = gql`
    query assessmentVariables($id: UxId!) {
  assessment(id: $id) {
    id
    variables {
      id
      name
      value
      isInUse
      currency
      isGlobal
      alias
      workspaceVariable
    }
  }
}
    `;

/**
 * __useAssessmentVariablesQuery__
 *
 * To run a query within a React component, call `useAssessmentVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentVariablesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssessmentVariablesQuery(baseOptions: Apollo.QueryHookOptions<AssessmentVariablesQuery, AssessmentVariablesQueryVariables> & ({ variables: AssessmentVariablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentVariablesQuery, AssessmentVariablesQueryVariables>(AssessmentVariablesDocument, options);
      }
export function useAssessmentVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentVariablesQuery, AssessmentVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentVariablesQuery, AssessmentVariablesQueryVariables>(AssessmentVariablesDocument, options);
        }
export function useAssessmentVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentVariablesQuery, AssessmentVariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentVariablesQuery, AssessmentVariablesQueryVariables>(AssessmentVariablesDocument, options);
        }
export type AssessmentVariablesQueryHookResult = ReturnType<typeof useAssessmentVariablesQuery>;
export type AssessmentVariablesLazyQueryHookResult = ReturnType<typeof useAssessmentVariablesLazyQuery>;
export type AssessmentVariablesSuspenseQueryHookResult = ReturnType<typeof useAssessmentVariablesSuspenseQuery>;
export type AssessmentVariablesQueryResult = Apollo.QueryResult<AssessmentVariablesQuery, AssessmentVariablesQueryVariables>;
export const AssessmentRiskRegisterDocument = gql`
    query assessmentRiskRegister($id: UxId!, $versionId: UxId) {
  assessment(id: $id, versionId: $versionId) {
    id
    name
    scenarios {
      id
      name
      source
      event
      consequence
      ownerName
      riskOwner {
        text
      }
      riskIdentifiedDate
      reviewDate
      editedAt
      isIncomplete
      riskNarrative
      frequencyNote
      consequenceNote
      lowerFormula
      upperFormula
      baseRisk {
        expectedLoss
        frequencyTimes
        frequencyYears
        lower
        upper
      }
      projectedRisk {
        expectedLoss
        frequencyTimes
        frequencyYears
        lower
        upper
      }
      liveRisk {
        expectedLoss
        frequencyTimes
        frequencyYears
        lower
        upper
      }
      managementStrategy
      managementNote
      ownerName
      riskManagementPlans {
        id
        control {
          id
          status
          frameworkControls {
            id
            control_identifier
          }
        }
        modifiers {
          id
          type
        }
      }
      status
      meta {
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useAssessmentRiskRegisterQuery__
 *
 * To run a query within a React component, call `useAssessmentRiskRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentRiskRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentRiskRegisterQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useAssessmentRiskRegisterQuery(baseOptions: Apollo.QueryHookOptions<AssessmentRiskRegisterQuery, AssessmentRiskRegisterQueryVariables> & ({ variables: AssessmentRiskRegisterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentRiskRegisterQuery, AssessmentRiskRegisterQueryVariables>(AssessmentRiskRegisterDocument, options);
      }
export function useAssessmentRiskRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentRiskRegisterQuery, AssessmentRiskRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentRiskRegisterQuery, AssessmentRiskRegisterQueryVariables>(AssessmentRiskRegisterDocument, options);
        }
export function useAssessmentRiskRegisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentRiskRegisterQuery, AssessmentRiskRegisterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentRiskRegisterQuery, AssessmentRiskRegisterQueryVariables>(AssessmentRiskRegisterDocument, options);
        }
export type AssessmentRiskRegisterQueryHookResult = ReturnType<typeof useAssessmentRiskRegisterQuery>;
export type AssessmentRiskRegisterLazyQueryHookResult = ReturnType<typeof useAssessmentRiskRegisterLazyQuery>;
export type AssessmentRiskRegisterSuspenseQueryHookResult = ReturnType<typeof useAssessmentRiskRegisterSuspenseQuery>;
export type AssessmentRiskRegisterQueryResult = Apollo.QueryResult<AssessmentRiskRegisterQuery, AssessmentRiskRegisterQueryVariables>;
export const AssessmentScenariosWizardDocument = gql`
    query assessmentScenariosWizard($id: UxId!) {
  assessment(id: $id) {
    id
    name
    scenarios {
      id
      name
      source
      event
      consequence
      ownerName
      riskIdentifiedDate
      editedAt
      isIncomplete
      liveRisk {
        expectedLoss
      }
      riskManagementPlans {
        id
        control {
          id
          frameworkControls {
            id
            control_identifier
          }
        }
      }
      status
      meta {
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useAssessmentScenariosWizardQuery__
 *
 * To run a query within a React component, call `useAssessmentScenariosWizardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentScenariosWizardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentScenariosWizardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssessmentScenariosWizardQuery(baseOptions: Apollo.QueryHookOptions<AssessmentScenariosWizardQuery, AssessmentScenariosWizardQueryVariables> & ({ variables: AssessmentScenariosWizardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentScenariosWizardQuery, AssessmentScenariosWizardQueryVariables>(AssessmentScenariosWizardDocument, options);
      }
export function useAssessmentScenariosWizardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentScenariosWizardQuery, AssessmentScenariosWizardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentScenariosWizardQuery, AssessmentScenariosWizardQueryVariables>(AssessmentScenariosWizardDocument, options);
        }
export function useAssessmentScenariosWizardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentScenariosWizardQuery, AssessmentScenariosWizardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentScenariosWizardQuery, AssessmentScenariosWizardQueryVariables>(AssessmentScenariosWizardDocument, options);
        }
export type AssessmentScenariosWizardQueryHookResult = ReturnType<typeof useAssessmentScenariosWizardQuery>;
export type AssessmentScenariosWizardLazyQueryHookResult = ReturnType<typeof useAssessmentScenariosWizardLazyQuery>;
export type AssessmentScenariosWizardSuspenseQueryHookResult = ReturnType<typeof useAssessmentScenariosWizardSuspenseQuery>;
export type AssessmentScenariosWizardQueryResult = Apollo.QueryResult<AssessmentScenariosWizardQuery, AssessmentScenariosWizardQueryVariables>;
export const ControlDocument = gql`
    query control($id: UxId!, $versionId: UxId) {
  control(id: $id, versionId: $versionId) {
    id
    name
    description
    owner {
      id
      text
      email
      inviteId
      memberId
      profilePhotoPath
    }
    annualCost
    vendor
    strategy
    status
    origin
    linkUrl
    linkText
    expectedActiveDate
    actualActiveDate
    reviewDate
    riskManagementPlans {
      id
    }
    frameworkControls {
      id
      control_identifier
      controlFramework {
        id
        shortname
      }
      compatibleControls {
        id
        name
        shortname
        control_identifier
        description
        strategy
        controlFramework {
          id
          name
          shortname
          description
          author
          framework_identifier
          externalId
        }
      }
    }
    existingMaturity
    targetMaturity
    meta {
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useControlQuery__
 *
 * To run a query within a React component, call `useControlQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useControlQuery(baseOptions: Apollo.QueryHookOptions<ControlQuery, ControlQueryVariables> & ({ variables: ControlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlQuery, ControlQueryVariables>(ControlDocument, options);
      }
export function useControlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlQuery, ControlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlQuery, ControlQueryVariables>(ControlDocument, options);
        }
export function useControlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlQuery, ControlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlQuery, ControlQueryVariables>(ControlDocument, options);
        }
export type ControlQueryHookResult = ReturnType<typeof useControlQuery>;
export type ControlLazyQueryHookResult = ReturnType<typeof useControlLazyQuery>;
export type ControlSuspenseQueryHookResult = ReturnType<typeof useControlSuspenseQuery>;
export type ControlQueryResult = Apollo.QueryResult<ControlQuery, ControlQueryVariables>;
export const ControlLinkedScenariosDocument = gql`
    query controlLinkedScenarios($id: UxId!, $versionId: UxId) {
  control(id: $id, versionId: $versionId) {
    id
    strategy
    riskManagementPlans {
      id
      control {
        id
        strategy
      }
      scenario {
        id
        name
        source
        event
        consequence
        ownerName
        riskIdentifiedDate
        editedAt
        isIncomplete
        liveRisk {
          expectedLoss
        }
        assessment {
          id
          name
        }
        riskManagementPlans {
          id
        }
        status
        meta {
          createdAt
          updatedAt
        }
      }
      modifiers {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useControlLinkedScenariosQuery__
 *
 * To run a query within a React component, call `useControlLinkedScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlLinkedScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlLinkedScenariosQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useControlLinkedScenariosQuery(baseOptions: Apollo.QueryHookOptions<ControlLinkedScenariosQuery, ControlLinkedScenariosQueryVariables> & ({ variables: ControlLinkedScenariosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlLinkedScenariosQuery, ControlLinkedScenariosQueryVariables>(ControlLinkedScenariosDocument, options);
      }
export function useControlLinkedScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlLinkedScenariosQuery, ControlLinkedScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlLinkedScenariosQuery, ControlLinkedScenariosQueryVariables>(ControlLinkedScenariosDocument, options);
        }
export function useControlLinkedScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlLinkedScenariosQuery, ControlLinkedScenariosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlLinkedScenariosQuery, ControlLinkedScenariosQueryVariables>(ControlLinkedScenariosDocument, options);
        }
export type ControlLinkedScenariosQueryHookResult = ReturnType<typeof useControlLinkedScenariosQuery>;
export type ControlLinkedScenariosLazyQueryHookResult = ReturnType<typeof useControlLinkedScenariosLazyQuery>;
export type ControlLinkedScenariosSuspenseQueryHookResult = ReturnType<typeof useControlLinkedScenariosSuspenseQuery>;
export type ControlLinkedScenariosQueryResult = Apollo.QueryResult<ControlLinkedScenariosQuery, ControlLinkedScenariosQueryVariables>;
export const ScenarioDocument = gql`
    query scenario($id: UxId!, $versionId: UxId) {
  scenario(id: $id, versionId: $versionId) {
    id
    name
    managementNote
    managementStrategy
    source
    event
    consequence
    riskIdentifiedDate
    riskNarrative
    frequencyNote
    consequenceNote
    isIncomplete
    status
    reviewDate
    groupName
    lowerFormula
    upperFormula
    assessment {
      id
      name
    }
    riskOwner {
      text
      email
      id
      profilePhotoPath
    }
    baseRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      upper
      lower
      chart {
        x
        y
      }
    }
    projectedRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      lower
      upper
      chart {
        x
        y
      }
    }
    liveRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      lower
      upper
      lowerThanMinimum
      chart {
        x
        y
      }
    }
    riskManagementPlans {
      id
      control {
        id
        status
      }
      modifiers {
        id
        type
      }
    }
    editedAt
    meta {
      updatedAt
    }
  }
}
    `;

/**
 * __useScenarioQuery__
 *
 * To run a query within a React component, call `useScenarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useScenarioQuery(baseOptions: Apollo.QueryHookOptions<ScenarioQuery, ScenarioQueryVariables> & ({ variables: ScenarioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioQuery, ScenarioQueryVariables>(ScenarioDocument, options);
      }
export function useScenarioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioQuery, ScenarioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioQuery, ScenarioQueryVariables>(ScenarioDocument, options);
        }
export function useScenarioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioQuery, ScenarioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioQuery, ScenarioQueryVariables>(ScenarioDocument, options);
        }
export type ScenarioQueryHookResult = ReturnType<typeof useScenarioQuery>;
export type ScenarioLazyQueryHookResult = ReturnType<typeof useScenarioLazyQuery>;
export type ScenarioSuspenseQueryHookResult = ReturnType<typeof useScenarioSuspenseQuery>;
export type ScenarioQueryResult = Apollo.QueryResult<ScenarioQuery, ScenarioQueryVariables>;
export const ScenarioIncidentsDocument = gql`
    query scenarioIncidents($id: UxId!, $versionId: UxId) {
  scenario(id: $id, versionId: $versionId) {
    id
    name
    incidents {
      id
      name
      ref
      source
      incidentType
      dateOfIncident
      description
      financialImpactLower
      financialImpactUpper
      impact
      severity
      owner {
        id
        text
        email
        inviteId
        memberId
        profilePhotoPath
      }
      scenarios {
        id
      }
    }
  }
}
    `;

/**
 * __useScenarioIncidentsQuery__
 *
 * To run a query within a React component, call `useScenarioIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioIncidentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useScenarioIncidentsQuery(baseOptions: Apollo.QueryHookOptions<ScenarioIncidentsQuery, ScenarioIncidentsQueryVariables> & ({ variables: ScenarioIncidentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioIncidentsQuery, ScenarioIncidentsQueryVariables>(ScenarioIncidentsDocument, options);
      }
export function useScenarioIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioIncidentsQuery, ScenarioIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioIncidentsQuery, ScenarioIncidentsQueryVariables>(ScenarioIncidentsDocument, options);
        }
export function useScenarioIncidentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioIncidentsQuery, ScenarioIncidentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioIncidentsQuery, ScenarioIncidentsQueryVariables>(ScenarioIncidentsDocument, options);
        }
export type ScenarioIncidentsQueryHookResult = ReturnType<typeof useScenarioIncidentsQuery>;
export type ScenarioIncidentsLazyQueryHookResult = ReturnType<typeof useScenarioIncidentsLazyQuery>;
export type ScenarioIncidentsSuspenseQueryHookResult = ReturnType<typeof useScenarioIncidentsSuspenseQuery>;
export type ScenarioIncidentsQueryResult = Apollo.QueryResult<ScenarioIncidentsQuery, ScenarioIncidentsQueryVariables>;
export const DashboardDocument = gql`
    query dashboard($assessmentId: UxId!) {
  assessment(id: $assessmentId) {
    id
    name
    description
    startedDate
    editedAt
    scenarios {
      id
      isIncomplete
      riskManagementPlans {
        id
        control {
          id
          status
        }
        modifiers {
          id
        }
      }
      incidents {
        id
      }
    }
    meta {
      updatedAt
    }
  }
  dashboard(assessmentId: $assessmentId) {
    expectedLoss {
      unmodifiedRisk
      liveRisk
      projectedRisk
    }
    securityProgram {
      riskReduction
      cost
      savings
    }
    futureSecurityProgram {
      furtherReduction
      additionalCost
      totalSavings
    }
    returnOnInvestment {
      currentProgramme
      futureProgramme
    }
    riskyScenarios {
      scenarios {
        id
        name
        liveRisk {
          expectedLoss
        }
        assessment {
          id
        }
      }
    }
    controlImplementation {
      notStartedCount
      notStartedCost
      inProgressCount
      inProgressCost
      liveCount
      liveCost
      otherCount
      otherCost
      controlsWithoutCost
    }
    overdueReviews {
      assessments
      scenarios
      controls
    }
    averageIncidentFrequency {
      meantimeBetweenIncidents
      meantimeBetweenNearMisses
    }
    riskAvoidance {
      nearMisses
      days
      estimatedLossLower
      estimatedLossUpper
    }
    missingData {
      scenariosWithoutCalculationData
      scenariosWithoutLinkedControls
      scenariosWithoutModifiers
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useDashboardQuery(baseOptions: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables> & ({ variables: DashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardSuspenseQueryHookResult = ReturnType<typeof useDashboardSuspenseQuery>;
export type DashboardQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const VersionsDocument = gql`
    query versions($assessmentId: UxId!) {
  assessment(id: $assessmentId) {
    id
    versions {
      id
      name
      editable
      legacyVersion
      meta {
        createdBy
        createdAt
      }
    }
  }
}
    `;

/**
 * __useVersionsQuery__
 *
 * To run a query within a React component, call `useVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useVersionsQuery(baseOptions: Apollo.QueryHookOptions<VersionsQuery, VersionsQueryVariables> & ({ variables: VersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VersionsQuery, VersionsQueryVariables>(VersionsDocument, options);
      }
export function useVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VersionsQuery, VersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VersionsQuery, VersionsQueryVariables>(VersionsDocument, options);
        }
export function useVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VersionsQuery, VersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VersionsQuery, VersionsQueryVariables>(VersionsDocument, options);
        }
export type VersionsQueryHookResult = ReturnType<typeof useVersionsQuery>;
export type VersionsLazyQueryHookResult = ReturnType<typeof useVersionsLazyQuery>;
export type VersionsSuspenseQueryHookResult = ReturnType<typeof useVersionsSuspenseQuery>;
export type VersionsQueryResult = Apollo.QueryResult<VersionsQuery, VersionsQueryVariables>;
export const EventsDocument = gql`
    query events($workspaceId: UxId!, $objectType: ObjectKind, $objectId: UxId, $eventType: EventKind, $completionStatus: EventCompletionStatus, $onlyOpen: Boolean = false) {
  events(
    workspaceId: $workspaceId
    objectType: $objectType
    objectId: $objectId
    eventType: $eventType
    completionStatus: $completionStatus
    onlyOpen: $onlyOpen
  ) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      objectType: // value for 'objectType'
 *      objectId: // value for 'objectId'
 *      eventType: // value for 'eventType'
 *      completionStatus: // value for 'completionStatus'
 *      onlyOpen: // value for 'onlyOpen'
 *   },
 * });
 */
export function useEventsQuery(baseOptions: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables> & ({ variables: EventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export function useEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsSuspenseQueryHookResult = ReturnType<typeof useEventsSuspenseQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export const EventDocument = gql`
    query event($id: UxId!) {
  event(id: $id) {
    ...EventFields
  }
}
    ${EventFieldsFragmentDoc}`;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventQuery(baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables> & ({ variables: EventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventQuery, EventQueryVariables>(EventDocument, options);
      }
export function useEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
export function useEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventSuspenseQueryHookResult = ReturnType<typeof useEventSuspenseQuery>;
export type EventQueryResult = Apollo.QueryResult<EventQuery, EventQueryVariables>;
export const ComparisonAssessmentDocument = gql`
    query comparisonAssessment($assessmentAId: UxId!, $assessmentBId: UxId!, $versionAId: UxId, $versionBId: UxId) {
  assessmentA: assessment(id: $assessmentAId, versionId: $versionAId) {
    ...ComparisonAssessmentData
  }
  assessmentB: assessment(id: $assessmentBId, versionId: $versionBId) {
    ...ComparisonAssessmentData
  }
}
    ${ComparisonAssessmentDataFragmentDoc}`;

/**
 * __useComparisonAssessmentQuery__
 *
 * To run a query within a React component, call `useComparisonAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useComparisonAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComparisonAssessmentQuery({
 *   variables: {
 *      assessmentAId: // value for 'assessmentAId'
 *      assessmentBId: // value for 'assessmentBId'
 *      versionAId: // value for 'versionAId'
 *      versionBId: // value for 'versionBId'
 *   },
 * });
 */
export function useComparisonAssessmentQuery(baseOptions: Apollo.QueryHookOptions<ComparisonAssessmentQuery, ComparisonAssessmentQueryVariables> & ({ variables: ComparisonAssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComparisonAssessmentQuery, ComparisonAssessmentQueryVariables>(ComparisonAssessmentDocument, options);
      }
export function useComparisonAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComparisonAssessmentQuery, ComparisonAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComparisonAssessmentQuery, ComparisonAssessmentQueryVariables>(ComparisonAssessmentDocument, options);
        }
export function useComparisonAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComparisonAssessmentQuery, ComparisonAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComparisonAssessmentQuery, ComparisonAssessmentQueryVariables>(ComparisonAssessmentDocument, options);
        }
export type ComparisonAssessmentQueryHookResult = ReturnType<typeof useComparisonAssessmentQuery>;
export type ComparisonAssessmentLazyQueryHookResult = ReturnType<typeof useComparisonAssessmentLazyQuery>;
export type ComparisonAssessmentSuspenseQueryHookResult = ReturnType<typeof useComparisonAssessmentSuspenseQuery>;
export type ComparisonAssessmentQueryResult = Apollo.QueryResult<ComparisonAssessmentQuery, ComparisonAssessmentQueryVariables>;
export const CompareScenariosDocument = gql`
    query compareScenarios($scenarioAId: UxId!, $scenarioBId: UxId!, $versionAId: UxId, $versionBId: UxId) {
  scenarioA: scenario(id: $scenarioAId, versionId: $versionAId) {
    ...ComparisonScenarioData
  }
  scenarioB: scenario(id: $scenarioBId, versionId: $versionBId) {
    ...ComparisonScenarioData
  }
}
    ${ComparisonScenarioDataFragmentDoc}`;

/**
 * __useCompareScenariosQuery__
 *
 * To run a query within a React component, call `useCompareScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompareScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompareScenariosQuery({
 *   variables: {
 *      scenarioAId: // value for 'scenarioAId'
 *      scenarioBId: // value for 'scenarioBId'
 *      versionAId: // value for 'versionAId'
 *      versionBId: // value for 'versionBId'
 *   },
 * });
 */
export function useCompareScenariosQuery(baseOptions: Apollo.QueryHookOptions<CompareScenariosQuery, CompareScenariosQueryVariables> & ({ variables: CompareScenariosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompareScenariosQuery, CompareScenariosQueryVariables>(CompareScenariosDocument, options);
      }
export function useCompareScenariosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompareScenariosQuery, CompareScenariosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompareScenariosQuery, CompareScenariosQueryVariables>(CompareScenariosDocument, options);
        }
export function useCompareScenariosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompareScenariosQuery, CompareScenariosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompareScenariosQuery, CompareScenariosQueryVariables>(CompareScenariosDocument, options);
        }
export type CompareScenariosQueryHookResult = ReturnType<typeof useCompareScenariosQuery>;
export type CompareScenariosLazyQueryHookResult = ReturnType<typeof useCompareScenariosLazyQuery>;
export type CompareScenariosSuspenseQueryHookResult = ReturnType<typeof useCompareScenariosSuspenseQuery>;
export type CompareScenariosQueryResult = Apollo.QueryResult<CompareScenariosQuery, CompareScenariosQueryVariables>;
export const ScenarioControlsDocument = gql`
    query scenarioControls($id: UxId!, $versionId: UxId) {
  scenario(id: $id, versionId: $versionId) {
    id
    name
    baseRisk {
      upper
      lower
      frequencyTimes
      frequencyYears
    }
    riskManagementPlans {
      id
      startingFrequency
      startingLower
      startingUpper
      order
      control {
        id
        name
        shortname
        description
        strategy
        status
        origin
        annualCost
        vendor
        linkUrl
        linkText
        expectedActiveDate
        actualActiveDate
        reviewDate
        existingMaturity
        targetMaturity
        owner {
          id
          text
          email
          memberId
          inviteId
          profilePhotoPath
        }
        frameworkControls {
          id
          name
          shortname
          control_identifier
          strategy
          controlFramework {
            id
            name
            shortname
          }
        }
        meta {
          createdAt
          updatedAt
        }
      }
      modifiers {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useScenarioControlsQuery__
 *
 * To run a query within a React component, call `useScenarioControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioControlsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useScenarioControlsQuery(baseOptions: Apollo.QueryHookOptions<ScenarioControlsQuery, ScenarioControlsQueryVariables> & ({ variables: ScenarioControlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioControlsQuery, ScenarioControlsQueryVariables>(ScenarioControlsDocument, options);
      }
export function useScenarioControlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioControlsQuery, ScenarioControlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioControlsQuery, ScenarioControlsQueryVariables>(ScenarioControlsDocument, options);
        }
export function useScenarioControlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioControlsQuery, ScenarioControlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioControlsQuery, ScenarioControlsQueryVariables>(ScenarioControlsDocument, options);
        }
export type ScenarioControlsQueryHookResult = ReturnType<typeof useScenarioControlsQuery>;
export type ScenarioControlsLazyQueryHookResult = ReturnType<typeof useScenarioControlsLazyQuery>;
export type ScenarioControlsSuspenseQueryHookResult = ReturnType<typeof useScenarioControlsSuspenseQuery>;
export type ScenarioControlsQueryResult = Apollo.QueryResult<ScenarioControlsQuery, ScenarioControlsQueryVariables>;
export const FiltersForDocument = gql`
    query filtersFor($workspaceId: UxId!, $object: FilterObjectKey!, $includeCounts: Boolean = false) {
  filtersFor(
    workspaceId: $workspaceId
    object: $object
    includeCounts: $includeCounts
  ) {
    controls {
      strategy {
        unifiedKey
        label
        enabled
      }
      status {
        unifiedKey
        label
        enabled
      }
      owners {
        unifiedKey
        label
        enabled
        email
      }
      frameworks {
        unifiedKey
        label
        enabled
      }
      assessments {
        unifiedKey
        label
        enabled
      }
      existingMaturity {
        unifiedKey
        label
        enabled
      }
      targetMaturity {
        unifiedKey
        label
        enabled
      }
    }
  }
}
    `;

/**
 * __useFiltersForQuery__
 *
 * To run a query within a React component, call `useFiltersForQuery` and pass it any options that fit your needs.
 * When your component renders, `useFiltersForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFiltersForQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      object: // value for 'object'
 *      includeCounts: // value for 'includeCounts'
 *   },
 * });
 */
export function useFiltersForQuery(baseOptions: Apollo.QueryHookOptions<FiltersForQuery, FiltersForQueryVariables> & ({ variables: FiltersForQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FiltersForQuery, FiltersForQueryVariables>(FiltersForDocument, options);
      }
export function useFiltersForLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FiltersForQuery, FiltersForQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FiltersForQuery, FiltersForQueryVariables>(FiltersForDocument, options);
        }
export function useFiltersForSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FiltersForQuery, FiltersForQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FiltersForQuery, FiltersForQueryVariables>(FiltersForDocument, options);
        }
export type FiltersForQueryHookResult = ReturnType<typeof useFiltersForQuery>;
export type FiltersForLazyQueryHookResult = ReturnType<typeof useFiltersForLazyQuery>;
export type FiltersForSuspenseQueryHookResult = ReturnType<typeof useFiltersForSuspenseQuery>;
export type FiltersForQueryResult = Apollo.QueryResult<FiltersForQuery, FiltersForQueryVariables>;
export const ComplianceFrameworkGaugeDocument = gql`
    query complianceFrameworkGauge($id: UxId!, $workspaceId: UxId!) {
  complianceFrameworks(id: $id, workspaceId: $workspaceId) {
    controlsCount
    controlsImplementedCount
    controlsPlannedCount
  }
}
    `;

/**
 * __useComplianceFrameworkGaugeQuery__
 *
 * To run a query within a React component, call `useComplianceFrameworkGaugeQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceFrameworkGaugeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceFrameworkGaugeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useComplianceFrameworkGaugeQuery(baseOptions: Apollo.QueryHookOptions<ComplianceFrameworkGaugeQuery, ComplianceFrameworkGaugeQueryVariables> & ({ variables: ComplianceFrameworkGaugeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceFrameworkGaugeQuery, ComplianceFrameworkGaugeQueryVariables>(ComplianceFrameworkGaugeDocument, options);
      }
export function useComplianceFrameworkGaugeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceFrameworkGaugeQuery, ComplianceFrameworkGaugeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceFrameworkGaugeQuery, ComplianceFrameworkGaugeQueryVariables>(ComplianceFrameworkGaugeDocument, options);
        }
export function useComplianceFrameworkGaugeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceFrameworkGaugeQuery, ComplianceFrameworkGaugeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceFrameworkGaugeQuery, ComplianceFrameworkGaugeQueryVariables>(ComplianceFrameworkGaugeDocument, options);
        }
export type ComplianceFrameworkGaugeQueryHookResult = ReturnType<typeof useComplianceFrameworkGaugeQuery>;
export type ComplianceFrameworkGaugeLazyQueryHookResult = ReturnType<typeof useComplianceFrameworkGaugeLazyQuery>;
export type ComplianceFrameworkGaugeSuspenseQueryHookResult = ReturnType<typeof useComplianceFrameworkGaugeSuspenseQuery>;
export type ComplianceFrameworkGaugeQueryResult = Apollo.QueryResult<ComplianceFrameworkGaugeQuery, ComplianceFrameworkGaugeQueryVariables>;
export const ComplianceFrameworkDocument = gql`
    query complianceFramework($id: UxId!, $workspaceId: UxId!) {
  complianceFrameworks(id: $id, workspaceId: $workspaceId) {
    controlsCount
    controlsImplementedCount
    controlsPlannedCount
    controlFramework {
      id
      shortname
      name
      description
      author
      framework_identifier
      featureKey
      version
      versionNumber
      isCurrentVersion
      versionCreatedBy
      publishDate
      meta {
        createdAt
        updatedAt
      }
      versions {
        id
        name
        shortname
        controlCount
        versionNumber
        isCurrentVersion
        versionCreatedBy
        frameworkControls {
          id
        }
        meta {
          createdAt
          updatedAt
        }
      }
    }
    complianceControls {
      complianceStatus
      frameworkControl {
        id
        control_identifier
        name
        shortname
        strategy
        description
        meta {
          createdAt
          updatedAt
        }
        controlFramework {
          shortname
          author
        }
      }
      compliantRmpControls {
        id
        name
        strategy
        status
        owner {
          id
          text
        }
        frameworkControls {
          controlFramework {
            id
            shortname
          }
        }
      }
    }
  }
}
    `;

/**
 * __useComplianceFrameworkQuery__
 *
 * To run a query within a React component, call `useComplianceFrameworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceFrameworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceFrameworkQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useComplianceFrameworkQuery(baseOptions: Apollo.QueryHookOptions<ComplianceFrameworkQuery, ComplianceFrameworkQueryVariables> & ({ variables: ComplianceFrameworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceFrameworkQuery, ComplianceFrameworkQueryVariables>(ComplianceFrameworkDocument, options);
      }
export function useComplianceFrameworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceFrameworkQuery, ComplianceFrameworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceFrameworkQuery, ComplianceFrameworkQueryVariables>(ComplianceFrameworkDocument, options);
        }
export function useComplianceFrameworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceFrameworkQuery, ComplianceFrameworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceFrameworkQuery, ComplianceFrameworkQueryVariables>(ComplianceFrameworkDocument, options);
        }
export type ComplianceFrameworkQueryHookResult = ReturnType<typeof useComplianceFrameworkQuery>;
export type ComplianceFrameworkLazyQueryHookResult = ReturnType<typeof useComplianceFrameworkLazyQuery>;
export type ComplianceFrameworkSuspenseQueryHookResult = ReturnType<typeof useComplianceFrameworkSuspenseQuery>;
export type ComplianceFrameworkQueryResult = Apollo.QueryResult<ComplianceFrameworkQuery, ComplianceFrameworkQueryVariables>;
export const MyExportJobsDocument = gql`
    query myExportJobs {
  myExportJobs {
    id
    reportType
    reportParams
    status
    access
    progress
    createdAt
    expiresAt
    completedAt
    failedAt
    canceledAt
    errorMessage
    requestedBy {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useMyExportJobsQuery__
 *
 * To run a query within a React component, call `useMyExportJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyExportJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyExportJobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyExportJobsQuery(baseOptions?: Apollo.QueryHookOptions<MyExportJobsQuery, MyExportJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyExportJobsQuery, MyExportJobsQueryVariables>(MyExportJobsDocument, options);
      }
export function useMyExportJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyExportJobsQuery, MyExportJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyExportJobsQuery, MyExportJobsQueryVariables>(MyExportJobsDocument, options);
        }
export function useMyExportJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyExportJobsQuery, MyExportJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyExportJobsQuery, MyExportJobsQueryVariables>(MyExportJobsDocument, options);
        }
export type MyExportJobsQueryHookResult = ReturnType<typeof useMyExportJobsQuery>;
export type MyExportJobsLazyQueryHookResult = ReturnType<typeof useMyExportJobsLazyQuery>;
export type MyExportJobsSuspenseQueryHookResult = ReturnType<typeof useMyExportJobsSuspenseQuery>;
export type MyExportJobsQueryResult = Apollo.QueryResult<MyExportJobsQuery, MyExportJobsQueryVariables>;
export const ProfileDocument = gql`
    query profile {
  profile {
    userFlowSignature
    user {
      id
      name
      email
      profilePhotoPath
      receiveNotifications
      orgUnitIdentity {
        baseRole
        name
      }
      invites {
        id
        userEmail
        invitedDate
        workspaceName
        workspaceId
        organisationName
        organisationId
        orgUnitType
      }
      requests {
        id
        workspaceName
        workspaceId
        organisationName
        organisationId
        userEmail
        requestedDate
        orgUnitType
      }
    }
    activeWorkspace {
      id
      name
      currency
      owners {
        id
        text
        email
        inviteId
        memberId
        profilePhotoPath
      }
      actionsOnThisWorkspace {
        canAccess
        canSeeSettings
        canInviteUsers
        canSeeAuditLogs
      }
    }
    activeOrganisation {
      id
      name
      logoUrl
      logoDataUrl
      primaryColor
      secondaryColor
      actionsOnThisOrganisation {
        canAccess
        canSeeSettings
      }
    }
    features {
      feature
      isActive
    }
    permissions {
      canCreateOrganisation
      canCreateWorkspace
      canCreateChild
      canEditUsers
      canManageUsers
      isPlatformAdmin
      isPartnerAdmin
    }
    terms {
      organisation_id
      organisation_name
      status
      can_defer
      defer_expires
      terms_id
      terms_url
    }
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export function useProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileSuspenseQueryHookResult = ReturnType<typeof useProfileSuspenseQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const ProfileSettingsOptionsDocument = gql`
    query profileSettingsOptions {
  profile {
    wsSettingsOptions {
      planType
      plan
    }
    orgSettingsOptions {
      organisationType
      businessType
    }
  }
}
    `;

/**
 * __useProfileSettingsOptionsQuery__
 *
 * To run a query within a React component, call `useProfileSettingsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileSettingsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileSettingsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileSettingsOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ProfileSettingsOptionsQuery, ProfileSettingsOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileSettingsOptionsQuery, ProfileSettingsOptionsQueryVariables>(ProfileSettingsOptionsDocument, options);
      }
export function useProfileSettingsOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileSettingsOptionsQuery, ProfileSettingsOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileSettingsOptionsQuery, ProfileSettingsOptionsQueryVariables>(ProfileSettingsOptionsDocument, options);
        }
export function useProfileSettingsOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileSettingsOptionsQuery, ProfileSettingsOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileSettingsOptionsQuery, ProfileSettingsOptionsQueryVariables>(ProfileSettingsOptionsDocument, options);
        }
export type ProfileSettingsOptionsQueryHookResult = ReturnType<typeof useProfileSettingsOptionsQuery>;
export type ProfileSettingsOptionsLazyQueryHookResult = ReturnType<typeof useProfileSettingsOptionsLazyQuery>;
export type ProfileSettingsOptionsSuspenseQueryHookResult = ReturnType<typeof useProfileSettingsOptionsSuspenseQuery>;
export type ProfileSettingsOptionsQueryResult = Apollo.QueryResult<ProfileSettingsOptionsQuery, ProfileSettingsOptionsQueryVariables>;
export const WorkspaceDocument = gql`
    query workspace($id: UxId) {
  workspace(id: $id) {
    id
    name
    recordType
    primaryContact
    currency
    isRestricted
    plan
    planType
    notificationScheduleTime
    reviewCadenceDays
    parent {
      id
      name
      domain
      isArchived
    }
    users {
      id
      name
      email
    }
    member {
      effectiveRole
    }
    isArchived
    actionsOnThisWorkspace {
      canEditSettings
      canDelete
      canArchive
      canUnarchive
    }
  }
}
    `;

/**
 * __useWorkspaceQuery__
 *
 * To run a query within a React component, call `useWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
      }
export function useWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
        }
export function useWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceQuery, WorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceQuery, WorkspaceQueryVariables>(WorkspaceDocument, options);
        }
export type WorkspaceQueryHookResult = ReturnType<typeof useWorkspaceQuery>;
export type WorkspaceLazyQueryHookResult = ReturnType<typeof useWorkspaceLazyQuery>;
export type WorkspaceSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSuspenseQuery>;
export type WorkspaceQueryResult = Apollo.QueryResult<WorkspaceQuery, WorkspaceQueryVariables>;
export const WorkspaceMembersDocument = gql`
    query workspaceMembers($id: UxId) {
  workspace(id: $id) {
    id
    users {
      id
      name
      email
      profilePhotoPath
      orgUnitIdentity {
        baseRole
        assumedRole
        name
      }
      workspaceUserActions {
        canGrantAccess
        canRevokeAccess
        canRemoveUser
        canGrantAdmin
        canRevokeAdmin
        canAcceptRequest
        canRejectRequest
        canRevokeInvite
        canEditProfile
      }
    }
    invites {
      id
      name
      email
      profilePhotoPath
      invite {
        id
        invitedDate
        invitedRole
      }
    }
    requests {
      id
      name
      email
      profilePhotoPath
      request {
        id
        requestedDate
      }
    }
    actionsOnThisWorkspace {
      canSeeMembers
      canInviteUsers
      canSeeInvites
      canSeeRequests
    }
  }
}
    `;

/**
 * __useWorkspaceMembersQuery__
 *
 * To run a query within a React component, call `useWorkspaceMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceMembersQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceMembersQuery, WorkspaceMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceMembersQuery, WorkspaceMembersQueryVariables>(WorkspaceMembersDocument, options);
      }
export function useWorkspaceMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceMembersQuery, WorkspaceMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceMembersQuery, WorkspaceMembersQueryVariables>(WorkspaceMembersDocument, options);
        }
export function useWorkspaceMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceMembersQuery, WorkspaceMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceMembersQuery, WorkspaceMembersQueryVariables>(WorkspaceMembersDocument, options);
        }
export type WorkspaceMembersQueryHookResult = ReturnType<typeof useWorkspaceMembersQuery>;
export type WorkspaceMembersLazyQueryHookResult = ReturnType<typeof useWorkspaceMembersLazyQuery>;
export type WorkspaceMembersSuspenseQueryHookResult = ReturnType<typeof useWorkspaceMembersSuspenseQuery>;
export type WorkspaceMembersQueryResult = Apollo.QueryResult<WorkspaceMembersQuery, WorkspaceMembersQueryVariables>;
export const WorkspaceVariablesDocument = gql`
    query workspaceVariables($id: UxId) {
  workspace(id: $id) {
    id
    variables {
      id
      name
      value
      isInUse
      currency
      isGlobal
      alias
      workspaceVariable
    }
  }
}
    `;

/**
 * __useWorkspaceVariablesQuery__
 *
 * To run a query within a React component, call `useWorkspaceVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceVariablesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceVariablesQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceVariablesQuery, WorkspaceVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceVariablesQuery, WorkspaceVariablesQueryVariables>(WorkspaceVariablesDocument, options);
      }
export function useWorkspaceVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceVariablesQuery, WorkspaceVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceVariablesQuery, WorkspaceVariablesQueryVariables>(WorkspaceVariablesDocument, options);
        }
export function useWorkspaceVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceVariablesQuery, WorkspaceVariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceVariablesQuery, WorkspaceVariablesQueryVariables>(WorkspaceVariablesDocument, options);
        }
export type WorkspaceVariablesQueryHookResult = ReturnType<typeof useWorkspaceVariablesQuery>;
export type WorkspaceVariablesLazyQueryHookResult = ReturnType<typeof useWorkspaceVariablesLazyQuery>;
export type WorkspaceVariablesSuspenseQueryHookResult = ReturnType<typeof useWorkspaceVariablesSuspenseQuery>;
export type WorkspaceVariablesQueryResult = Apollo.QueryResult<WorkspaceVariablesQuery, WorkspaceVariablesQueryVariables>;
export const WizardDocument = gql`
    query wizard {
  profile {
    activeWorkspace {
      questions {
        scenarios {
          B2B
          B2C
          publiclyAccessibleInternetBusiness
          paymentVolumeOrValue
          significantITContributionToRevenue
          significantDataInCloud
          softwareBusiness
          cniOrDefenseInvolvement
          significantRandD
          regulated
          operationalTechnology
          supplyChainReliant
          aiThirdPartyReliant
          aiCustomerFacingApp
        }
        assessment {
          name
          description
          review_date
          started_date
        }
        regulations {
          legislation
          controlFrameworks
          controlFrameworksOther
          primaryControlFramework
          primaryFrameworkControls
          pinnedControlFrameworks
        }
        softwareDev {
          developsSoftware
        }
        organisation {
          sector
          usesManagedServiceProvider
        }
        cyberInsurance {
          cyberInsurance
        }
      }
    }
  }
}
    `;

/**
 * __useWizardQuery__
 *
 * To run a query within a React component, call `useWizardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWizardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardQuery({
 *   variables: {
 *   },
 * });
 */
export function useWizardQuery(baseOptions?: Apollo.QueryHookOptions<WizardQuery, WizardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WizardQuery, WizardQueryVariables>(WizardDocument, options);
      }
export function useWizardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WizardQuery, WizardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WizardQuery, WizardQueryVariables>(WizardDocument, options);
        }
export function useWizardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WizardQuery, WizardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WizardQuery, WizardQueryVariables>(WizardDocument, options);
        }
export type WizardQueryHookResult = ReturnType<typeof useWizardQuery>;
export type WizardLazyQueryHookResult = ReturnType<typeof useWizardLazyQuery>;
export type WizardSuspenseQueryHookResult = ReturnType<typeof useWizardSuspenseQuery>;
export type WizardQueryResult = Apollo.QueryResult<WizardQuery, WizardQueryVariables>;
export const OrganisationDocument = gql`
    query organisation($id: UxId) {
  organisation(id: $id) {
    id
    name
    logoUrl
    logoDataUrl
    primaryColor
    secondaryColor
    domain
    parentId
    primaryContact
    billingContact
    organisationType
    businessType
    actionsOnThisOrganisation {
      canEditSettings
      canInviteUsers
      canSeeInvites
      canSeeRequests
      canArchive
      canSeeParent
      canEditParent
      canEditOrganisationType
    }
    isArchived
    member {
      effectiveRole
    }
  }
}
    `;

/**
 * __useOrganisationQuery__
 *
 * To run a query within a React component, call `useOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
      }
export function useOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
        }
export function useOrganisationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
        }
export type OrganisationQueryHookResult = ReturnType<typeof useOrganisationQuery>;
export type OrganisationLazyQueryHookResult = ReturnType<typeof useOrganisationLazyQuery>;
export type OrganisationSuspenseQueryHookResult = ReturnType<typeof useOrganisationSuspenseQuery>;
export type OrganisationQueryResult = Apollo.QueryResult<OrganisationQuery, OrganisationQueryVariables>;
export const OrganisationMembersDocument = gql`
    query organisationMembers($id: UxId) {
  organisation(id: $id) {
    id
    users {
      id
      name
      email
      profilePhotoPath
      orgUnitIdentity {
        baseRole
        assumedRole
        name
      }
      organisationUserActions {
        canGrantAccess
        canRevokeAccess
        canRemoveUser
        canGrantAdmin
        canRevokeAdmin
        canEditProfile
      }
    }
    requests {
      id
      name
      email
      profilePhotoPath
      request {
        id
        requestedDate
      }
    }
    invites {
      id
      name
      email
      profilePhotoPath
      invite {
        id
        invitedDate
        invitedRole
      }
    }
    actionsOnThisOrganisation {
      canEditSettings
      canInviteUsers
      canSeeInvites
      canSeeRequests
      canArchive
      canSeeParent
      canEditParent
      canEditOrganisationType
    }
  }
}
    `;

/**
 * __useOrganisationMembersQuery__
 *
 * To run a query within a React component, call `useOrganisationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationMembersQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationMembersQuery, OrganisationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationMembersQuery, OrganisationMembersQueryVariables>(OrganisationMembersDocument, options);
      }
export function useOrganisationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationMembersQuery, OrganisationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationMembersQuery, OrganisationMembersQueryVariables>(OrganisationMembersDocument, options);
        }
export function useOrganisationMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationMembersQuery, OrganisationMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationMembersQuery, OrganisationMembersQueryVariables>(OrganisationMembersDocument, options);
        }
export type OrganisationMembersQueryHookResult = ReturnType<typeof useOrganisationMembersQuery>;
export type OrganisationMembersLazyQueryHookResult = ReturnType<typeof useOrganisationMembersLazyQuery>;
export type OrganisationMembersSuspenseQueryHookResult = ReturnType<typeof useOrganisationMembersSuspenseQuery>;
export type OrganisationMembersQueryResult = Apollo.QueryResult<OrganisationMembersQuery, OrganisationMembersQueryVariables>;
export const FlatOrganisationsHomeDocument = gql`
    query flatOrganisationsHome($memberEmail: String, $includeArchived: Boolean) {
  flatOrganisations(memberEmail: $memberEmail, includeArchived: $includeArchived) {
    id
    name
    domain
    parentId
    childIds
    primaryContact
    recordType
    isArchived
    plan
    organisationType
    businessType
    planType
    isRestricted
    actionsOnThisOrgUnit {
      canAccess
      canRequest
      canSeeSettings
      canArchive
      canUnarchive
      canDelete
      canInviteUsers
    }
    member {
      access
    }
  }
}
    `;

/**
 * __useFlatOrganisationsHomeQuery__
 *
 * To run a query within a React component, call `useFlatOrganisationsHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatOrganisationsHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatOrganisationsHomeQuery({
 *   variables: {
 *      memberEmail: // value for 'memberEmail'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useFlatOrganisationsHomeQuery(baseOptions?: Apollo.QueryHookOptions<FlatOrganisationsHomeQuery, FlatOrganisationsHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatOrganisationsHomeQuery, FlatOrganisationsHomeQueryVariables>(FlatOrganisationsHomeDocument, options);
      }
export function useFlatOrganisationsHomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatOrganisationsHomeQuery, FlatOrganisationsHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatOrganisationsHomeQuery, FlatOrganisationsHomeQueryVariables>(FlatOrganisationsHomeDocument, options);
        }
export function useFlatOrganisationsHomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlatOrganisationsHomeQuery, FlatOrganisationsHomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlatOrganisationsHomeQuery, FlatOrganisationsHomeQueryVariables>(FlatOrganisationsHomeDocument, options);
        }
export type FlatOrganisationsHomeQueryHookResult = ReturnType<typeof useFlatOrganisationsHomeQuery>;
export type FlatOrganisationsHomeLazyQueryHookResult = ReturnType<typeof useFlatOrganisationsHomeLazyQuery>;
export type FlatOrganisationsHomeSuspenseQueryHookResult = ReturnType<typeof useFlatOrganisationsHomeSuspenseQuery>;
export type FlatOrganisationsHomeQueryResult = Apollo.QueryResult<FlatOrganisationsHomeQuery, FlatOrganisationsHomeQueryVariables>;
export const FlatOrganisationsUserDocument = gql`
    query flatOrganisationsUser($memberEmail: String) {
  flatOrganisations(memberEmail: $memberEmail, includeArchived: false) {
    id
    name
    parentId
    recordType
    isArchived
    actionsOnThisOrgUnit {
      canSeeSettings
      canRequest
      canInviteUsers
    }
    member {
      access
      effectiveRole
      association {
        userName
        userEmail
        role
        requestedDate
        acceptedDate
        notifications
      }
      memberActions {
        canEditProfile
        canMakeAdmin
        canMakePartnerAdmin
        canRequestAccess
        canCancelRequest
      }
      user {
        profilePhotoPath
        name
        email
      }
    }
  }
}
    `;

/**
 * __useFlatOrganisationsUserQuery__
 *
 * To run a query within a React component, call `useFlatOrganisationsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatOrganisationsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatOrganisationsUserQuery({
 *   variables: {
 *      memberEmail: // value for 'memberEmail'
 *   },
 * });
 */
export function useFlatOrganisationsUserQuery(baseOptions?: Apollo.QueryHookOptions<FlatOrganisationsUserQuery, FlatOrganisationsUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatOrganisationsUserQuery, FlatOrganisationsUserQueryVariables>(FlatOrganisationsUserDocument, options);
      }
export function useFlatOrganisationsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatOrganisationsUserQuery, FlatOrganisationsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatOrganisationsUserQuery, FlatOrganisationsUserQueryVariables>(FlatOrganisationsUserDocument, options);
        }
export function useFlatOrganisationsUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlatOrganisationsUserQuery, FlatOrganisationsUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlatOrganisationsUserQuery, FlatOrganisationsUserQueryVariables>(FlatOrganisationsUserDocument, options);
        }
export type FlatOrganisationsUserQueryHookResult = ReturnType<typeof useFlatOrganisationsUserQuery>;
export type FlatOrganisationsUserLazyQueryHookResult = ReturnType<typeof useFlatOrganisationsUserLazyQuery>;
export type FlatOrganisationsUserSuspenseQueryHookResult = ReturnType<typeof useFlatOrganisationsUserSuspenseQuery>;
export type FlatOrganisationsUserQueryResult = Apollo.QueryResult<FlatOrganisationsUserQuery, FlatOrganisationsUserQueryVariables>;
export const MemberDocument = gql`
    query member($orgUnitId: UxId!, $memberEmail: UxId!) {
  member(orgUnitId: $orgUnitId, memberEmail: $memberEmail) {
    access
    effectiveRole
    association {
      userName
      userEmail
      role
      requestedDate
      acceptedDate
      notifications
    }
    memberActions {
      canEditProfile
      canMakeAdmin
      canMakePartnerAdmin
      canRequestAccess
      canCancelRequest
    }
    user {
      id
      name
      email
      profilePhotoPath
    }
  }
}
    `;

/**
 * __useMemberQuery__
 *
 * To run a query within a React component, call `useMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberQuery({
 *   variables: {
 *      orgUnitId: // value for 'orgUnitId'
 *      memberEmail: // value for 'memberEmail'
 *   },
 * });
 */
export function useMemberQuery(baseOptions: Apollo.QueryHookOptions<MemberQuery, MemberQueryVariables> & ({ variables: MemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberQuery, MemberQueryVariables>(MemberDocument, options);
      }
export function useMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberQuery, MemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberQuery, MemberQueryVariables>(MemberDocument, options);
        }
export function useMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberQuery, MemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberQuery, MemberQueryVariables>(MemberDocument, options);
        }
export type MemberQueryHookResult = ReturnType<typeof useMemberQuery>;
export type MemberLazyQueryHookResult = ReturnType<typeof useMemberLazyQuery>;
export type MemberSuspenseQueryHookResult = ReturnType<typeof useMemberSuspenseQuery>;
export type MemberQueryResult = Apollo.QueryResult<MemberQuery, MemberQueryVariables>;
export const OrganisationAccessCheckDocument = gql`
    query organisationAccessCheck($id: UxId) {
  organisation(id: $id) {
    id
    isArchived
    actionsOnThisOrganisation {
      canSeeSettings
    }
  }
}
    `;

/**
 * __useOrganisationAccessCheckQuery__
 *
 * To run a query within a React component, call `useOrganisationAccessCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationAccessCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationAccessCheckQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationAccessCheckQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationAccessCheckQuery, OrganisationAccessCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationAccessCheckQuery, OrganisationAccessCheckQueryVariables>(OrganisationAccessCheckDocument, options);
      }
export function useOrganisationAccessCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationAccessCheckQuery, OrganisationAccessCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationAccessCheckQuery, OrganisationAccessCheckQueryVariables>(OrganisationAccessCheckDocument, options);
        }
export function useOrganisationAccessCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationAccessCheckQuery, OrganisationAccessCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationAccessCheckQuery, OrganisationAccessCheckQueryVariables>(OrganisationAccessCheckDocument, options);
        }
export type OrganisationAccessCheckQueryHookResult = ReturnType<typeof useOrganisationAccessCheckQuery>;
export type OrganisationAccessCheckLazyQueryHookResult = ReturnType<typeof useOrganisationAccessCheckLazyQuery>;
export type OrganisationAccessCheckSuspenseQueryHookResult = ReturnType<typeof useOrganisationAccessCheckSuspenseQuery>;
export type OrganisationAccessCheckQueryResult = Apollo.QueryResult<OrganisationAccessCheckQuery, OrganisationAccessCheckQueryVariables>;
export const WorkspaceAccessCheckDocument = gql`
    query workspaceAccessCheck($id: UxId) {
  workspace(id: $id) {
    id
    isArchived
    actionsOnThisWorkspace {
      canAccess
      canSeeSettings
      canSeeAuditLogs
    }
  }
}
    `;

/**
 * __useWorkspaceAccessCheckQuery__
 *
 * To run a query within a React component, call `useWorkspaceAccessCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceAccessCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceAccessCheckQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceAccessCheckQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceAccessCheckQuery, WorkspaceAccessCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceAccessCheckQuery, WorkspaceAccessCheckQueryVariables>(WorkspaceAccessCheckDocument, options);
      }
export function useWorkspaceAccessCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceAccessCheckQuery, WorkspaceAccessCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceAccessCheckQuery, WorkspaceAccessCheckQueryVariables>(WorkspaceAccessCheckDocument, options);
        }
export function useWorkspaceAccessCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceAccessCheckQuery, WorkspaceAccessCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceAccessCheckQuery, WorkspaceAccessCheckQueryVariables>(WorkspaceAccessCheckDocument, options);
        }
export type WorkspaceAccessCheckQueryHookResult = ReturnType<typeof useWorkspaceAccessCheckQuery>;
export type WorkspaceAccessCheckLazyQueryHookResult = ReturnType<typeof useWorkspaceAccessCheckLazyQuery>;
export type WorkspaceAccessCheckSuspenseQueryHookResult = ReturnType<typeof useWorkspaceAccessCheckSuspenseQuery>;
export type WorkspaceAccessCheckQueryResult = Apollo.QueryResult<WorkspaceAccessCheckQuery, WorkspaceAccessCheckQueryVariables>;
export const FlatOrganisationsNavDocument = gql`
    query flatOrganisationsNav($memberEmail: String, $includeArchived: Boolean) {
  flatOrganisations(memberEmail: $memberEmail, includeArchived: $includeArchived) {
    id
    name
    recordType
    parentId
    childIds
    isArchived
    organisationType
    businessType
  }
}
    `;

/**
 * __useFlatOrganisationsNavQuery__
 *
 * To run a query within a React component, call `useFlatOrganisationsNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatOrganisationsNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatOrganisationsNavQuery({
 *   variables: {
 *      memberEmail: // value for 'memberEmail'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useFlatOrganisationsNavQuery(baseOptions?: Apollo.QueryHookOptions<FlatOrganisationsNavQuery, FlatOrganisationsNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatOrganisationsNavQuery, FlatOrganisationsNavQueryVariables>(FlatOrganisationsNavDocument, options);
      }
export function useFlatOrganisationsNavLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatOrganisationsNavQuery, FlatOrganisationsNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatOrganisationsNavQuery, FlatOrganisationsNavQueryVariables>(FlatOrganisationsNavDocument, options);
        }
export function useFlatOrganisationsNavSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlatOrganisationsNavQuery, FlatOrganisationsNavQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlatOrganisationsNavQuery, FlatOrganisationsNavQueryVariables>(FlatOrganisationsNavDocument, options);
        }
export type FlatOrganisationsNavQueryHookResult = ReturnType<typeof useFlatOrganisationsNavQuery>;
export type FlatOrganisationsNavLazyQueryHookResult = ReturnType<typeof useFlatOrganisationsNavLazyQuery>;
export type FlatOrganisationsNavSuspenseQueryHookResult = ReturnType<typeof useFlatOrganisationsNavSuspenseQuery>;
export type FlatOrganisationsNavQueryResult = Apollo.QueryResult<FlatOrganisationsNavQuery, FlatOrganisationsNavQueryVariables>;
export const InviteRolesDocument = gql`
    query inviteRoles($workspaceId: UxId, $organisationId: UxId, $userEmail: String!) {
  inviteRoles(
    workspaceId: $workspaceId
    organisationId: $organisationId
    userEmail: $userEmail
  ) {
    roles
    isTrustedEmail
    isPartnerAdmin
  }
}
    `;

/**
 * __useInviteRolesQuery__
 *
 * To run a query within a React component, call `useInviteRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteRolesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      organisationId: // value for 'organisationId'
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useInviteRolesQuery(baseOptions: Apollo.QueryHookOptions<InviteRolesQuery, InviteRolesQueryVariables> & ({ variables: InviteRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteRolesQuery, InviteRolesQueryVariables>(InviteRolesDocument, options);
      }
export function useInviteRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteRolesQuery, InviteRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteRolesQuery, InviteRolesQueryVariables>(InviteRolesDocument, options);
        }
export function useInviteRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InviteRolesQuery, InviteRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteRolesQuery, InviteRolesQueryVariables>(InviteRolesDocument, options);
        }
export type InviteRolesQueryHookResult = ReturnType<typeof useInviteRolesQuery>;
export type InviteRolesLazyQueryHookResult = ReturnType<typeof useInviteRolesLazyQuery>;
export type InviteRolesSuspenseQueryHookResult = ReturnType<typeof useInviteRolesSuspenseQuery>;
export type InviteRolesQueryResult = Apollo.QueryResult<InviteRolesQuery, InviteRolesQueryVariables>;
export const ScenarioPdfDocument = gql`
    query scenarioPdf($id: UxId!, $versionId: UxId) {
  scenario(id: $id, versionId: $versionId) {
    id
    name
    managementNote
    managementStrategy
    source
    event
    consequence
    riskIdentifiedDate
    riskNarrative
    frequencyNote
    consequenceNote
    lowerFormula
    upperFormula
    isIncomplete
    status
    reviewDate
    editedAt
    actions {
      id
      notes
      dueDate
      completionStatus
      isOverdue
      assignedTo {
        text
        email
      }
    }
    assessment {
      id
      name
      reviewDate
      variables {
        id
        name
        value
        currency
        isGlobal
        alias
        workspaceVariable
      }
      workspace {
        variables {
          id
          name
          value
          currency
          isGlobal
          alias
          workspaceVariable
        }
      }
    }
    riskOwner {
      text
      email
    }
    baseRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      upper
      lower
      chart {
        x
        y
      }
    }
    projectedRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      lower
      upper
      chart {
        x
        y
      }
    }
    liveRisk {
      expectedLoss
      frequencyTimes
      frequencyYears
      lower
      upper
      chart {
        x
        y
      }
    }
    incidents {
      id
      name
      ref
      source
      incidentType
      dateOfIncident
      description
      financialImpactLower
      financialImpactUpper
      impact
      severity
      actions {
        id
        notes
        dueDate
        completionStatus
        isOverdue
        assignedTo {
          text
          email
        }
      }
      owner {
        text
        email
      }
      scenarios {
        id
        name
        source
        event
        consequence
        status
        riskOwner {
          text
          email
        }
        liveRisk {
          expectedLoss
        }
        assessment {
          id
          name
        }
      }
    }
    riskManagementPlans {
      id
      control {
        id
        name
        description
        status
        strategy
        annualCost
        vendor
        linkUrl
        linkText
        expectedActiveDate
        actualActiveDate
        reviewDate
        existingMaturity
        targetMaturity
        actions {
          id
          notes
          dueDate
          completionStatus
          isOverdue
          assignedTo {
            text
            email
          }
        }
        frameworkControls {
          id
          control_identifier
          controlFramework {
            id
            shortname
          }
        }
        owner {
          text
          email
        }
        meta {
          updatedAt
        }
      }
    }
    meta {
      updatedAt
    }
  }
}
    `;

/**
 * __useScenarioPdfQuery__
 *
 * To run a query within a React component, call `useScenarioPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useScenarioPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScenarioPdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useScenarioPdfQuery(baseOptions: Apollo.QueryHookOptions<ScenarioPdfQuery, ScenarioPdfQueryVariables> & ({ variables: ScenarioPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScenarioPdfQuery, ScenarioPdfQueryVariables>(ScenarioPdfDocument, options);
      }
export function useScenarioPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScenarioPdfQuery, ScenarioPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScenarioPdfQuery, ScenarioPdfQueryVariables>(ScenarioPdfDocument, options);
        }
export function useScenarioPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScenarioPdfQuery, ScenarioPdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScenarioPdfQuery, ScenarioPdfQueryVariables>(ScenarioPdfDocument, options);
        }
export type ScenarioPdfQueryHookResult = ReturnType<typeof useScenarioPdfQuery>;
export type ScenarioPdfLazyQueryHookResult = ReturnType<typeof useScenarioPdfLazyQuery>;
export type ScenarioPdfSuspenseQueryHookResult = ReturnType<typeof useScenarioPdfSuspenseQuery>;
export type ScenarioPdfQueryResult = Apollo.QueryResult<ScenarioPdfQuery, ScenarioPdfQueryVariables>;
export const AssessmentPdfDocument = gql`
    query assessmentPdf($id: UxId!, $versionId: UxId) {
  assessment(id: $id, versionId: $versionId) {
    id
    name
    description
    executiveSummary
    riskTolerance
    actions {
      id
      notes
      dueDate
      completionStatus
      isOverdue
      assignedTo {
        text
        email
      }
    }
    AssessmentBaseRisk {
      expectedLoss
      chart {
        x
        y
      }
    }
    AssessmentProjectedRisk {
      expectedLoss
      chart {
        x
        y
      }
    }
    AssessmentLiveRisk {
      expectedLoss
      chart {
        x
        y
      }
    }
    startedDate
    reviewDate
    editedAt
    meta {
      updatedAt
    }
    scenarios {
      id
      name
      source
      event
      consequence
      riskOwner {
        text
        email
      }
      riskIdentifiedDate
      reviewDate
      editedAt
      isIncomplete
      riskNarrative
      frequencyNote
      consequenceNote
      actions {
        id
        notes
        dueDate
        completionStatus
        isOverdue
        assignedTo {
          text
          email
        }
      }
      baseRisk {
        expectedLoss
        frequencyTimes
        frequencyYears
        lower
        upper
        chart {
          x
          y
        }
      }
      projectedRisk {
        expectedLoss
        frequencyTimes
        frequencyYears
        lower
        upper
        chart {
          x
          y
        }
      }
      liveRisk {
        expectedLoss
        frequencyTimes
        frequencyYears
        lower
        upper
        chart {
          x
          y
        }
      }
      managementStrategy
      managementNote
      assessment {
        id
        name
        reviewDate
      }
      riskManagementPlans {
        id
        control {
          id
          name
          description
          status
          strategy
          annualCost
          vendor
          linkUrl
          linkText
          expectedActiveDate
          actualActiveDate
          reviewDate
          existingMaturity
          targetMaturity
          actions {
            id
            notes
            dueDate
            completionStatus
            isOverdue
            assignedTo {
              text
              email
            }
          }
          frameworkControls {
            id
            control_identifier
            controlFramework {
              id
              shortname
            }
          }
          owner {
            text
            email
          }
          riskManagementPlans {
            modifiers {
              id
              type
              consequenceUpper
              consequenceLower
              frequencyReduction
              isPercentage
              totalPolicyCover
              excess
              note
            }
            scenario {
              id
            }
          }
          meta {
            updatedAt
          }
        }
      }
      incidents {
        id
        name
        ref
        source
        incidentType
        dateOfIncident
        description
        financialImpactLower
        financialImpactUpper
        impact
        severity
        actions {
          id
          notes
          dueDate
          completionStatus
          isOverdue
          assignedTo {
            text
            email
          }
        }
        owner {
          text
          email
        }
        scenarios {
          id
          name
          source
          event
          consequence
          status
          riskOwner {
            text
            email
          }
          liveRisk {
            expectedLoss
          }
          assessment {
            id
            name
          }
        }
      }
      status
      meta {
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useAssessmentPdfQuery__
 *
 * To run a query within a React component, call `useAssessmentPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentPdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useAssessmentPdfQuery(baseOptions: Apollo.QueryHookOptions<AssessmentPdfQuery, AssessmentPdfQueryVariables> & ({ variables: AssessmentPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentPdfQuery, AssessmentPdfQueryVariables>(AssessmentPdfDocument, options);
      }
export function useAssessmentPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentPdfQuery, AssessmentPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentPdfQuery, AssessmentPdfQueryVariables>(AssessmentPdfDocument, options);
        }
export function useAssessmentPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentPdfQuery, AssessmentPdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentPdfQuery, AssessmentPdfQueryVariables>(AssessmentPdfDocument, options);
        }
export type AssessmentPdfQueryHookResult = ReturnType<typeof useAssessmentPdfQuery>;
export type AssessmentPdfLazyQueryHookResult = ReturnType<typeof useAssessmentPdfLazyQuery>;
export type AssessmentPdfSuspenseQueryHookResult = ReturnType<typeof useAssessmentPdfSuspenseQuery>;
export type AssessmentPdfQueryResult = Apollo.QueryResult<AssessmentPdfQuery, AssessmentPdfQueryVariables>;
export const ControlsPdfDocument = gql`
    query controlsPdf($workspaceId: UxId) {
  controls(workspaceId: $workspaceId) {
    id
    name
    description
    owner {
      text
      email
    }
    actions {
      id
      notes
      dueDate
      completionStatus
      isOverdue
      assignedTo {
        text
        email
      }
    }
    annualCost
    vendor
    strategy
    status
    linkUrl
    linkText
    expectedActiveDate
    actualActiveDate
    reviewDate
    existingMaturity
    targetMaturity
    frameworkControls {
      id
      control_identifier
      controlFramework {
        id
        shortname
      }
    }
    riskManagementPlans {
      id
      modifiers {
        id
        type
        consequenceUpper
        consequenceLower
        frequencyReduction
        isPercentage
        totalPolicyCover
        excess
        note
      }
      scenario {
        id
        name
        source
        event
        consequence
        status
        riskOwner {
          text
          email
        }
        liveRisk {
          expectedLoss
        }
        assessment {
          id
          name
        }
      }
    }
    meta {
      updatedAt
    }
  }
}
    `;

/**
 * __useControlsPdfQuery__
 *
 * To run a query within a React component, call `useControlsPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useControlsPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useControlsPdfQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useControlsPdfQuery(baseOptions?: Apollo.QueryHookOptions<ControlsPdfQuery, ControlsPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ControlsPdfQuery, ControlsPdfQueryVariables>(ControlsPdfDocument, options);
      }
export function useControlsPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ControlsPdfQuery, ControlsPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ControlsPdfQuery, ControlsPdfQueryVariables>(ControlsPdfDocument, options);
        }
export function useControlsPdfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ControlsPdfQuery, ControlsPdfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ControlsPdfQuery, ControlsPdfQueryVariables>(ControlsPdfDocument, options);
        }
export type ControlsPdfQueryHookResult = ReturnType<typeof useControlsPdfQuery>;
export type ControlsPdfLazyQueryHookResult = ReturnType<typeof useControlsPdfLazyQuery>;
export type ControlsPdfSuspenseQueryHookResult = ReturnType<typeof useControlsPdfSuspenseQuery>;
export type ControlsPdfQueryResult = Apollo.QueryResult<ControlsPdfQuery, ControlsPdfQueryVariables>;